import { __values, __read, __assign, __awaiter, __generator, __extends, __spreadArray, __rest, __decorate, __metadata, __param } from 'tslib';
import { FileType, DialogOrientation, AddonErrorCode, BackEndErrorCode, AddonEnvironmentType, ActionName, FileTypeDes, DOC_CORE_OPERNAME, TOOL_FILE_TYPE, DOC_CORE_MODULE, DOC_CORE_ACTION, OCRType, IReqType, CODE_MESSAGE_MAPPING, MenuType, ResizeMode } from '@tencent/td-open-common-interfaces';
import { isCosImg, getFileTypeDes, getRandomString, getCookie, getXSRF, Exception, getEnvAddonId, isPrivateEnv, isConsumerEnv, addURLHashParam, isEnterpriseWecomEnv, isOriginalAddonId, addURLQueryParam } from '@tencent/td-open-common-utils';
import { v4 } from 'uuid';
import * as MultiTools from '@tencent/docs-multi-tools';
import Axios from 'axios';
import ua from '@tencent/docs-user-agent';
import { getMultUrl, tencentDocOpenUrlForAll, openNewBlankWindow } from '@tencent/tencent_doc_open_url';
import React, { Fragment } from 'react';
import { InjectorService, DrawerService, WidgetService, StateManager, withState, MainMenu, Menu, Param, ActionPointInfo, Toolbar, Controller, Inject, ControllerService, MenuService } from '@tencent/workbench';
import { PullPanel, Modal, HorizontalPanel, Checkbox, Divider, Button } from '@tencent/dui-mobile';
import ReactDOM from 'react-dom';
import DocsConfig from '@tencent/docs-config';
import { getAidForReport } from '@tencent/txdocs-aid';
import { Modal as Modal$1, Divider as Divider$1, Checkbox as Checkbox$1, Button as Button$1 } from '@tencent/dui';
import i18next from 'i18next';
import MiniApp from '@tencent/docs-miniapp-sdk';
import URLParse from 'url-parse';
import dayjs from 'dayjs';
import { AddonReportManager, ReportStatus } from '@tencent/td-open-report';

/*
 * @Author: fugao
 * @Date: 2021-06-14 20:52:40
 * @Last Modified by: fugao
 * @Last Modified time: 2021-07-06 17:15:03
 *
 * 文档生命周期Hook, 用于监听文档侧的一些生命周期
 */
// TODO: 后续扩展 - fugao
var DocHook = /** @class */ (function () {
    function DocHook() {
    }
    // 文档打开
    DocHook.prototype.onOpen = function () {
        console.log('文档打开');
    };
    return DocHook;
}());

/**
 * 插件窗口类型
 */
var AddonWindowType;
(function (AddonWindowType) {
    AddonWindowType[AddonWindowType["DIALOG"] = 1] = "DIALOG";
    AddonWindowType[AddonWindowType["SIDEBAR"] = 2] = "SIDEBAR";
})(AddonWindowType || (AddonWindowType = {}));
var DocElementType;
(function (DocElementType) {
    DocElementType[DocElementType["UNKNOWN"] = 0] = "UNKNOWN";
    DocElementType[DocElementType["TEXT"] = 1] = "TEXT";
    DocElementType[DocElementType["IMAGE"] = 2] = "IMAGE";
    DocElementType[DocElementType["WEB"] = 3] = "WEB";
    DocElementType[DocElementType["LINK"] = 4] = "LINK";
    DocElementType[DocElementType["AUDIO"] = 5] = "AUDIO";
    DocElementType[DocElementType["ADDON"] = 6] = "ADDON";
    DocElementType[DocElementType["HINA"] = 7] = "HINA";
})(DocElementType || (DocElementType = {}));
var MenuConfigurationType;
(function (MenuConfigurationType) {
    MenuConfigurationType[MenuConfigurationType["UNKNOWN"] = 0] = "UNKNOWN";
    MenuConfigurationType[MenuConfigurationType["ACTION"] = 1] = "ACTION";
    MenuConfigurationType[MenuConfigurationType["MENUS"] = 2] = "MENUS";
})(MenuConfigurationType || (MenuConfigurationType = {}));
/**
 * 打印模式
 */
var PrintMode;
(function (PrintMode) {
    /** 不支持打印 */
    PrintMode[PrintMode["NONE"] = 0] = "NONE";
    /** 自动获取封面打印(需要提供获取封面的接口) */
    PrintMode[PrintMode["AUTO"] = 1] = "AUTO";
})(PrintMode || (PrintMode = {}));
// 插件域名地址
var AddonWindowPathType;
(function (AddonWindowPathType) {
    // (C端)默认
    AddonWindowPathType["DEFAULT"] = "/open/addon/sandbox";
    // B端企微
    AddonWindowPathType["ENTERPRISE_WECOM"] = "/public/addon/sandbox";
})(AddonWindowPathType || (AddonWindowPathType = {}));
// 插件渠道类型
var AddonListChannel;
(function (AddonListChannel) {
    AddonListChannel[AddonListChannel["MOBILE"] = 1] = "MOBILE";
    AddonListChannel[AddonListChannel["PC"] = 3] = "PC";
})(AddonListChannel || (AddonListChannel = {}));
var AddonScenes;
(function (AddonScenes) {
    // 图片
    AddonScenes["IMAGE"] = "IMAGE";
    // 文本
    AddonScenes["TEXT"] = "TEXT";
    // 图表
    AddonScenes["CHART"] = "CHART";
    // 光标
    AddonScenes["CURSOR"] = "CURSOR";
    // 附件（视频/音频）
    AddonScenes["APPENDIX"] = "APPENDIX";
    // iframe 弹窗
    AddonScenes["IFRAME"] = "IFRAME";
})(AddonScenes || (AddonScenes = {}));
var MallTopic;
(function (MallTopic) {
    MallTopic["PC"] = "PC";
    MallTopic["MOBILE"] = "MOBILE";
})(MallTopic || (MallTopic = {}));

// 默认插入iframe的宽度和高度（单位：px）
var PROD_HOST_NAME = global.location.origin;
// web 插件代理 url
var WEB_ADDON_PROXY_URL = 'https://proxy.tencentsuite.com/openapi/proxy/v2/addon';
var VIPType;
(function (VIPType) {
    VIPType[VIPType["SVIP"] = 1] = "SVIP";
    VIPType[VIPType["VIP"] = 2] = "VIP";
})(VIPType || (VIPType = {}));
var SVIP = VIPType.SVIP;
// 文档需要的弹窗顶层高度
var MODAL_Z_INDEX = 12003;

// 检查对象身上是否有对应的属性
function checkPropertiesInObject(properties, object) {
    var e_1, _a;
    if (!object) {
        return false;
    }
    try {
        for (var properties_1 = __values(properties), properties_1_1 = properties_1.next(); !properties_1_1.done; properties_1_1 = properties_1.next()) {
            var property = properties_1_1.value;
            if (!Object.prototype.hasOwnProperty.call(object, property)) {
                return false;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (properties_1_1 && !properties_1_1.done && (_a = properties_1.return)) _a.call(properties_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
}

/**
 * 判断 doc element 的类型
 * @param docElement
 * @returns 类型
 */
function getDocElementType(docElement) {
    var e_1, _a;
    var typeGuardMap = new Map([
        [DocElementType.TEXT, isTextDocElement],
        [DocElementType.IMAGE, isImageAddonElement],
        [DocElementType.WEB, isWebAddonElement],
        [DocElementType.LINK, isLinkDocElement],
        [DocElementType.AUDIO, isAudioAddonElement],
        [DocElementType.HINA, isHinaAddonElement],
    ]);
    try {
        for (var typeGuardMap_1 = __values(typeGuardMap), typeGuardMap_1_1 = typeGuardMap_1.next(); !typeGuardMap_1_1.done; typeGuardMap_1_1 = typeGuardMap_1.next()) {
            var _b = __read(typeGuardMap_1_1.value, 2), key = _b[0], value = _b[1];
            if (value(docElement)) {
                return key;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (typeGuardMap_1_1 && !typeGuardMap_1_1.done && (_a = typeGuardMap_1.return)) _a.call(typeGuardMap_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return DocElementType.UNKNOWN;
}
function isAddonElement(docElement) {
    return checkPropertiesInObject(['anchorId', 'addonId'], docElement);
}
function isTextDocElement(docElement) {
    return checkPropertiesInObject(['text'], docElement);
}
function isImageAddonElement(docElement) {
    if (!isAddonElement(docElement)) {
        return false;
    }
    return checkPropertiesInObject(['src', 'sourceType'], docElement);
}
function isWebAddonElement(docElement) {
    if (!isAddonElement(docElement)) {
        return false;
    }
    return checkPropertiesInObject(['embedURL', 'originURL'], docElement);
}
function isAudioAddonElement(docElement) {
    if (!isAddonElement(docElement)) {
        return false;
    }
    return checkPropertiesInObject(['src', 'height'], docElement);
}
function isLinkDocElement(docElement) {
    if (!isAddonElement(docElement)) {
        return false;
    }
    return checkPropertiesInObject(['link'], docElement);
}
function isHinaAddonElement(docElement) {
    if (!isAddonElement(docElement)) {
        return false;
    }
    return checkPropertiesInObject(['url'], docElement);
}

var DocManager = /** @class */ (function () {
    function DocManager() {
        return DocManager;
    }
    DocManager.getDocData = function () {
        return this.docData;
    };
    /**
     * 设置文档托管数据
     *
     * @static
     * @param {DocData} docData 托管数据
     */
    DocManager.initDocData = function (docData) {
        this.docData = docData;
    };
    /**
     * 更新文档信息（目前只有doc使用，doc的文字链+icon未初始化就使用了addon的能力，因此提供此接口先传入文档信息）
     *
     * @static
     * @param {DocData} docData 托管数据
     */
    DocManager.updateMetaInfo = function (metaInfo) {
        if (this.docData) {
            this.docData.metaInfo = metaInfo;
            return;
        }
        this.docData = { metaInfo: metaInfo };
    };
    /**
     * 获取品类传入的插件菜单配置
     */
    DocManager.getMenuConfig = function () {
        return this.docData.menuConfig;
    };
    /**
     * 获取文档基本信息
     *
     * @return {*}  {FileMetaInfo} 文档基本信息
     */
    DocManager.getMetaInfo = function () {
        // metaInfo 默认值
        var defaultMetaInfo = { fileId: '', creatorId: '', uid: '' };
        return __assign(__assign({}, defaultMetaInfo), this.docData.metaInfo);
    };
    /**
     * 获取文档提供的service
     *
     * @return {*}  {DocService} 文档服务
     */
    DocManager.getService = function () {
        return this.docData.service;
    };
    /**
     * 如果editor为空，什么都不行
     */
    DocManager.getEditor = function () {
        var editor = this.docData.service.editor;
        return editor !== null && editor !== void 0 ? editor : null;
    };
    /**
     * 获取文档提供的插件hook对象
     *
     * @return {*}  {(AddonHook | undefined)} 插件hook对象
     */
    DocManager.getAddonHook = function () {
        return this.docData.addonHook;
    };
    /**
     * 设置 ocr 识别结果
     * @param res
     */
    DocManager.setOCRRes = function (res) {
        return __awaiter(this, void 0, void 0, function () {
            var imageElement;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getSelectedImageAddonElement()];
                    case 1:
                        imageElement = _b.sent();
                        if (imageElement) {
                            this.anchorIdWithOCRImageElement = imageElement.anchorId;
                            this.ocrRes = res;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 清除 ocr 识别结果
     */
    DocManager.clearOCRRes = function () {
        this.ocrRes = {};
        this.anchorIdWithOCRImageElement = undefined;
    };
    /**
     * 获取文档上下文，如果setup中没有传入docData.service.editor或docData.metaInfo，直接返回 undefined
     *
     * @return {*}  {DocContext} 文档上下文信息
     */
    DocManager.getDocContext = function () {
        var _b, _c, _d, _e;
        return __awaiter(this, void 0, void 0, function () {
            var _f, fileId, fileType, _g, editor, getLanguage, selectedElements, images, docContext, imageElement;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        _f = this.docData.metaInfo, fileId = _f.fileId, fileType = _f.fileType;
                        if (!this.docData.service) {
                            return [2 /*return*/, {
                                    fileId: fileId !== null && fileId !== void 0 ? fileId : '',
                                    fileType: fileType,
                                    userAgent: ua.userAgent,
                                    language: '',
                                }];
                        }
                        _g = this.docData.service, editor = _g.editor, getLanguage = _g.config.getLanguage;
                        return [4 /*yield*/, (editor === null || editor === void 0 ? void 0 : editor.getSelectedDocElements())];
                    case 1:
                        selectedElements = (_b = (_h.sent())) !== null && _b !== void 0 ? _b : [];
                        images = (_d = (_c = editor === null || editor === void 0 ? void 0 : editor.getContextImages) === null || _c === void 0 ? void 0 : _c.call(editor)) !== null && _d !== void 0 ? _d : [];
                        docContext = {
                            fileId: fileId !== null && fileId !== void 0 ? fileId : '',
                            fileType: fileType,
                            userAgent: ua.userAgent,
                            language: getLanguage(),
                            cursor: (_e = this.getCursor(fileType)) !== null && _e !== void 0 ? _e : '',
                            selectedElements: selectedElements,
                            activeRangeValues: this.getRangeValues(),
                            images: images.filter(function (image) { return isCosImg(image.src); }),
                        };
                        return [4 /*yield*/, this.getSelectedImageAddonElement()];
                    case 2:
                        imageElement = _h.sent();
                        // 保证有ocr识别结果的图片和当前选中图片是一张才会带上识别结果
                        if (imageElement && this.anchorIdWithOCRImageElement === imageElement.anchorId) {
                            docContext.ocrRes = JSON.stringify(this.ocrRes);
                        }
                        return [2 /*return*/, docContext];
                }
            });
        });
    };
    DocManager.getRangeValues = function () {
        var _b, _c;
        var _d = this.docData, editor = _d.service.editor, fileType = _d.metaInfo.fileType;
        if (fileType !== FileType.SHEET) {
            return;
        }
        var range = (_b = editor === null || editor === void 0 ? void 0 : editor.getActiveRange) === null || _b === void 0 ? void 0 : _b.call(editor);
        if (!range)
            return;
        return (_c = editor === null || editor === void 0 ? void 0 : editor.getRangeValues) === null || _c === void 0 ? void 0 : _c.call(editor, range);
    };
    DocManager.getCursor = function (fileType) {
        var _b;
        var _c;
        var editor = this.docData.service.editor;
        if (!editor) {
            return;
        }
        var resultMap = (_b = {},
            _b[FileType.DOC] = editor === null || editor === void 0 ? void 0 : editor.getCursor,
            _b[FileType.SHEET] = this.getSheetActiveRange,
            _b);
        try {
            // 保持原有 cursor 逻辑把 getCursor 方法作为品类测的兜底方法
            return ((_c = resultMap[fileType]) === null || _c === void 0 ? void 0 : _c.call(resultMap)) || (editor === null || editor === void 0 ? void 0 : editor.getCursor());
        }
        catch (_d) {
            return;
        }
    };
    DocManager.getSelectedImageAddonElement = function () {
        return __awaiter(this, void 0, void 0, function () {
            var selectedDocElements, selectedElement, docElementType;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.docData.service.editor) {
                            return [2 /*return*/, undefined];
                        }
                        return [4 /*yield*/, this.docData.service.editor.getSelectedDocElements()];
                    case 1:
                        selectedDocElements = _b.sent();
                        if (selectedDocElements.length !== 1) {
                            return [2 /*return*/, undefined];
                        }
                        selectedElement = selectedDocElements[0];
                        docElementType = getDocElementType(selectedElement);
                        if (docElementType !== DocElementType.IMAGE) {
                            return [2 /*return*/, undefined];
                        }
                        return [2 /*return*/, selectedElement];
                }
            });
        });
    };
    var _a;
    _a = DocManager;
    // ocr 识别结果
    DocManager.ocrRes = {};
    /**
     * 获取当前文档类型的描述
     */
    DocManager.getFileTypeDes = function () { return getFileTypeDes(_a.getMetaInfo().fileType); };
    /**
     * 获取 aid 上报的位置
     */
    DocManager.getAidPosition = function () { var _b; return ((_b = _a.docData.reportInfo) === null || _b === void 0 ? void 0 : _b.aidPosition) || 'toolbar'; };
    DocManager.getSheetActiveRange = function () {
        var _b;
        var editor = _a.docData.service.editor;
        var activeRange = (_b = editor === null || editor === void 0 ? void 0 : editor.getActiveRange) === null || _b === void 0 ? void 0 : _b.call(editor);
        if (!activeRange) {
            return;
        }
        var _c = __read(activeRange.xRange, 2), startColumn = _c[0], endColumn = _c[1], _d = __read(activeRange.yRange, 2), startRow = _d[0], endRow = _d[1], sheetId = activeRange.sheetId;
        return {
            startRow: startRow,
            endRow: endRow,
            startColumn: startColumn,
            endColumn: endColumn,
            sheetId: sheetId,
        };
    };
    return DocManager;
}());

var ADDON_PROXY_KEY = '__td_open_addon_proxy__';
var ENTERPRISE_DEFAULT_ORIGIN = 'https://doc.weixin.qq.com';
var DEFAULT_ORIGIN = 'https://docs.qq.com';
var EXPIRE_TIME = 24 * 3600 * 1000;
var CSS_DEV_BROAD = {
    background: 'rgba(51,113,246,0.8)',
    position: 'fixed',
    bottom: '30px',
    left: '20px',
    padding: '3px 5px',
    display: 'flex',
    'flex-direction': 'column',
    'border-radius': '5px',
    // 根据最新 zindex 规则
    'z-index': 12001,
    'min-width': '190px',
};
var CSS_BUTTON = {
    margin: 'auto',
    padding: '0 2px',
    border: '0px',
    'border-radius': '2px',
};
var CSS_INFO_TEXT_DIV = {
    color: 'white',
};
var CSS_BUTTON_CONTAINER = {
    display: 'flex',
    column: 'row',
};

function getInlineCSS(cssObject) {
    var cssList = Object.keys(cssObject).reduce(function (acc, key) {
        acc.push("".concat(key, ":").concat(cssObject[key]));
        return acc;
    }, []);
    return cssList.join(';');
}

var DevElement = /** @class */ (function () {
    function DevElement(infoText, exitCallback, openPageCallback) {
        this.infoText = infoText;
        this.exitCallback = exitCallback;
        this.openPageCallback = openPageCallback;
        this.key = 'txdocs_open_addon_proxy';
        this.board = document.createElement('div');
        this.infoTextDiv = document.createElement('div');
        this.exitButton = document.createElement('button');
        this.openDevPagesBtn = document.createElement('button');
        this.buttonContainer = document.createElement('div');
    }
    DevElement.prototype.renderDevBoard = function () {
        var _a = this, infoTextDiv = _a.infoTextDiv, exitButton = _a.exitButton, board = _a.board, infoText = _a.infoText, key = _a.key, openDevPagesBtn = _a.openDevPagesBtn, buttonContainer = _a.buttonContainer;
        exitButton.innerText = '退出调试';
        exitButton.setAttribute('style', getInlineCSS(CSS_BUTTON));
        openDevPagesBtn.innerText = '更多工具';
        openDevPagesBtn.setAttribute('style', getInlineCSS(CSS_BUTTON));
        buttonContainer.append(exitButton, openDevPagesBtn);
        buttonContainer.setAttribute('style', getInlineCSS(CSS_BUTTON_CONTAINER));
        infoTextDiv.innerText = infoText;
        infoTextDiv.setAttribute('style', getInlineCSS(CSS_INFO_TEXT_DIV));
        board.setAttribute('style', getInlineCSS(CSS_DEV_BROAD));
        board.appendChild(this.infoTextDiv);
        board.appendChild(buttonContainer);
        board.setAttribute('id', key);
        document.body.appendChild(board);
        this.manageEventListener(this.getEventName());
    };
    DevElement.prototype.disposalDevBoard = function () {
        var _a = this, board = _a.board, exitButton = _a.exitButton, infoTextDiv = _a.infoTextDiv, openDevPagesBtn = _a.openDevPagesBtn;
        [board, exitButton, infoTextDiv, openDevPagesBtn].forEach(function (i) {
            i.remove();
        });
    };
    DevElement.prototype.getEventName = function () {
        var mobileEvent = {
            click: 'touchstart',
            clickStart: 'touchstart',
            clickMove: 'touchmove',
            clickEnd: 'touchend',
        };
        var PCEvent = {
            click: 'click',
            clickStart: 'mousedown',
            clickMove: 'mousemove',
            clickEnd: 'mouseup',
        };
        return ua.isMobile ? mobileEvent : PCEvent;
    };
    DevElement.prototype.manageEventListener = function (eventName) {
        var _a = this, board = _a.board, exitButton = _a.exitButton, exitCallback = _a.exitCallback, openDevPagesBtn = _a.openDevPagesBtn, openPageCallback = _a.openPageCallback;
        exitButton.addEventListener(eventName.click, exitCallback);
        openDevPagesBtn.addEventListener(eventName.click, openPageCallback);
        var changePosition = function (ev) {
            var _a = ev, clientX = _a.clientX, clientY = _a.clientY;
            if (ua.isMobile) {
                var touches = ev.touches;
                clientX = touches.item(0).clientX;
                clientY = touches.item(0).clientY;
            }
            board.setAttribute('style', getInlineCSS(__assign(__assign({}, CSS_DEV_BROAD), { top: "".concat(clientY, "px"), left: "".concat(clientX, "px"), bottom: 'initial', transform: 'translate(-50%,-50%)' })));
        };
        board.addEventListener(eventName.clickStart, function (ev) {
            ev.preventDefault();
            board.addEventListener(eventName.clickMove, changePosition);
        });
        board.addEventListener(eventName.clickEnd, function (ev) {
            ev.preventDefault();
            board.removeEventListener(eventName.clickMove, changePosition);
        });
    };
    return DevElement;
}());

/**
 * 生成addon window 唯一 ID (8位的数字小写字母组合)
 * @returns window id
 */
var generateAddonWindowId = function () { return getRandomString(8); };
/**
 * 生成插件通信的的唯一 ID (8位的数字小写字母组合)
 * @returns 8位随机数
 */
var generateEncAddonId = function () { return getRandomString(8); };
/**
 * 生成代理 url 随机数 (6位的数字小写字母组合)
 * @returns 6位随机数
 */
var generateProxyURLNonce = function () { return getRandomString(6); };
// 根据时间戳（13位）和随机字符串，生成唯一的 id
var generateIdWithTimestamp = function (randomLen) {
    var time = new Date().getTime();
    var random = getRandomString(randomLen);
    return "".concat(time).concat(random);
};
// 格式：yyyy-MM-dd hh:mm:ss
var getFormatDate = function (date) {
    var _a;
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var hour = date.getHours();
    var min = date.getMinutes();
    var sec = date.getSeconds();
    _a = __read([year, month, day, hour, min, sec].map(function (i) { return "".concat(i).padStart(2, '0'); }), 6), year = _a[0], month = _a[1], day = _a[2], hour = _a[3], min = _a[4], sec = _a[5];
    return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hour, ":").concat(min, ":").concat(sec);
};

/**
 * 调试类，必须要在每一个public函数调用之前运行isDevMode判断
 */
var AddonDevManager = /** @class */ (function () {
    function AddonDevManager(_a) {
        var addonId = _a.addonId, port = _a.port, toolsVersion = _a.toolsVersion;
        this.addonId = addonId;
        this.port = port;
        this.toolsVersion = toolsVersion;
        this.devExpireTime = Date.now() + EXPIRE_TIME;
        var exitModeFn = AddonDevManager.exitDevMode.bind(AddonDevManager);
        var openPagesFn = AddonDevManager.getDevPageURL.bind(AddonDevManager);
        this.devElement = new DevElement(this.getDevBroadInfo(), exitModeFn, openPagesFn);
    }
    AddonDevManager.getSingletonInstance = function () {
        var _a;
        var addonProxyInfo = (_a = localStorage.getItem(ADDON_PROXY_KEY)) !== null && _a !== void 0 ? _a : '';
        var decodedCookie = window.atob(addonProxyInfo);
        var _b = __read(decodedCookie.split('&'), 3), addonId = _b[0], port = _b[1], toolsVersion = _b[2];
        var portNumber = parseInt(port, 10);
        if (Number.isNaN(portNumber) || portNumber < 0 || portNumber > 65535) {
            portNumber = 0;
        }
        if (!this.instance) {
            this.instance = new AddonDevManager({ addonId: addonId, port: portNumber, toolsVersion: toolsVersion });
            // 第一次尝试获取manager对象时，判断如果是调试模式，则渲染调试面板，其他情况都跳过
            if (this.instance.isDevMode()) {
                this.instance.devElement.renderDevBoard();
            }
        }
        return this.instance;
    };
    AddonDevManager.exitDevMode = function () {
        if (!this.instance) {
            return;
        }
        localStorage.removeItem(ADDON_PROXY_KEY);
        this.instance.devElement.disposalDevBoard();
        this.instance = null;
        window.location.reload();
    };
    AddonDevManager.getDevPageURL = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, getOpenAPIContext, addonId, _b, expiredTime, openId, accessToken, url;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!this.instance || ua.isMobile) {
                            return [2 /*return*/];
                        }
                        _a = this.instance, getOpenAPIContext = _a.getOpenAPIContext, addonId = _a.addonId;
                        if (!!this.instance.openAPITokenContext) return [3 /*break*/, 2];
                        return [4 /*yield*/, getOpenAPIContext()];
                    case 1:
                        _c.sent();
                        _c.label = 2;
                    case 2:
                        _b = this.instance.openAPITokenContext, expiredTime = _b.expiresIn, openId = _b.openId, accessToken = _b.accessToken;
                        return [4 /*yield*/, getDevPagesUrl({ expiredTime: expiredTime, accessToken: accessToken, openId: openId, addonId: addonId })];
                    case 3:
                        url = (_c.sent()).url;
                        window.open(url, '_blank');
                        return [2 /*return*/];
                }
            });
        });
    };
    AddonDevManager.prototype.getDevBroadInfo = function () {
        var _a = this, toolsVersion = _a.toolsVersion, addonId = _a.addonId, port = _a.port, devExpireTime = _a.devExpireTime;
        return "".concat(toolsVersion ? "\u7248\u672C\uFF1A".concat(toolsVersion, "\uFF1B") : '', " \u7AEF\u53E3: ").concat(port, "\n    \u63D2\u4EF6ID: ").concat(addonId, "\n    \u8FC7\u671F\u65F6\u95F4\uFF1A").concat(getFormatDate(new Date(devExpireTime)));
    };
    /**
     * 三个变量四个状态
     * 1. 初态： 无token、无promise、过期 ==> 直接发起请求
     * 2. 第一个请求发出后：无token、有promise、过期 ==> await 缓存promise
     * 3. 第一个请求返回后：有token、有promise、未过期 ==> 直接返回token
     * 4. 过期时间到：有token，有promise，过期 ==> 再次发起请求
     */
    AddonDevManager.prototype.getOpenAPIContext = function () {
        return __awaiter(this, void 0, void 0, function () {
            var checkIfInitAndRequest, isWaitingFirstRes, isCacheExpires;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        checkIfInitAndRequest = function () { return !_this.openAPIContextPromise && !_this.openAPITokenContext; };
                        isWaitingFirstRes = function () { return !_this.openAPITokenContext && _this.openAPIContextPromise; };
                        isCacheExpires = function () { return _this.openAPITokenContext && _this.openAPIContextPromise && _this.checkTokenExpired(); };
                        if (!checkIfInitAndRequest()) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.updateOpenAPIContext()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 2:
                        if (!isWaitingFirstRes()) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.openAPIContextPromise];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        if (!isCacheExpires()) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.updateOpenAPIContext()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6: return [2 /*return*/, this.openAPITokenContext];
                }
            });
        });
    };
    AddonDevManager.prototype.getEnterpriseContext = function () {
        return getWeworkUserId();
    };
    AddonDevManager.prototype.getDevServerHost = function () {
        return "https://localhost:".concat(this.port);
    };
    AddonDevManager.prototype.isDevMode = function () {
        return Boolean(this.addonId && this.port);
    };
    AddonDevManager.prototype.getAddonId = function () {
        return this.addonId;
    };
    AddonDevManager.prototype.updateOpenAPIContext = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, fileId, fileType, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = DocManager.getMetaInfo(), fileId = _a.fileId, fileType = _a.fileType;
                        // 缓存promise
                        this.openAPIContextPromise = getOpenAPIToken({
                            clientId: this.addonId,
                            docId: fileId,
                            docType: getFileTypeDes(fileType),
                        });
                        _b = this;
                        return [4 /*yield*/, this.openAPIContextPromise];
                    case 1:
                        _b.openAPITokenContext = _c.sent();
                        this.expireFrom = Date.now();
                        return [2 /*return*/];
                }
            });
        });
    };
    // 缓存token和expire time
    // 如果上面的量没有，如果没有promise，则发起请求
    AddonDevManager.prototype.checkTokenExpired = function () {
        // 如果没有该字段，直接返回过期
        if (!this.expireFrom)
            return true;
        // 文档打开的时间过长时，需要判断
        return Date.now() >= this.expireFrom + this.openAPITokenContext.expiresIn;
    };
    return AddonDevManager;
}());

var RES_SUCCESS_STATUS = 200;
// TODO(cassyhong): OAuth资源默认域名，B端OAuth项目不确定是不是部署在另一套域名下，待确认后修改
var DEFAULT_OAUTH_ORIGIN = global.location.origin;
var CGI;
(function (CGI) {
    /** 获取插件列表 */
    CGI["GET_ADDON_LIST"] = "/addon/editor-addons";
    /** invoke云能力调用 */
    CGI["INVOKE"] = "/addon/funcs/invoke";
    CGI["OPENAPI_DEV_TOKEN"] = "/addon/token";
    CGI["GET_DEV_PAGES"] = "/addon/develops/pages";
    CGI["GET_ADDONS"] = "/addon/addons";
    /** 获取小程序渲染白名单*/
    CGI["GET_MINI_WHITELIST"] = "/addon/mini-program/whitelist";
    CGI["GET_WEWORK_USER_ID"] = "/addon/user/id";
})(CGI || (CGI = {}));
var DRIVE_CGI;
(function (DRIVE_CGI) {
    DRIVE_CGI["GET_DRIVE_LIST"] = "/addon/drive-addons";
    DRIVE_CGI["DIRECT_AUTHORIZE"] = "/oauth/v2/direct/authorize";
    DRIVE_CGI["AUTHORIZE"] = "/oauth/v2/addon/authorize";
})(DRIVE_CGI || (DRIVE_CGI = {}));
var ADDON_ID = '__ADDON_ID__';
var MALL_CGI;
(function (MALL_CGI) {
    MALL_CGI["AUTH"] = "/oauth/v2/direct/authorize";
    MALL_CGI["UNINSTALL"] = "/addon/addons/__ADDON_ID__/uninstall";
    MALL_CGI["INSTALL"] = "/addon/addons/__ADDON_ID__/install";
    /** 获取插件商城插件列表 */
    MALL_CGI["GET_TOPIC_DETAIL"] = "v2/mall/marketing/topics_detail";
})(MALL_CGI || (MALL_CGI = {}));
var LOCAL_CGI = [
    {
        url: CGI.INVOKE,
        needToken: true,
    },
    {
        url: CGI.GET_ADDON_LIST,
        needToken: false,
    },
    {
        url: CGI.GET_DEV_PAGES,
        needToken: false,
    },
];

// 插件快速授权(OAuth提供的cgi)
var ADDON_AUTH_URL = "".concat(DEFAULT_OAUTH_ORIGIN, "/oauth/v2/addon/authorize");
// 插件快速授权重定向地址前缀
var ADDON_AUTH_REDIRECT_URL = "".concat(DEFAULT_OAUTH_ORIGIN, "/addon/addons");
// 插件安装、授权cgi(addon服务提供的cgi)
var AddonAuthCGI;
(function (AddonAuthCGI) {
    AddonAuthCGI["INSTALL"] = "install";
    AddonAuthCGI["AUTH"] = "auth/callback";
})(AddonAuthCGI || (AddonAuthCGI = {}));
var AUTH_RANDOM_LEN = 3;

function concatAuthURI(authParams) {
    var cgi = authParams.cgi, redirectURI = authParams.redirectURI, responseType = authParams.responseType, state = authParams.state, addonId = authParams.addonId;
    var authURI = "".concat(cgi, "?response_type=").concat(responseType, "&client_id=").concat(addonId, "&redirect_uri=").concat(encodeURIComponent(redirectURI));
    if (state) {
        authURI = "".concat(authURI, "&state=").concat(state);
    }
    return getMultUrl(authURI);
}

function ensureValueInScope(value, min, max) {
    return Math.min(max, Math.max(min, value));
}

var ADDON_DIALOG_WIDGET_NAME = 'addon-dialog';
var ADDON_MOBILE_IFRAME_NAME = 'addon-mobile-iframe-name';
var WITH_LOGO_ADDON_ID_LIST = ['meeting_release', 'meeting_test'];
// form 需要 > 10001
var MOBILE_ADDON_Z_INDEX = 10005;

var ADDON_DIALOG_OPTIONS = 'addonDialogOptions';
var ModalSize;
(function (ModalSize) {
    ModalSize[ModalSize["DEFAULT_WIDTH"] = 400] = "DEFAULT_WIDTH";
    ModalSize[ModalSize["DEFAULT_HEIGHT"] = 400] = "DEFAULT_HEIGHT";
    ModalSize[ModalSize["FULLSCREEN_MIN_WIDTH"] = 524] = "FULLSCREEN_MIN_WIDTH";
    ModalSize[ModalSize["FULLSCREEN_MIN_HEIGHT"] = 524] = "FULLSCREEN_MIN_HEIGHT";
})(ModalSize || (ModalSize = {}));

var TRANSITION_DURATION = 240;
var MEDIA_QUERY = '(prefers-color-scheme: light)';
var LIGHT_MODE_MASK_COLOR = 'hsla(0,0%,100%,.65)';
var DARK_MODE_MASK_COLOR = 'rgba(56, 56, 56, .6)';
var PAD_PANEL_WIDTH = '375px';
var PAD_PANEL_HEIGHT = '80%';
var PHONE_PANEL_HEIGHT = '90%';

function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$8 = ".index_modal-mobile-content-wrapper__d-PH1{align-items:center;border:\"none\";bottom:0;display:flex;font-family:-apple-system,Helvetica Neue,Helvetica,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif;height:100%;justify-content:center;left:0;position:relative;right:0;top:0;width:100%}.index_modal-mobile-content-wrapper__d-PH1 .index_content-block__2H-q3{border-width:0;bottom:0;height:100%;left:0;position:absolute;right:0;top:0;width:100%}.index_modal-mobile-content-wrapper__d-PH1 .index_loading-wrapper__-GxZc{background-color:#fff;bottom:0;height:100%;left:0;position:absolute;right:0;top:0;width:100%}.index_modal-mobile-content-wrapper__d-PH1 .index_loading-wrapper__-GxZc .index_loading-content__-0Gja{left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}.index_modal-mobile-content-wrapper__d-PH1 .index_loading-wrapper__-GxZc .index_loading-content__-0Gja .index_loading-icon__X-hLu{display:flex;justify-content:center}.index_modal-mobile-content-wrapper__d-PH1 .index_loading-wrapper__-GxZc .index_loading-content__-0Gja .index_loading-text__9cGOC{color:#000;font-size:12px;line-height:17px;opacity:.64;padding-top:10px}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL2FkZG9uLW1vZGFsL21vZGFsLW1vYmlsZS9jb250ZW50LWJsb2NrL2luZGV4Lmxlc3MiLCJpbmRleC5sZXNzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLDJDQVNFLGtCQUFBLENBRkEsYUFBQSxDQUpBLFFBQUEsQ0FLQSxZQUFBLENBSUEsaUpBQUEsQ0FOQSxXQUFBLENBSUEsc0JBQUEsQ0FSQSxNQUFBLENBU0EsaUJBQUEsQ0FQQSxPQUFBLENBSEEsS0FBQSxDQUlBLFVDUUYsQ0RiQSx1RUFvQkksY0FBQSxDQURBLFFBQUEsQ0FHQSxXQUFBLENBTEEsTUFBQSxDQU1BLGlCQUFBLENBTEEsT0FBQSxDQUZBLEtBQUEsQ0FLQSxVQ0VKLENEdkJBLHlFQWtDSSxxQkFBQSxDQUpBLFFBQUEsQ0FFQSxXQUFBLENBSkEsTUFBQSxDQUtBLGlCQUFBLENBSkEsT0FBQSxDQUZBLEtBQUEsQ0FJQSxVQ0VKLENEakNBLHVHQXVDTSxRQUFBLENBRkEsaUJBQUEsQ0FDQSxPQUFBLENBRUEsOEJDRE4sQ0R2Q0Esa0lBMkNRLFlBQUEsQ0FDQSxzQkNEUixDRDNDQSxrSUFvRFEsVUFBQSxDQUhBLGNBQUEsQ0FDQSxnQkFBQSxDQUNBLFdBQUEsQ0FIQSxnQkNFUiIsImZpbGUiOiJpbmRleC5sZXNzIn0= */";
var styles$8 = {"modal-mobile-content-wrapper":"index_modal-mobile-content-wrapper__d-PH1","content-block":"index_content-block__2H-q3","loading-wrapper":"index_loading-wrapper__-GxZc","loading-content":"index_loading-content__-0Gja","loading-icon":"index_loading-icon__X-hLu","loading-text":"index_loading-text__9cGOC","modal___mobile___content___wrapper":"index_modal-mobile-content-wrapper__d-PH1","content___block":"index_content-block__2H-q3","loading___wrapper":"index_loading-wrapper__-GxZc","loading___content":"index_loading-content__-0Gja","loading___icon":"index_loading-icon__X-hLu","loading___text":"index_loading-text__9cGOC"};
styleInject(css_248z$8);

var ContentBlock = /** @class */ (function (_super) {
    __extends(ContentBlock, _super);
    function ContentBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onLoad = function () {
            var _a, _b;
            (_b = (_a = _this.props).onLoad) === null || _b === void 0 ? void 0 : _b.call(_a);
        };
        _this.render = function () {
            var _a = _this.props, id = _a.id, src = _a.src;
            return (React.createElement("div", { className: styles$8['modal-mobile-content-wrapper'] },
                React.createElement("iframe", { frameBorder: "no", src: src, id: id, className: styles$8['content-block'], onLoad: _this.onLoad })));
        };
        return _this;
    }
    return ContentBlock;
}(React.Component));

var css_248z$7 = ".addon-mobile-modal-wrapper,.addon-mobile-modal-wrapper .dui-m-modal-content{margin:0;padding:0}.addon-mobile-pullpanel-wrapper .addon-mobile-pullpanel-header{height:auto;padding:16px}.addon-mobile-pullpanel-wrapper .addon-mobile-pullpanel-header .dui-m-pullpanel-header-title{font-size:17px}.addon-mobile-pullpanel-wrapper .addon-mobile-pullpanel-content{padding-bottom:0}.index_header-wrapper__wUBoD{border-bottom:1px solid rgba(0,0,0,.08);box-sizing:border-box;display:flex;flex-flow:row nowrap;font-size:17px;justify-content:space-between;min-height:56px;padding:16px 16px 15px;position:relative}.index_header-title__rk7Mo{font-weight:500}.index_header-logo__UpBlV{height:0;width:0}.index_header-close__rlBZ3{background-image:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' fill='none'%3E%3Ccircle opacity='.4' cx='12' cy='12' r='12' fill='%23cbcdd1'/%3E%3Cpath fill-rule='evenodd' d='M16.722 16.72c.37-.37.37-.994.007-1.357l-3.359-3.359 3.359-3.366a.975.975 0 0 0-.007-1.357.97.97 0 0 0-1.357-.007l-3.366 3.359-3.366-3.366a.99.99 0 0 0-1.357.007c-.37.37-.363 1.008-.007 1.364l3.366 3.366-3.366 3.366c-.355.348-.363.987.007 1.357a.99.99 0 0 0 1.357.007l3.366-3.366 3.366 3.359a.97.97 0 0 0 1.357-.007z' fill='%2381868f'/%3E%3C/svg%3E\");background-position:50%;background-repeat:no-repeat;background-size:contain;height:24px;width:24px}.index_header-close__rlBZ3:active{opacity:.5}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL2FkZG9uLW1vZGFsL21vZGFsLW1vYmlsZS9wb3J0cmFpdC9pbmRleC5sZXNzIiwiaW5kZXgubGVzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSw2RUFPTSxRQUFBLENBREEsU0NBTixDRE5BLCtEQWFNLFdBQUEsQ0FDQSxZQ0pOLENEVkEsNkZBaUJRLGNDSlIsQ0RiQSxnRUF1Qk0sZ0JDUE4sQ0RhRSw2QkFRRSx1Q0FBQSxDQUxBLHFCQUFBLENBRkEsWUFBQSxDQUlBLG9CQUFBLENBSUEsY0FBQSxDQUhBLDZCQUFBLENBRkEsZUFBQSxDQUdBLHNCQUFBLENBTEEsaUJDSkosQ0RjRSwyQkFDRSxlQ1pKLENEZUUsMEJBR0UsUUFBQSxDQURBLE9DYkosQ0RpQkUsMkJBQ0UscWtCQUFBLENBS0EsdUJBQUEsQ0FEQSwyQkFBQSxDQURBLHVCQUFBLENBREEsV0FBQSxDQURBLFVDWEosQ0RpQkksa0NBQ0UsVUNmTiIsImZpbGUiOiJpbmRleC5sZXNzIn0= */";
var styles$7 = {"header-wrapper":"index_header-wrapper__wUBoD","header-title":"index_header-title__rk7Mo","header-logo":"index_header-logo__UpBlV","header-close":"index_header-close__rlBZ3","header___wrapper":"index_header-wrapper__wUBoD","header___title":"index_header-title__rk7Mo","header___logo":"index_header-logo__UpBlV","header___close":"index_header-close__rlBZ3"};
styleInject(css_248z$7);

var MobilePortraitModal = /** @class */ (function (_super) {
    __extends(MobilePortraitModal, _super);
    function MobilePortraitModal(props) {
        var _this = _super.call(this, props) || this;
        _this.render = function () {
            if (ua.isIPad || ua.isAndroidPad) {
                return _this.renderPadPanel();
            }
            return _this.renderPhonePanel();
        };
        _this.renderPhonePanel = function () {
            var _a = _this.props, onLoad = _a.onLoad, _b = _a.addonDialogOptions, title = _b.title, src = _b.src, id = _b.id;
            return (React.createElement(PullPanel, { visible: _this.state.visible, zIndex: MOBILE_ADDON_Z_INDEX, title: title, pullable: false, mask: true, panelHeight: PHONE_PANEL_HEIGHT, 
                // 需要覆盖 dui-mobile 样式, 不使用 css-modules
                className: "addon-mobile-pullpanel-wrapper", headerClassName: "addon-mobile-pullpanel-header", contentClassName: "addon-mobile-pullpanel-content", onOk: _this.onClose.bind(_this), cancelText: React.createElement("img", { className: styles$7['header-logo'] }), okText: React.createElement("div", { className: styles$7['header-close'] }) },
                React.createElement(ContentBlock, { id: id, src: src, onLoad: onLoad })));
        };
        _this.renderPadPanel = function () {
            var _a = _this.props, onLoad = _a.onLoad, _b = _a.addonDialogOptions, title = _b.title, src = _b.src, id = _b.id;
            return (React.createElement(Modal, { visible: _this.state.visible, zIndex: MOBILE_ADDON_Z_INDEX, title: null, footer: null, 
                // 需要覆盖 dui-mobile 样式, 不使用 css-modules
                className: "addon-mobile-modal-wrapper", style: { width: PAD_PANEL_WIDTH, height: PAD_PANEL_HEIGHT } },
                React.createElement("div", { className: styles$7['header-wrapper'] },
                    React.createElement("img", { className: styles$7['header-logo'] }),
                    React.createElement("div", { className: styles$7['header-title'] }, title),
                    React.createElement("div", { className: styles$7['header-close'], onClick: _this.onClose.bind(_this) })),
                React.createElement(ContentBlock, { id: id, src: src, onLoad: onLoad })));
        };
        _this.state = { visible: true, isLightMode: false };
        return _this;
    }
    MobilePortraitModal.prototype.onClose = function () {
        var _this = this;
        this.setState({ visible: false });
        setTimeout(function () {
            _this.props.onClose();
        }, TRANSITION_DURATION);
    };
    return MobilePortraitModal;
}(React.Component));

var MobileLandscapeModal = /** @class */ (function (_super) {
    __extends(MobileLandscapeModal, _super);
    function MobileLandscapeModal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.render = function () {
            // 此处需要隐藏header,插件自己实现,因为取消和完成需要交给开发者处理
            var headerStyle = { display: 'none' };
            // 不是 IPAD 或者 APAD 的情景需要强制横屏
            var forceLandscape = !ua.isIPad && !ua.isAndroidPad;
            var _a = _this.props, onLoad = _a.onLoad, _b = _a.addonDialogOptions, src = _b.src, id = _b.id;
            return (React.createElement(HorizontalPanel, { forceLandscape: forceLandscape, visible: true, zIndex: 9999, headerStyle: headerStyle },
                React.createElement(ContentBlock, { id: id, src: src, onLoad: onLoad })));
        };
        return _this;
    }
    return MobileLandscapeModal;
}(React.Component));

var css_248z$6 = ".index_mobile-fullscreen-content-wrapper__ZuFNV{height:100%;position:absolute;top:0;width:100%}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL2FkZG9uLW1vZGFsL21vZGFsLW1vYmlsZS9mdWxsLXNjcmVlbi9pbmRleC5sZXNzIiwiaW5kZXgubGVzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxnREFFRSxXQUFBLENBREEsaUJBQUEsQ0FHQSxLQUFBLENBREEsVUNFRiIsImZpbGUiOiJpbmRleC5sZXNzIn0= */";
var styles$6 = {"mobile-fullscreen-content-wrapper":"index_mobile-fullscreen-content-wrapper__ZuFNV","mobile___fullscreen___content___wrapper":"index_mobile-fullscreen-content-wrapper__ZuFNV"};
styleInject(css_248z$6);

var MobileFullScreen = /** @class */ (function (_super) {
    __extends(MobileFullScreen, _super);
    function MobileFullScreen() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.render = function () {
            var _a = _this.props, onLoad = _a.onLoad, _b = _a.addonDialogOptions, src = _b.src, id = _b.id;
            return (React.createElement("div", { className: styles$6['mobile-fullscreen-content-wrapper'] },
                React.createElement(ContentBlock, { id: id, src: src, onLoad: onLoad })));
        };
        return _this;
    }
    return MobileFullScreen;
}(React.Component));

/**
 * 插件弹窗组件
 */
var MobileModal = /** @class */ (function (_super) {
    __extends(MobileModal, _super);
    function MobileModal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MobileModal.prototype.render = function () {
        var _a = this.props[ADDON_DIALOG_OPTIONS], _b = _a.orientation, orientation = _b === void 0 ? DialogOrientation.PORTRAIT : _b, _c = _a.fullscreen, fullscreen = _c === void 0 ? false : _c;
        if (fullscreen) {
            return React.createElement(MobileFullScreen, __assign({}, this.props));
        }
        if (orientation === DialogOrientation.LANDSCAPE) {
            return React.createElement(MobileLandscapeModal, __assign({}, this.props));
        }
        return React.createElement(MobilePortraitModal, __assign({}, this.props));
    };
    return MobileModal;
}(React.Component));

var css_248z$5 = "@keyframes index_sdk-modal-fade-in__XtObL{0%{opacity:0}to{opacity:1}}@keyframes index_sdk-modal-pop-up__S0o9m{0%{opacity:0;transform:scale3d(.9,.9,1)}to{opacity:1;transform:scaleX(1)}}.index_modal-fade-in__7puek{opacity:1}.index_modal-fade-out__0TCJ1{opacity:0}.index_addon-modal-wrapper__BQX7u{align-items:center;animation:index_sdk-modal-fade-in__XtObL .3s cubic-bezier(.4,0,.2,1);background-color:rgba(56,56,56,.6);bottom:0;display:flex;font-family:-apple-system,Helvetica Neue,Helvetica,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif;justify-content:center;left:0;padding:48px;position:fixed;right:0;top:0;z-index:11000}.index_addon-modal-wrapper__BQX7u .index_modal__kcy2p{animation:index_sdk-modal-pop-up__S0o9m .3s cubic-bezier(.4,0,.2,1);background-color:#fff;border-radius:6px;box-shadow:0 2px 12px 2px rgba(68,73,77,.16);display:flex;flex-direction:column;overflow:hidden;position:relative}.index_addon-modal-wrapper__BQX7u .index_modal__kcy2p .index_close__ieA69{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iIzgxODY4RiIgZD0iTTguNjMxIDggMTMgMTIuMzY4bC0uNjMyLjYzMkw4IDguNjMxIDMuNjMyIDEzIDMgMTIuMzY4IDcuMzY4IDggMyAzLjYzMiAzLjYzMiAzIDggNy4zNjggMTIuMzY4IDNsLjYzMi42MzJ6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=);background-position:50%;background-repeat:no-repeat;background-size:16px 16px;border-radius:2px;cursor:pointer;height:24px;position:absolute;right:20px;top:20px;width:24px;z-index:10}.index_addon-modal-wrapper__BQX7u .index_modal__kcy2p .index_close__ieA69:hover{background-color:rgba(0,0,0,.04)}.index_addon-modal-wrapper__BQX7u .index_modal__kcy2p .index_close__ieA69:active{background-color:rgba(0,0,0,.08)}.index_addon-modal-wrapper__BQX7u .index_modal__kcy2p .index_header__-5DoY{display:flex;height:64px;padding:0 24px}.index_addon-modal-wrapper__BQX7u .index_modal__kcy2p .index_header__-5DoY .index_icon__czSS7{align-items:center;display:flex;margin:0 8px 0 0}.index_addon-modal-wrapper__BQX7u .index_modal__kcy2p .index_header__-5DoY .index_icon__czSS7 img{height:32px;width:32px}.index_addon-modal-wrapper__BQX7u .index_modal__kcy2p .index_header__-5DoY .index_title__uie7N{color:#000;display:flex;font-size:16px;font-stretch:normal;font-style:normal;font-weight:600;letter-spacing:normal;line-height:64px;opacity:.88;overflow:hidden;padding-right:48px;text-overflow:ellipsis;white-space:nowrap}.index_addon-modal-wrapper__BQX7u .index_modal__kcy2p .index_content__aLmQo{align-items:center;display:flex;height:100%;justify-content:center;margin:0;position:relative;width:100%}.index_addon-modal-wrapper__BQX7u .index_modal--hidden__BI-Vi,.index_addon-modal-wrapper__BQX7u .index_modal--visible__7NEvd{transition-property:opacity,transform,visibility;transition-timing-function:cubic-bezier(.4,0,.2,1)}.index_addon-modal-wrapper__BQX7u .index_modal--visible__7NEvd{opacity:1;transform:scaleX(1);transition-duration:.3s}.index_addon-modal-wrapper__BQX7u .index_modal--hidden__BI-Vi{opacity:0;transform:scale3d(.9,.9,1);transition-duration:.24s}.index_addon-mask--visible__3rRsi{opacity:1;transition:all .3s cubic-bezier(.4,0,.2,1)}.index_addon-mask--hidden__1RpAP{opacity:0;transition:all .24s cubic-bezier(.4,0,.2,1)}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL2FkZG9uLW1vZGFsL21vZGFsLXBjL2luZGV4Lmxlc3MiLCJpbmRleC5sZXNzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQU1FLDBDQUNFLEdBNEJGLFNDaENBLENET0UsR0FxQkYsU0N6QkEsQ0FDRixDRERFLHlDQUNFLEdBZ0JGLFNBQUEsQ0FDQSwwQkNaQSxDREZFLEdBT0YsU0FBQSxDQUVBLG1CQ0hBLENBQ0YsQ0RhQSw0QkFDRSxTQ1hGLENEY0EsNkJBQ0UsU0NaRixDRGVBLGtDQVNFLGtCQUFBLENBS0Esb0VBQUEsQ0FQQSxrQ0FBQSxDQUhBLFFBQUEsQ0FJQSxZQUFBLENBSUEsaUpBQUEsQ0FGQSxzQkFBQSxDQVBBLE1BQUEsQ0FRQSxZQUFBLENBVkEsY0FBQSxDQUlBLE9BQUEsQ0FIQSxLQUFBLENBSUEsYUNORixDREFBLHNEQXdCSSxtRUFBQSxDQUpBLHFCQUFBLENBRkEsaUJBQUEsQ0FDQSw0Q0FBQSxDQUdBLFlBQUEsQ0FDQSxxQkFBQSxDQUZBLGVBQUEsQ0FKQSxpQkNQSixDRFZBLDBFQWdDTSx3VkFBQSxDQUNBLHVCQUFBLENBQ0EsMkJBQUEsQ0FDQSx5QkFBQSxDQUVBLGlCQUFBLENBQ0EsY0FBQSxDQVJBLFdBQUEsQ0FIQSxpQkFBQSxDQUNBLFVBQUEsQ0FDQSxRQUFBLENBRUEsVUFBQSxDQUtBLFVDWk4sQ0RnQk0sZ0ZBQ0UsZ0NDZFIsQ0RpQk0saUZBQ0UsZ0NDZlIsQ0Q5QkEsMkVBb0RNLFlBQUEsQ0FEQSxXQUFBLENBREEsY0NmTixDRG5DQSw4RkF3RFEsa0JBQUEsQ0FEQSxZQUFBLENBRUEsZ0JDakJSLENEeENBLGtHQTREVSxXQUFBLENBQ0EsVUNqQlYsQ0Q1Q0EsK0ZBMkVRLFVBQUEsQ0FUQSxZQUFBLENBR0EsY0FBQSxDQUVBLG1CQUFBLENBQ0EsaUJBQUEsQ0FGQSxlQUFBLENBSUEscUJBQUEsQ0FEQSxnQkFBQSxDQUxBLFdBQUEsQ0FTQSxlQUFBLENBVkEsa0JBQUEsQ0FXQSxzQkFBQSxDQUZBLGtCQ2pCUixDRDNEQSw0RUFxRk0sa0JBQUEsQ0FEQSxZQUFBLENBS0EsV0FBQSxDQUhBLHNCQUFBLENBSEEsUUFBQSxDQUlBLGlCQUFBLENBQ0EsVUNwQk4sQ0RwRUEsNkhBaUdJLGdEQUFBLENBRkEsa0RDdEJKLENEekVBLCtEQXJCRSxTQUFBLENBRUEsbUJBQUEsQ0F5SEUsdUJDeEJKLENEOUVBLDhEQWZFLFNBQUEsQ0FDQSwwQkFBQSxDQXlIRSx3QkN4QkosQ0Q0QkEsa0NBQ0UsU0FBQSxDQUNBLDBDQzFCRixDRDZCQSxpQ0FDRSxTQUFBLENBQ0EsMkNDM0JGIiwiZmlsZSI6ImluZGV4Lmxlc3MifQ== */";
var styles$5 = {"modal-fade-in":"index_modal-fade-in__7puek","modal-fade-out":"index_modal-fade-out__0TCJ1","addon-modal-wrapper":"index_addon-modal-wrapper__BQX7u","sdk-modal-fade-in":"index_sdk-modal-fade-in__XtObL","modal":"index_modal__kcy2p","sdk-modal-pop-up":"index_sdk-modal-pop-up__S0o9m","close":"index_close__ieA69","header":"index_header__-5DoY","icon":"index_icon__czSS7","title":"index_title__uie7N","content":"index_content__aLmQo","modal--hidden":"index_modal--hidden__BI-Vi","modal--visible":"index_modal--visible__7NEvd","addon-mask--visible":"index_addon-mask--visible__3rRsi","addon-mask--hidden":"index_addon-mask--hidden__1RpAP","modal___fade___in":"index_modal-fade-in__7puek","modal___fade___out":"index_modal-fade-out__0TCJ1","addon___modal___wrapper":"index_addon-modal-wrapper__BQX7u","sdk___modal___fade___in":"index_sdk-modal-fade-in__XtObL","sdk___modal___pop___up":"index_sdk-modal-pop-up__S0o9m","modal____hidden":"index_modal--hidden__BI-Vi","modal____visible":"index_modal--visible__7NEvd","addon___mask____visible":"index_addon-mask--visible__3rRsi","addon___mask____hidden":"index_addon-mask--hidden__1RpAP"};
styleInject(css_248z$5);

var PCModal = /** @class */ (function (_super) {
    __extends(PCModal, _super);
    function PCModal(props) {
        var _this = _super.call(this, props) || this;
        _this.changeMode = function (event) {
            _this.setState({ isLightMode: event.matches });
        };
        _this.escFunction = function (event) {
            if (event.key.toLocaleLowerCase() === 'escape') {
                event.preventDefault();
                _this.close();
            }
        };
        _this.lightModeMedia = window.matchMedia(MEDIA_QUERY);
        _this.state = { visible: true, isLightMode: _this.lightModeMedia.matches };
        return _this;
    }
    PCModal.prototype.render = function () {
        var _a = this.props, _b = ADDON_DIALOG_OPTIONS, _c = _a[_b], _d = _c.width, width = _d === void 0 ? ModalSize.DEFAULT_WIDTH : _d, _e = _c.height, height = _e === void 0 ? ModalSize.DEFAULT_HEIGHT : _e, _f = _c.title, title = _f === void 0 ? '' : _f, id = _c.id, src = _c.src, logo = _c.logo, _g = _c.fullscreen, fullscreen = _g === void 0 ? false : _g, onLoad = _a.onLoad;
        var iframeStyle = this.getIframeStyle();
        var modalStyle = this.getModalStyle({
            width: width,
            height: height,
            fullscreen: fullscreen,
        });
        var maskStyle = {
            backgroundColor: this.state.isLightMode ? LIGHT_MODE_MASK_COLOR : DARK_MODE_MASK_COLOR,
        };
        var TitleBar = function () { return (React.createElement("div", { className: styles$5.header },
            logo ? (React.createElement("div", { className: styles$5.icon },
                React.createElement("img", { src: logo }))) : null,
            React.createElement("div", { className: styles$5.title }, title))); };
        return ReactDOM.createPortal(React.createElement("div", { className: "".concat(styles$5['addon-modal-wrapper'], " \n            ").concat(this.state.visible ? styles$5['addon-mask--visible'] : styles$5['addon-mask--hidden']), style: maskStyle },
            React.createElement("div", { style: modalStyle, className: "".concat(styles$5.modal, " ").concat(this.state.visible ? styles$5['modal--visible'] : styles$5['modal--hidden']), onClick: function (event) {
                    event.stopPropagation();
                } },
                React.createElement("div", { className: styles$5.close, style: this.props[ADDON_DIALOG_OPTIONS].noTitle ? { top: '24px', right: '24px' } : {}, onClick: this.close.bind(this) }),
                this.props[ADDON_DIALOG_OPTIONS].noTitle ? null : React.createElement(TitleBar, null),
                React.createElement("div", { className: styles$5.content },
                    React.createElement("iframe", { style: iframeStyle, id: id, src: src, onLoad: function () {
                            onLoad === null || onLoad === void 0 ? void 0 : onLoad();
                        } })))), document.body);
    };
    PCModal.prototype.componentDidMount = function () {
        document.addEventListener('keydown', this.escFunction, false);
        this.lightModeMedia.addEventListener('change', this.changeMode);
    };
    PCModal.prototype.componentWillUnmount = function () {
        document.removeEventListener('keydown', this.escFunction, false);
        this.lightModeMedia.removeEventListener('change', this.changeMode);
    };
    PCModal.prototype.close = function () {
        var _this = this;
        this.setState({
            visible: false,
        });
        setTimeout(function () {
            _this.props.onClose();
        }, TRANSITION_DURATION);
    };
    PCModal.prototype.getIframeStyle = function () {
        var iframeStyle = {
            width: '100%',
            height: '100%',
            border: 0,
        };
        return iframeStyle;
    };
    PCModal.prototype.getModalStyle = function (options) {
        var width = options.width, height = options.height, fullscreen = options.fullscreen;
        if (fullscreen) {
            return {
                width: '100%',
                height: '100%',
                minWidth: ModalSize.FULLSCREEN_MIN_WIDTH,
                minHeight: ModalSize.FULLSCREEN_MIN_HEIGHT,
                position: 'relative',
            };
        }
        return {
            width: "".concat(width, "px"),
            height: "".concat(height, "px"),
            position: 'absolute',
        };
    };
    return PCModal;
}(React.Component));

/**
 * 插件弹窗组件
 */
var AddonModalComponent = /** @class */ (function (_super) {
    __extends(AddonModalComponent, _super);
    function AddonModalComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddonModalComponent.prototype.render = function () {
        if (ua.isMobile) {
            return React.createElement(MobileModal, __assign({}, this.props));
        }
        return React.createElement(PCModal, __assign({}, this.props));
    };
    return AddonModalComponent;
}(React.Component));

var css_248z$4 = ".index_addon-sidebar-container__BGEOT{font-family:-apple-system,Helvetica Neue,Helvetica,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif;height:100%;position:absolute;top:0;width:100%}.index_sidebar-header__GwA2X{align-items:center;display:flex;height:64px;justify-content:space-between;margin-left:16px}.index_sidebar-header__GwA2X>.index_sidebar-title__2pCrb{color:#000;display:inline-block;font-size:16px;font-weight:600;line-height:64px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.index_sidebar-header__GwA2X>.index_sidebar-close-button__bLy50{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iIzgxODY4RiIgZD0iTTguNjMxIDggMTMgMTIuMzY4bC0uNjMyLjYzMkw4IDguNjMxIDMuNjMyIDEzIDMgMTIuMzY4IDcuMzY4IDggMyAzLjYzMiAzLjYzMiAzIDggNy4zNjggMTIuMzY4IDNsLjYzMi42MzJ6IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=);background-position:50%;background-repeat:no-repeat;background-size:16px 16px;cursor:pointer;display:inline-block;height:24px;margin-right:12px;transition:all .3s ease;width:24px}.index_sidebar-header__GwA2X>.index_sidebar-close-button__bLy50:hover{background-color:rgba(0,0,0,.04)}.index_sidebar-header__GwA2X>.index_sidebar-close-button__bLy50:active{background-color:rgba(0,0,0,.08)}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL2FkZG9uLXNpZGViYXIvaW5kZXgubGVzcyIsImluZGV4Lmxlc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsc0NBS0UsaUpBQUEsQ0FEQSxXQUFBLENBSEEsaUJBQUEsQ0FDQSxLQUFBLENBQ0EsVUNHRixDREdBLDZCQUVFLGtCQUFBLENBREEsWUFBQSxDQUlBLFdBQUEsQ0FGQSw2QkFBQSxDQUNBLGdCQ0FGLENER0UseURBSUUsVUFBQSxDQURBLG9CQUFBLENBRkEsY0FBQSxDQUlBLGVBQUEsQ0FIQSxnQkFBQSxDQUtBLGVBQUEsQ0FDQSxzQkFBQSxDQUZBLGtCQ0NKLENESUUsZ0VBQ0Usd1ZBQUEsQ0FDQSx1QkFBQSxDQUVBLDJCQUFBLENBREEseUJBQUEsQ0FPQSxjQUFBLENBSEEsb0JBQUEsQ0FEQSxXQUFBLENBRUEsaUJBQUEsQ0FDQSx1QkFBQSxDQUpBLFVDR0osQ0RJSSxzRUFDRSxnQ0NGTixDREtJLHVFQUNFLGdDQ0hOIiwiZmlsZSI6ImluZGV4Lmxlc3MifQ== */";
var styles$4 = {"addon-sidebar-container":"index_addon-sidebar-container__BGEOT","sidebar-header":"index_sidebar-header__GwA2X","sidebar-title":"index_sidebar-title__2pCrb","sidebar-close-button":"index_sidebar-close-button__bLy50","addon___sidebar___container":"index_addon-sidebar-container__BGEOT","sidebar___header":"index_sidebar-header__GwA2X","sidebar___title":"index_sidebar-title__2pCrb","sidebar___close___button":"index_sidebar-close-button__bLy50"};
styleInject(css_248z$4);

var SidebarSize;
(function (SidebarSize) {
    SidebarSize[SidebarSize["DEFAULT_SIDEBAR_WIDTH"] = 280] = "DEFAULT_SIDEBAR_WIDTH";
    SidebarSize[SidebarSize["MIN_WIDTH"] = 280] = "MIN_WIDTH";
    SidebarSize[SidebarSize["MAX_WIDTH"] = 400] = "MAX_WIDTH";
})(SidebarSize || (SidebarSize = {}));
var ADDON_SIDEBAR_OPTIONS = 'addonSidebarOptions';
var AddonSidebarComponent = /** @class */ (function (_super) {
    __extends(AddonSidebarComponent, _super);
    function AddonSidebarComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.escFunction = function (event) {
            if (event.key.toLocaleLowerCase() === 'escape') {
                event.preventDefault();
                var onClose = _this.props.onClose;
                onClose();
            }
        };
        return _this;
    }
    AddonSidebarComponent.prototype.render = function () {
        var _a = this.props, _b = ADDON_SIDEBAR_OPTIONS, _c = _a[_b], id = _c.id, _d = _c.title, title = _d === void 0 ? '' : _d, src = _c.src, onClose = _a.onClose, onLoad = _a.onLoad;
        return (React.createElement("div", { className: styles$4['addon-sidebar-container'] },
            React.createElement("div", { className: styles$4['sidebar-header'] },
                React.createElement("div", { className: styles$4['sidebar-title'] }, title),
                React.createElement("div", { className: styles$4['sidebar-close-button'], onClick: onClose })),
            React.createElement("iframe", { id: id, frameBorder: "0", width: "100%", height: "100%", src: src, onLoad: function () {
                    onLoad === null || onLoad === void 0 ? void 0 : onLoad();
                } })));
    };
    AddonSidebarComponent.prototype.componentDidMount = function () {
        document.addEventListener('keydown', this.escFunction, false);
    };
    AddonSidebarComponent.prototype.componentWillUnmount = function () {
        document.removeEventListener('keydown', this.escFunction, false);
    };
    return AddonSidebarComponent;
}(React.Component));

var PC_IFRAME_MODAL_WIDTH = 320;
var PC_IFRAME_MODAL_HEIGHT = 576;

var UIManagerBase = /** @class */ (function () {
    function UIManagerBase() {
        this.events = {};
    }
    UIManagerBase.prototype.getIframeModalOptions = function (_a) {
        var url = _a.url, _b = _a.title, title = _b === void 0 ? '' : _b;
        var options = { src: url, id: 'addon-iframe-modal', title: title };
        if (ua.isPC) {
            options.noTitle = true;
            options.width = PC_IFRAME_MODAL_WIDTH;
            options.height = PC_IFRAME_MODAL_HEIGHT;
        }
        return options;
    };
    return UIManagerBase;
}());

var UIManagerWorkbench = /** @class */ (function (_super) {
    __extends(UIManagerWorkbench, _super);
    function UIManagerWorkbench() {
        var _this = _super.call(this) || this;
        _this.openDialog = function (options, event) {
            _this.events.dialog = event;
            _this.store.update(ADDON_DIALOG_OPTIONS, options);
            var ModalComponent = _this.ModalComponent;
            _this.widgetService.float({
                name: ADDON_DIALOG_WIDGET_NAME,
                component: React.createElement(ModalComponent, { onClose: _this.closeDialog, onLoad: event === null || event === void 0 ? void 0 : event.onLoad }),
            });
        };
        _this.updateDialog = function (options) {
            var oldOptions = _this.store.getValue(ADDON_DIALOG_OPTIONS);
            if (oldOptions) {
                _this.store.update(ADDON_DIALOG_OPTIONS, __assign(__assign({}, oldOptions), options));
            }
        };
        _this.closeDialog = function () {
            var _a, _b;
            (_b = (_a = _this.events.dialog) === null || _a === void 0 ? void 0 : _a.onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
            _this.widgetService.remove(ADDON_DIALOG_WIDGET_NAME, 'float');
        };
        _this.openSidebar = function (options, event) {
            _this.store.update(ADDON_SIDEBAR_OPTIONS, options);
            _this.events.sidebar = event;
            var SidebarComponent = _this.SidebarComponent;
            var _a = options.width, width = _a === void 0 ? SidebarSize.DEFAULT_SIDEBAR_WIDTH : _a;
            var computedWidth = ensureValueInScope(width, SidebarSize.MIN_WIDTH, SidebarSize.MAX_WIDTH);
            _this.drawerService.showRightDrawer({
                content: (React.createElement(SidebarComponent
                // sidebar 组件内部触发关闭事件
                , { 
                    // sidebar 组件内部触发关闭事件
                    onClose: _this.closeSidebar, onLoad: event === null || event === void 0 ? void 0 : event.onLoad })),
                style: {
                    width: computedWidth,
                },
                // sidebar 被外部关闭时触发
                onClose: event === null || event === void 0 ? void 0 : event.onClose,
            });
        };
        _this.updateSidebar = function (options) {
            var oldOptions = _this.store.getValue(ADDON_SIDEBAR_OPTIONS);
            if (oldOptions) {
                _this.store.update(ADDON_SIDEBAR_OPTIONS, __assign(__assign({}, oldOptions), options));
            }
        };
        _this.closeSidebar = function () {
            var _a, _b;
            (_b = (_a = _this.events.sidebar) === null || _a === void 0 ? void 0 : _a.onClose) === null || _b === void 0 ? void 0 : _b.call(_a);
            _this.drawerService.closeRightDrawer(true);
        };
        _this.openIframeModal = function (_a) {
            var url = _a.url, _b = _a.title, title = _b === void 0 ? '' : _b;
            var options = _this.getIframeModalOptions({ url: url, title: title });
            _this.widgetService.float({
                name: ADDON_MOBILE_IFRAME_NAME,
                component: React.createElement(AddonModalComponent, { addonDialogOptions: options, onClose: _this.closeIframeModal }),
            });
        };
        _this.closeIframeModal = function () {
            _this.widgetService.remove(ADDON_MOBILE_IFRAME_NAME, 'float');
        };
        _this.drawerService = InjectorService.get(DrawerService);
        _this.widgetService = InjectorService.get(WidgetService);
        _this.store = InjectorService.get(StateManager);
        _this.initStore();
        _this.ModalComponent = withState([ADDON_DIALOG_OPTIONS])(AddonModalComponent);
        _this.SidebarComponent = withState([ADDON_SIDEBAR_OPTIONS])(AddonSidebarComponent);
        return _this;
    }
    UIManagerWorkbench.prototype.initStore = function () {
        this.store.register(ADDON_SIDEBAR_OPTIONS, {
            id: '',
            src: '',
            width: SidebarSize.DEFAULT_SIDEBAR_WIDTH,
        });
        this.store.register(ADDON_DIALOG_OPTIONS, {
            id: '',
            src: '',
            width: ModalSize.DEFAULT_WIDTH,
            height: ModalSize.DEFAULT_HEIGHT,
        });
    };
    return UIManagerWorkbench;
}(UIManagerBase));
var UIManagerWorkbench$1 = UIManagerWorkbench;

var UIManager = getUIManager();
function getUIManager() {
    var UIManager;
    {
        UIManager = new UIManagerWorkbench$1();
    }
    return UIManager;
}

/**
 * 管理插件授权
 */
var AddonAuthManager = /** @class */ (function () {
    function AddonAuthManager() {
        var _this = this;
        // 管理所有回调
        this.callbackMap = new Map();
        this.callbackIdRandomLen = 3;
        // 处理插件授权
        this.handleAddonAuth = function (addonId, successCallback, failCallback) {
            if (successCallback === void 0) { successCallback = function () { }; }
            if (failCallback === void 0) { failCallback = _this.defaultFailCallback; }
            return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var _b, installed, needAuthorize, addonName, callbackId, cgi, authURL;
                var _this = this;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, AddonManager$1.getInstance().getAddon(addonId, { needInstalled: false })];
                        case 1:
                            _b = _c.sent(), installed = _b.installed, needAuthorize = _b.needAuthorize, addonName = _b.name;
                            // 安装且授权了，不打开安装或者授权页面
                            if (installed && !needAuthorize) {
                                successCallback();
                                resolve();
                                return [2 /*return*/];
                            }
                            callbackId = generateIdWithTimestamp(this.callbackIdRandomLen);
                            cgi = installed ? AddonAuthCGI.AUTH : AddonAuthCGI.INSTALL;
                            authURL = concatAuthURI({
                                cgi: ADDON_AUTH_URL,
                                responseType: 'code',
                                redirectURI: "".concat(ADDON_AUTH_REDIRECT_URL, "/").concat(addonId, "/").concat(cgi),
                                state: callbackId,
                                addonId: addonId,
                            });
                            UIManager.openIframeModal({ url: authURL, title: addonName });
                            // 2.设置callbackMap
                            this.callbackMap.set(callbackId, {
                                success: function () {
                                    // 授权成功后关闭弹窗
                                    UIManager.closeIframeModal();
                                    // 安装成功后重新拉取插件信息进行更新
                                    AddonManager$1.getInstance().getAddon(addonId, { shouldGetLatest: true });
                                    successCallback();
                                },
                                fail: failCallback,
                            });
                            // 3.设置监听函数（先解除再监听，避免重复执行）
                            this.clearEventListener(true);
                            window.addEventListener('message', function (event) {
                                var success = _this.handleAuthResult(event);
                                if (success) {
                                    resolve();
                                }
                                else {
                                    reject();
                                }
                            });
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        // 处理授权结果
        this.handleAuthResult = function (event) {
            var isMessageValid = function (event) { var _b, _c; return event.origin === DEFAULT_OAUTH_ORIGIN && ((_b = event.data) === null || _b === void 0 ? void 0 : _b.data) && ((_c = event.data) === null || _c === void 0 ? void 0 : _c.code) !== undefined; };
            if (!isMessageValid(event)) {
                return false;
            }
            var _b = event.data, code = _b.code, _c = _b.data.state, callbackId = _c === void 0 ? '' : _c;
            if (!_this.callbackMap.has(callbackId)) {
                return false;
            }
            var _d = _this.callbackMap.get(callbackId), success = _d.success, fail = _d.fail;
            var res = false;
            if (code === AddonErrorCode.SUCCESS) {
                success === null || success === void 0 ? void 0 : success();
                res = true;
            }
            else {
                fail === null || fail === void 0 ? void 0 : fail();
            }
            _this.callbackMap.delete(callbackId);
            // 处理完成后，如果callbackMap为空，则解绑listener
            _this.clearEventListener(_this.callbackMap.size === 0);
            return res;
        };
        // TODO(cassyhong): 默认授权异常回调 - 调用品类侧toast接口
        this.defaultFailCallback = function () { };
        // 解绑message listener
        this.clearEventListener = function (condition) {
            if (condition === void 0) { condition = false; }
            if (condition) {
                window.removeEventListener('message', _this.handleAuthResult);
            }
        };
    }
    var _a;
    _a = AddonAuthManager;
    // 单例实现
    AddonAuthManager.getInstance = function () {
        if (!_a.instance) {
            _a.instance = new AddonAuthManager();
        }
        return _a.instance;
    };
    return AddonAuthManager;
}());

// 是否需要授权
var needAddonAuthorize = function (ret) { return ret === BackEndErrorCode.ADDON_NOT_AUTHORIZED; };

var _a$5;
var getExtraData = function () { return ({
    envId: getCookie('env_id'),
    // DEV 模式下，traceId 为空
    traceId: '',
}); };
var devActionMap = (_a$5 = {},
    _a$5[DEFAULT_ORIGIN] = function (req) { return __awaiter(void 0, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, AddonDevManager.getSingletonInstance().getOpenAPIContext()];
                case 1:
                    data = _a.sent();
                    req.data = __assign(__assign(__assign({}, req.data), getExtraData()), data);
                    return [2 /*return*/, req];
            }
        });
    }); },
    _a$5[ENTERPRISE_DEFAULT_ORIGIN] = function (req) { return __awaiter(void 0, void 0, void 0, function () {
        var userId;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, AddonDevManager.getSingletonInstance().getEnterpriseContext()];
                case 1:
                    userId = _a.sent();
                    req.data = __assign(__assign(__assign({}, req.data), getExtraData()), { openId: userId });
                    return [2 /*return*/, req];
            }
        });
    }); },
    _a$5);

// 通用请求拦截器，防止xsrf攻击
var addXSRF = function (req) {
    var data;
    var xsrf = getXSRF();
    if (/^get$/i.test(req.method) || /^delete$/i.test(req.method)) {
        return __assign(__assign({}, req), { params: __assign(__assign({}, req.params), { xsrf: xsrf }) });
    }
    if (/^post$/i.test(req.method) || /^patch$/i.test(req.method)) {
        data = Object.assign(req.data, { xsrf: xsrf });
    }
    return __assign(__assign({}, req), { data: data });
};
// 开发模式下的拦截器函数
var devModeInterceptor = function (req) { return __awaiter(void 0, void 0, void 0, function () {
    var devManager, url, getAddonCGI, localCGI, origin;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                devManager = AddonDevManager.getSingletonInstance();
                if (!devManager.isDevMode()) {
                    return [2 /*return*/, req];
                }
                url = req.url;
                getAddonCGI = { url: "/addon/addons/".concat(devManager.getAddonId()), needToken: false };
                localCGI = __spreadArray(__spreadArray([], __read(LOCAL_CGI), false), [getAddonCGI], false).find(function (item) { return item.url === url; });
                origin = req.baseURL;
                if (!localCGI) return [3 /*break*/, 2];
                req.baseURL = devManager.getDevServerHost();
                if (!localCGI.needToken) return [3 /*break*/, 2];
                return [4 /*yield*/, devActionMap[origin](req)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/, req];
        }
    });
}); };
// 重写返回data中的msg
var rewriteDataMsg = function (data) {
    if (data) {
        return __assign({ msg: '未知错误' }, data);
    }
    return data;
};
var onFulFillRewriteRes = function (res) {
    var data = rewriteDataMsg(res.data);
    // 请求成功
    if (res.status === RES_SUCCESS_STATUS) {
        res.data = data;
        return res;
    }
    return Promise.reject(new Exception(data.ret, data));
};
// 处理响应码为200的成功请求
var handleSuccessRes = function (res) {
    var _a = res.data, data = _a === void 0 ? {} : _a;
    var ret = data.ret;
    // 请求成功
    if (ret === AddonErrorCode.SUCCESS) {
        return Promise.resolve(data);
    }
    // 处理授权
    if (needAddonAuthorize(ret)) {
        return handleAddonAuth(res);
    }
    // 其他业务错误
    return Promise.reject(new Exception(ret, data));
};
// 处理插件授权
var handleAddonAuth = function (res) {
    var config = res.config;
    var data = config.data;
    return new Promise(function (resolve, reject) {
        try {
            // 因为axios请求前会默认将data做stringify处理，这里重新parse后再传入
            var reqData_1 = JSON.parse(data);
            AddonAuthManager.getInstance().handleAddonAuth(reqData_1.addonId, function () { return __awaiter(void 0, void 0, void 0, function () {
                var response, err_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, request(__assign(__assign({}, config), { data: reqData_1 }))];
                        case 1:
                            response = _a.sent();
                            resolve(response);
                            return [3 /*break*/, 3];
                        case 2:
                            err_1 = _a.sent();
                            // 第二次请求错误，直接 reject
                            reject(err_1);
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            }); });
        }
        catch (err) {
            // JSON.parse 错误，直接返回业务错误
            reject(new Exception(data.ret, data));
        }
    });
};
var onRejectRewriteRes = function (error) {
    var exception = error instanceof Exception ? error : new Exception(AddonErrorCode.ENVIRONMENT_NETWORK_FAIL);
    return Promise.reject(exception);
};
var REQUEST_INTERCEPTORS = [[addXSRF], [devModeInterceptor]];
var RESPONSE_INTERCEPTORS = [[onFulFillRewriteRes, onRejectRewriteRes], [handleSuccessRes]];
var loadReqInterceptors = function (request, interceptors) {
    interceptors.forEach(function (item) { return request.use.apply(request, __spreadArray([], __read(item), false)); });
};
var loadResInterceptors = function (response, interceptors) {
    interceptors.forEach(function (item) { return response.use.apply(response, __spreadArray([], __read(item), false)); });
};

/*
 * @Author: fugao
 * @Date: 2021-06-14 21:05:20
 * @Last Modified by: fugao
 * @Last Modified time: 2021-08-18 20:26:22
 *
 * 初始化请求配置
 */
var request = Axios.create({
    baseURL: PROD_HOST_NAME,
    xsrfCookieName: 'TOK',
    timeout: 10000,
});
// 注册请求拦截器
loadReqInterceptors(request.interceptors.request, REQUEST_INTERCEPTORS);
// 注册响应拦截器
loadResInterceptors(request.interceptors.response, RESPONSE_INTERCEPTORS);

/**
 * 获取插件列表
 * @param options 参数
 * @return 插件列表数据
 */
function getAddonList(options) {
    return request.get(CGI.GET_ADDON_LIST, { params: options });
}
/**
 * 获取商城插件列表
 * @param options 参数
 * @return 插件列表数据
 */
function getTopicData(options) {
    var addonTypes = options.addonTypes, rest = __rest(options, ["addonTypes"]);
    return request.post(MALL_CGI.GET_TOPIC_DETAIL, __assign({ addon_types: addonTypes }, rest));
}
/**
 * 云函数调用
 * @param options 参数
 * @returns
 */
function invokeAddonService(options) {
    return request.post(CGI.INVOKE, options);
}
function getOpenAPIToken(options) {
    return __awaiter(this, void 0, void 0, function () {
        var clientId, docId, docType, params;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    clientId = options.clientId, docId = options.docId, docType = options.docType;
                    params = docId ? { addonId: clientId, docId: docId, docType: docType } : { addonId: clientId };
                    return [4 /*yield*/, request.get(CGI.OPENAPI_DEV_TOKEN, {
                            params: params,
                        })];
                case 1: return [2 /*return*/, (_a.sent()).data];
            }
        });
    });
}
function getDevPagesUrl(options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.post(CGI.GET_DEV_PAGES, options)];
                case 1: return [2 /*return*/, (_a.sent()).data];
            }
        });
    });
}
function uninstallAddon(addonId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.delete(MALL_CGI.UNINSTALL.replace(ADDON_ID, addonId))];
                case 1: return [2 /*return*/, (_a.sent()).data];
            }
        });
    });
}
function getAddons(addonIds, needAuthStatus) {
    if (needAuthStatus === void 0) { needAuthStatus = 1; }
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (addonIds.length === 0) {
                        return [2 /*return*/, Promise.reject('请至少传入一个插件id')];
                    }
                    return [4 /*yield*/, request.get("".concat(CGI.GET_ADDONS, "/").concat(addonIds.join(',')), {
                            params: {
                                needAuthStatus: needAuthStatus,
                            },
                        })];
                case 1: return [2 /*return*/, (_a.sent()).data];
            }
        });
    });
}
function getMiniAppRenderWhiteList() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, request.get(CGI.GET_MINI_WHITELIST)];
        });
    });
}
function getWeworkUserId() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.get("".concat(CGI.GET_WEWORK_USER_ID))];
                case 1: return [2 /*return*/, (_a.sent()).data.id];
            }
        });
    });
}
// 获取插件已授权文件列表
function getAuthorizedFiles(addonId) {
    return __awaiter(this, void 0, void 0, function () {
        var params;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    params = { clientID: addonId };
                    return [4 /*yield*/, request.get("/open/user-auth/authfile" /* FILE_AUTH_CGI.GET_AUTH_FILES */, {
                            params: params,
                        })];
                case 1: return [2 /*return*/, (_a.sent()).data];
            }
        });
    });
}
// 提交插件授权文件
function authFiles(params) {
    return __awaiter(this, void 0, void 0, function () {
        var config;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = { headers: { 'Content-Type': 'application/json' } };
                    return [4 /*yield*/, request.patch("/open/user-auth/authfile" /* FILE_AUTH_CGI.GET_AUTH_FILES */, params, config)];
                case 1: return [2 /*return*/, (_a.sent()).data];
            }
        });
    });
}

/**
 * @description: 把 DocContext 的 selectedElements 中的 addonId 改为正式环境的 id
 * @param {Addon} addon
 * @param {DocContext} context
 * @return {DocContext | undefined}
 */
var getContext = function (addon) { return __awaiter(void 0, void 0, void 0, function () {
    var context, addonId, env, res, prodAddonId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, DocManager.getDocContext()];
            case 1:
                context = _a.sent();
                addonId = addon.addonId, env = addon.env;
                // 正式环境不修改 context 数据
                if (!context || env === AddonEnvironmentType.PRODUCTION) {
                    return [2 /*return*/, context];
                }
                res = __assign({}, context);
                prodAddonId = getEnvAddonId(addonId, AddonEnvironmentType.PRODUCTION);
                if (res.selectedElements) {
                    res.selectedElements = res.selectedElements.map(function (element) {
                        // DocElement 类型上没有 addonId 属性，把类型转换为 any 处理
                        if (isAddonElement(element)) {
                            var elementRes = element;
                            elementRes.addonId = prodAddonId;
                            elementRes.env = env;
                            return elementRes;
                        }
                        return element;
                    });
                }
                return [2 /*return*/, res];
        }
    });
}); };
var getEnvContent = function (content, env) {
    var _a;
    if (env === void 0) { env = AddonEnvironmentType.PRODUCTION; }
    if (!content) {
        return '';
    }
    var contentSuffix = (_a = {},
        _a[AddonEnvironmentType.PRODUCTION] = '',
        _a[AddonEnvironmentType.PREVIEW] = '（体验）',
        _a[AddonEnvironmentType.AUDIT] = '（审核）',
        _a[AddonEnvironmentType.DEVELOPMENT] = '',
        _a)[env];
    return "".concat(content).concat(contentSuffix || '');
};

const appConfigInstance$1 = DocsConfig.getInstance();
const npmConfig$1 = appConfigInstance$1.getConfig('npm["@tencent/docs-design-resources"]');
let p = !!npmConfig$1 && npmConfig$1.CDN_ORIGIN || 'https://docs.gtimg.com/docs-design-resources';
p = p + '/pc/svg/';
function getDataDate31Dark() {
  return p + 'data_date31_dark-10b5b68151.svg';
}
function getHelpLineNormal() {
  return p + 'help_line_normal-3650975d42.svg';
}
function getToolbarAddLatex() {
  return p + 'toolbar_add_latex-4ca8867f41.svg';
}
function getToolbarAddSignature() {
  return p + 'toolbar_add_signature-f944e0dae6.svg';
}
function getToolbarAddTencentMeeting() {
  return p + 'toolbar_add_tencent_meeting-b8fb131038.svg';
}
function getToolbarAddTool() {
  return p + 'toolbar_add_tool-b50bf54708.svg';
}
function getToolbarPainting() {
  return p + 'toolbar_painting-e8d3d57dcb.svg';
}

// 三方内容类型
var LinkType;
(function (LinkType) {
    LinkType[LinkType["UNKNOWN"] = 0] = "UNKNOWN";
    // 腾讯视频
    LinkType[LinkType["TENCENT_VIDEO"] = 1] = "TENCENT_VIDEO";
    // bilibili
    LinkType[LinkType["BILIBILI"] = 2] = "BILIBILI";
    // processon
    LinkType[LinkType["PROCESSON"] = 3] = "PROCESSON";
    // 印象笔记
    LinkType[LinkType["YINXIANG"] = 4] = "YINXIANG";
    // canva
    LinkType[LinkType["CANVA"] = 5] = "CANVA";
    // 墨刀
    LinkType[LinkType["MODAO"] = 6] = "MODAO";
    // 摹客
    LinkType[LinkType["MOKE"] = 7] = "MOKE";
    // QQ音乐
    LinkType[LinkType["QQ_MUSIC"] = 8] = "QQ_MUSIC";
})(LinkType || (LinkType = {}));
var SnackbarType;
(function (SnackbarType) {
    SnackbarType["INFO"] = "info";
    SnackbarType["SUCCESS"] = "success";
    SnackbarType["ERROR"] = "error";
    SnackbarType["LOADING"] = "loading";
})(SnackbarType || (SnackbarType = {}));
// 官方插件类型
var OfficialAddonType;
(function (OfficialAddonType) {
    OfficialAddonType["UNKNOWN"] = "unknown";
    // 第三方内容
    OfficialAddonType["LINK"] = "link";
    // LaTeX公式
    OfficialAddonType["FORMULA"] = "formula";
    // 签名
    OfficialAddonType["SIGN"] = "sign";
    // 腾讯会议
    OfficialAddonType["MEETING"] = "meeting";
    // 腾讯会议 - 测试
    OfficialAddonType["MEETING_TEST"] = "meeting_test";
    // 倒计时
    OfficialAddonType["COUNTDOWN"] = "countdown";
    // 投票
    OfficialAddonType["VOTE"] = "vote";
    // 绘图
    OfficialAddonType["GRAPH"] = "graph";
})(OfficialAddonType || (OfficialAddonType = {}));

var _a$4;
// map官方插件黑白图标
var OFFICIAL_ICON_MAPPING = (_a$4 = {},
    _a$4[OfficialAddonType.LINK] = getToolbarAddTool(),
    _a$4[OfficialAddonType.FORMULA] = getToolbarAddLatex(),
    _a$4[OfficialAddonType.SIGN] = getToolbarAddSignature(),
    _a$4[OfficialAddonType.MEETING] = getToolbarAddTencentMeeting(),
    _a$4[OfficialAddonType.MEETING_TEST] = getToolbarAddTencentMeeting(),
    _a$4[OfficialAddonType.COUNTDOWN] = getDataDate31Dark(),
    _a$4[OfficialAddonType.GRAPH] = getToolbarPainting(),
    _a$4);

// 云函数调用场景
var InvokeScene;
(function (InvokeScene) {
    // 子菜单
    InvokeScene[InvokeScene["MENU"] = 1] = "MENU";
    // 子菜单事件
    InvokeScene[InvokeScene["MENU_ACTION"] = 2] = "MENU_ACTION";
    // toolbar
    InvokeScene[InvokeScene["TOOLBAR"] = 3] = "TOOLBAR";
    // toolbar事件
    InvokeScene[InvokeScene["TOOLBAR_ACTION"] = 4] = "TOOLBAR_ACTION";
    // 插件内部调用
    InvokeScene[InvokeScene["ADDON"] = 5] = "ADDON";
    // 文档侧调用
    InvokeScene[InvokeScene["DOC"] = 6] = "DOC";
})(InvokeScene || (InvokeScene = {}));
/**
 * 插件类型
 * PLATFORM: 平台插件(内部)
 * TRIPARTITE: 三方插件(开发者)
 */
var AddonType;
(function (AddonType) {
    AddonType[AddonType["PLATFORM"] = 0] = "PLATFORM";
    AddonType[AddonType["TRIPARTITE"] = 1] = "TRIPARTITE";
})(AddonType || (AddonType = {}));
var ChargingType;
(function (ChargingType) {
    ChargingType["LIMITEDFREE"] = "limitedFree";
    ChargingType["PAID"] = "paid";
    ChargingType["INAPPPURCHASE"] = "inAppPurchase";
    ChargingType["FREE"] = "free";
    ChargingType["DISCOUNT"] = "discount";
})(ChargingType || (ChargingType = {}));
// 插件弹窗/sidebar 渲染类型
var AddonRenderType;
(function (AddonRenderType) {
    AddonRenderType["IFRAME"] = "iframe";
    // sandbox-hina-addon 三层结构
    AddonRenderType["HINA"] = "hina";
})(AddonRenderType || (AddonRenderType = {}));
// 插件访问策略
var AddonAccessStrategy;
(function (AddonAccessStrategy) {
    AddonAccessStrategy["VIEWABLE"] = "viewable";
    AddonAccessStrategy["EDITABLE"] = "editable";
})(AddonAccessStrategy || (AddonAccessStrategy = {}));

var SUIT_ADDON_H5_BASE_URL = 'https://docs.qq.com/open/addon/suit';
var MINIPROGRAM_FILE_SELECTOR_PATH = '/packages/miniapp-open/wechat-file-select/wechat-file-select';

// 删除链接中的参数
var deleteQuery = function (url, query) {
    var urlInstance = new URL(url);
    urlInstance.searchParams.delete(query);
    return urlInstance.href;
};
// 获取套件插件 H5 打开 url
var getOpenSuitAddonH5URL = function (addonId, _a) {
    var _b = _a === void 0 ? {} : _a, fileId = _b.fileId, fileType = _b.fileType, aidPosition = _b.aidPosition;
    var url = new URL("".concat(SUIT_ADDON_H5_BASE_URL, "?addon_id=").concat(addonId));
    if (fileId) {
        url.searchParams.append('file_id', fileId);
    }
    if (fileType) {
        url.searchParams.append('file_type', fileType);
    }
    if (aidPosition) {
        url.searchParams.append('aid_position', aidPosition);
    }
    return url.toString();
};
// 获取小程序内跳转打开本地文件选择器页面 path
var getOpenPlatformFileSelectorURL = function (addonId, _a) {
    var _b = _a === void 0 ? {} : _a, fileType = _b.fileType, aidPosition = _b.aidPosition;
    var h5URL = getOpenSuitAddonH5URL(addonId, {
        fileType: fileType,
        aidPosition: aidPosition,
    });
    return "".concat(MINIPROGRAM_FILE_SELECTOR_PATH, "?callbackUrl=").concat(encodeURIComponent(h5URL));
};

// 插件文件授权类型
var FileAuthType;
(function (FileAuthType) {
    FileAuthType["NONE"] = "None";
    FileAuthType["ALL"] = "All";
    FileAuthType["PART"] = "Part";
})(FileAuthType || (FileAuthType = {}));
var FileAuthUpdateType;
(function (FileAuthUpdateType) {
    FileAuthUpdateType["ADD"] = "Add";
    FileAuthUpdateType["COVER"] = "Cover";
})(FileAuthUpdateType || (FileAuthUpdateType = {}));
// 移动端文件选择器权限
var MobileFileSelectorPermission;
(function (MobileFileSelectorPermission) {
    MobileFileSelectorPermission[MobileFileSelectorPermission["CanCopy"] = 0] = "CanCopy";
    MobileFileSelectorPermission[MobileFileSelectorPermission["CanExport"] = 1] = "CanExport";
    MobileFileSelectorPermission[MobileFileSelectorPermission["CanPrint"] = 2] = "CanPrint";
})(MobileFileSelectorPermission || (MobileFileSelectorPermission = {}));

var PayTheme;
(function (PayTheme) {
    // 按条购买模板
    PayTheme["TEMPLATE"] = "TEMPLATE";
    // 订阅VIP
    PayTheme["VIP"] = "VIP";
    // 通用的商品
    PayTheme["COMMON_PRODUCT"] = "COMMON_PRODUCT";
})(PayTheme || (PayTheme = {}));
var ProductType;
(function (ProductType) {
    // 模版
    ProductType[ProductType["TEMPLATE"] = 1] = "TEMPLATE";
    // 容量劵
    ProductType[ProductType["COUPON"] = 2] = "COUPON";
    // 插件
    ProductType[ProductType["ADDON"] = 3] = "ADDON";
})(ProductType || (ProductType = {}));

var isUAExist = function (ua) { return window.navigator.userAgent.indexOf(ua) !== -1; };
var concatAID = function (source, addonId) {
    return getAidForReport({
        position: DocManager.getAidPosition(),
        feature: 'addon',
        apprec1: addonId,
        apprec2: source,
        apprec3: DocManager.getFileTypeDes(),
    });
};

var EagerLoad = 7;
function getExtensionService() {
    return __awaiter(this, void 0, void 0, function () {
        var extensionService, arkExtension;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, import('@tencent/ark-extensions')];
                case 1:
                    arkExtension = _a.sent();
                    extensionService = arkExtension.createExtensionService();
                    return [3 /*break*/, 3];
                case 2:
                    _a.sent();
                    // 除了商城外的所有宿主都会有 ark 依赖
                    throw new Error('缺少 ark-extension 依赖');
                case 3: return [2 /*return*/, extensionService];
            }
        });
    });
}
function getArkExtension(_a) {
    var name = _a.name, _b = _a.loadType, loadType = _b === void 0 ? EagerLoad : _b;
    return __awaiter(this, void 0, void 0, function () {
        var extensionService;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, getExtensionService()];
                case 1:
                    extensionService = _c.sent();
                    return [4 /*yield*/, extensionService.scanAndHandleExtensions([
                            {
                                name: name,
                                loadType: loadType,
                            },
                        ])];
                case 2:
                    _c.sent();
                    return [2 /*return*/, extensionService.getExtension(name)];
            }
        });
    });
}
function strictFileField(files) {
    return files.map(function (file) {
        var id = file.id, title = file.title, docType = file.docType, _a = file.docIcon, docIcon = _a === void 0 ? '' : _a, _b = file.docUrl, docUrl = _b === void 0 ? '' : _b, _c = file.docTypeDesc, docTypeDesc = _c === void 0 ? '' : _c, _d = file.url, url = _d === void 0 ? '' : _d, _e = file.iconUrl, iconUrl = _e === void 0 ? '' : _e;
        return {
            id: id,
            title: title,
            type: docType,
            icon: docIcon || iconUrl,
            url: docUrl || url,
            description: docTypeDesc,
        };
    });
}
function strictPartFileField(files) {
    return files.map(function (file) {
        var fileID = file.fileID, fileName = file.fileName, docType = file.docType, icon = file.icon, url = file.url, docTypeDesc = file.docTypeDesc;
        return {
            id: fileID,
            title: fileName,
            type: docType,
            icon: icon,
            url: url,
            description: docTypeDesc,
        };
    });
}

var AddonMallManager = /** @class */ (function () {
    function AddonMallManager() {
        var _this = this;
        /**
         * 打开插件商城
         * @param options 插件商城选项
         */
        this.openAddonMall = function (options) { return __awaiter(_this, void 0, void 0, function () {
            var openAddonPanel;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAddonMallLoader()];
                    case 1:
                        openAddonPanel = (_a.sent()).openAddonPanel;
                        openAddonPanel(options);
                        return [2 /*return*/];
                }
            });
        }); };
        /**
         * 关闭插件商城
         */
        this.closeAddonMall = function () { return __awaiter(_this, void 0, void 0, function () {
            var closeAddonPanel;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAddonMallLoader()];
                    case 1:
                        closeAddonPanel = (_a.sent()).closeAddonPanel;
                        closeAddonPanel();
                        return [2 /*return*/];
                }
            });
        }); };
    }
    AddonMallManager.getInstance = function () {
        if (!this.instance) {
            this.instance = new AddonMallManager();
        }
        return this.instance;
    };
    AddonMallManager.prototype.getAddonMallLoader = function () {
        if (!this.addonMallLoader) {
            this.addonMallLoader = ua.isMobile
                ? this.getMobileAddonMallLoader()
                : import('@tencent/docs-tmall-panel/dist/addon');
        }
        return this.addonMallLoader;
    };
    AddonMallManager.prototype.getMobileAddonMallLoader = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, openMobileAddonPanel, closeMobileAddonPanel;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, import('@tencent/docs-tmall-panel/dist/m/addon')];
                    case 1:
                        _a = _b.sent(), openMobileAddonPanel = _a.openMobileAddonPanel, closeMobileAddonPanel = _a.closeMobileAddonPanel;
                        return [2 /*return*/, {
                                openAddonPanel: openMobileAddonPanel,
                                closeAddonPanel: closeMobileAddonPanel,
                                default: openMobileAddonPanel,
                            }];
                }
            });
        });
    };
    return AddonMallManager;
}());

var enUS = {
	"第三方插件": "Third-party add-ons",
	"智能抠图": "Smart cutout",
	"制作证件照": "Make ID photos",
	"闪萌表情": "Weshine meme",
	"酷狗音乐": "Kugou Music",
	"摹客设计稿": "Mockplus",
	"镝数图表": "Dycharts",
	"插入PPT素材": "Insert iSlide PPT",
	"插入{{$name}}": "Insert {{$name}}",
	"请到电脑客户端或浏览器中使用": "Please go to the desktop client or browser to use",
	"获取更多": "Get add-ons",
	"管理插件": "Manage add-ons",
	"LaTeX公式": "LaTeX Formula",
	"倒计时": "Countdown",
	"腾讯会议": "Tencent Meeting",
	"第三方内容": "Third-party Content",
	"云图三维": "Cloudcad",
	"腾讯视频": "Tencent Video",
	"哔哩哔哩": "Bilibili",
	"QQ音乐": "QQ Music",
	"印象笔记": "Evernote",
	"墨刀": "MockingBot",
	"摹客": "Mockplus",
	"生成像素画": "Generate pixel art",
	"今天": "Today",
	"昨天": "Yesterday",
	"确定": "OK",
	"授权给「{{addonName}}」的文件": "Files authorized for「{{addonName}}」",
	"「{{addonName}}」想访问你的腾讯文档帐号下的文件，是否允许？": "「{{addonName}}」wants to access the files under your Tencent Docs account, is it allowed?",
	"授权部分文件": "Authorize some files",
	"不允许": "Disallow",
	"授权当前文件": "Authorize current file",
	"授权所有文件": "Authorize all files",
	"选择腾讯文档": "Select Tencent Docs",
	"名称": "Name",
	"来自": "From",
	"最近查看": "Last viewed",
	"已经选择{{$number}}个文件": "{{$number}} selected file(s)",
	"修改授件范围": "Modify authorization scope",
	"取消": "Cancel",
	"可以在这里使用：": "You can find it here：",
	"在{{$1}}的工具栏“插入”-“插件”中使用": "Use in the toolbar \"Insert\" - \"Add-ons\"",
	"{{$1}}详情页工具栏“插件”": "Add-ons on detail pages of {{$1}}",
	"我知道了": "Got it",
	"插件无法使用": "The add-on cannot be used.",
	"当前光标位置不可编辑，请换一个可编辑的位置后再打开插件。": "Please change to an editable position before opening the add-on.",
	"如何打开插件": "How to use it?",
	"如何使用": "How to use",
	"好的": "OK",
	"文档": "Doc",
	"表格": "Sheet",
	"幻灯片": "Slide",
	"收集表": "From"
};

var zhCN = {
	"第三方插件": "第三方插件",
	"插入{{$name}}": "插入{{$name}}",
	"插入 iSlide 素材": "插入 iSlide 素材",
	"请到电脑客户端或浏览器中使用": "请到电脑客户端或浏览器中使用",
	"获取更多": "获取更多",
	"管理插件": "管理插件",
	"LaTeX公式": "LaTeX公式",
	"倒计时": "倒计时",
	"腾讯会议": "腾讯会议",
	"第三方内容": "第三方内容",
	"云图三维": "云图三维",
	"腾讯视频": "腾讯视频",
	"哔哩哔哩": "哔哩哔哩",
	"QQ音乐": "QQ音乐",
	"印象笔记": "印象笔记",
	"墨刀": "墨刀",
	"摹客": "摹客",
	"智能抠图": "智能抠图",
	"制作证件照": "制作证件照",
	"闪萌表情": "闪萌表情",
	"酷狗音乐": "酷狗音乐",
	"摹客设计稿": "摹客设计稿",
	"镝数图表": "镝数图表",
	"生成像素画": "生成像素画",
	"今天": "今天",
	"昨天": "昨天",
	"前天": "前天",
	"确定": "确定",
	"授权给「{{addonName}}」的文件": "授权给「{{addonName}}」的文件",
	"「{{addonName}}」想访问你的腾讯文档帐号下的文件，是否允许？": "「{{addonName}}」想访问你的腾讯文档帐号下的文件，是否允许？",
	"授权部分文件": "授权部分文件",
	"不允许": "不允许",
	"授权当前文件": "授权当前文件",
	"选择腾讯文档": "选择腾讯文档",
	"名称": "名称",
	"来自": "来自",
	"最近查看": "最近查看",
	"已经选择{{$number}}个文件": "已经选择{{$number}}个文件",
	"修改授件范围": "修改授件范围",
	"取消": "取消",
	"可以在这里使用：": "可以在这里使用：",
	"在{{$1}}的工具栏“插入”-“插件”中使用": "在{{$1}}的工具栏“插入”-“插件”中使用",
	"{{$1}}详情页工具栏“插件”": "{{$1}}详情页工具栏“插件”",
	"我知道了": "我知道了",
	"插件无法使用": "插件无法使用",
	"当前光标位置不可编辑，请换一个可编辑的位置后再打开插件。": "当前光标位置不可编辑，请换一个可编辑的位置后再打开插件。",
	"如何打开插件": "如何打开插件",
	"如何使用": "如何使用",
	"好的": "好的",
	"文档": "文档",
	"表格": "表格",
	"幻灯片": "幻灯片",
	"收集表": "收集表"
};

var zhHK = {
	"第三方插件": "第三方插件",
	"智能抠图": "智能摳圖",
	"制作证件照": "製作證件照",
	"闪萌表情": "閃萌表情",
	"酷狗音乐": "酷狗音樂",
	"摹客设计稿": "摹客設計稿",
	"镝数图表": "鏑數圖表",
	"插入{{$name}}": "插入{{$name}}",
	"请到电脑客户端或浏览器中使用": "請到電腦客戶端或瀏覽器中使用",
	"获取更多": "獲取更多",
	"管理插件": "管理插件",
	"LaTeX公式": "LaTeX公式",
	"倒计时": "倒計時",
	"腾讯会议": "騰訊會議",
	"哔哩哔哩": "嗶哩嗶哩",
	"第三方内容": "第三方內容",
	"云图三维": "雲圖三維",
	"腾讯视频": "騰訊視頻",
	"QQ音乐": "QQ音樂",
	"印象笔记": "印象筆記",
	"墨刀": "墨刀",
	"摹客": "摹客",
	"生成像素画": "生成像素畫",
	"今天": "今天",
	"昨天": "昨天",
	"前天": "前天",
	"确定": "確定",
	"授权给「{{addonName}}」的文件": "授權給「{{addonName}}」的文件",
	"「{{addonName}}」想访问你的腾讯文档帐号下的文件，是否允许？": "「{{addonName}}」想訪問你的騰訊文檔帳號下的文件，是否允許？",
	"授权部分文件": "授權部分文件",
	"不允许": "不允許",
	"授权当前文件": "授權當前文件",
	"选择腾讯文档": "選擇騰訊文檔",
	"名称": "名稱",
	"来自": "來自",
	"最近查看": "最近查看",
	"已经选择{{$number}}个文件": "已經選擇{{$number}}個文件",
	"修改授件范围": "修改授件範圍",
	"取消": "取消",
	"可以在这里使用：": "可以在這裏使用：",
	"在{{$1}}的工具栏“插入”-“插件”中使用": "在{{$1}}的工具欄“插入”-“插件”中使用",
	"{{$1}}详情页工具栏“插件”": "{{$1}}詳情頁工具欄“插件”",
	"我知道了": "我收到喇",
	"插件无法使用": "插件無法使用",
	"当前光标位置不可编辑，请换一个可编辑的位置后再打开插件。": "當前光標位置不可編輯，請換一個可編輯嘅位置後再打開插件。",
	"如何打开插件": "如何打開插件",
	"如何使用": "如何使用",
	"好的": "好的",
	"文档": "文檔",
	"表格": "表格",
	"幻灯片": "幻燈片",
	"收集表": "收集表"
};

var _a$3, _b$1, _c$1, _d;
var AddonSDKDocsNamespace = 'addon-sdk-docs';
var Languages;
(function (Languages) {
    Languages["US"] = "en-US";
    Languages["CN"] = "zh-CN";
    Languages["HK"] = "zh-HK";
})(Languages || (Languages = {}));
// 如果 i18n 未初始化，方法可能为 undefined
(_a$3 = i18next.addResources) === null || _a$3 === void 0 ? void 0 : _a$3.call(i18next, Languages.US, AddonSDKDocsNamespace, enUS);
(_b$1 = i18next.addResources) === null || _b$1 === void 0 ? void 0 : _b$1.call(i18next, Languages.CN, AddonSDKDocsNamespace, zhCN);
(_c$1 = i18next.addResources) === null || _c$1 === void 0 ? void 0 : _c$1.call(i18next, Languages.HK, AddonSDKDocsNamespace, zhHK);
var fixedT = (_d = i18next.getFixedT) === null || _d === void 0 ? void 0 : _d.call(i18next, null, AddonSDKDocsNamespace);
var getLanguageByI18n = function (language) {
    switch (language) {
        case 'en':
        case 'en-US':
            return Languages.US;
        case 'zh':
        case 'zh-CN':
            return Languages.CN;
        case 'zh-TW':
        case 'zh-HK':
            return Languages.HK;
        default:
            return Languages.CN;
    }
};
var $t = function () {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return (_a = fixedT === null || fixedT === void 0 ? void 0 : fixedT.apply(void 0, __spreadArray([], __read(args), false))) !== null && _a !== void 0 ? _a : args[0];
};

// 设置文件选择器的最大可选文件数量
var MAX_SELECTOR_FILE = 100;
var ARK_FILE_SELECTOR_COMPONENT = 'docs-component-file-selector';
var ARK_DRIVE_SELECTOR_MOBILE = 'docs-component-drive-selector-mobile';
var FILE_MANAGER_URL = 'https://docs.qq.com/open/auth';
var FILE_SELECTOR_DOM_ID = 'addon-file-manager-root';

var getDefault = function () { return ({
    TODAY: dayjs().startOf('day'),
    WEEK_START: dayjs().startOf('week'),
    WEEK_END: dayjs().endOf('week'),
    SEVEN_DAYS_AGO: dayjs().subtract(7, 'day'),
    YEAR_START: dayjs().startOf('year'),
}); };
var isToday = function (time) {
    var TODAY = getDefault().TODAY;
    return TODAY.isSame(time, 'day');
};
var isYesterday = function (time) {
    var TODAY = getDefault().TODAY;
    return TODAY.isSame(dayjs(time).add(1, 'day'), 'day');
};
// 前天
var isTheDayBeforeYesterday = function (time) {
    var TODAY = getDefault().TODAY;
    return TODAY.isSame(dayjs(time).add(2, 'day'), 'day');
};
var isThisYear = function (time) {
    var YEAR_START = getDefault().YEAR_START;
    return YEAR_START.isBefore(dayjs(time).add(1, 'years'), 'year');
};
var isUSEnvironment = function () { return RegExp(/en-US|en/).test(i18next.language); };
/**
 * 文件显示时间格式化
 * @param time
 */
var dateFormat = function (time, formatString) {
    if (formatString === void 0) { formatString = 'MM-DD HH:mm'; }
    if (isToday(time)) {
        return "".concat(i18next.t('今天'), " ").concat(dayjs(time).format('HH:mm'));
    }
    if (isYesterday(time)) {
        return "".concat(i18next.t('昨天'), " ").concat(dayjs(time).format('HH:mm'));
    }
    if (isTheDayBeforeYesterday(time) && !isUSEnvironment()) {
        return "\u524D\u5929 ".concat(dayjs(time).format('HH:mm'));
    }
    // 非本年度则显示 YYYY-MM-DD
    if (!isThisYear(time)) {
        return dayjs(time).format('YYYY-MM-DD');
    }
    return dayjs(time).format(formatString);
};
/**
 * 文件时间戳处理
 * @param timestamp 时间戳
 * @returns 取整并格式化后的时间，Y/M/D h:m:s
 */
var getFileDate = function (timestamp) { return dateFormat(Math.floor(timestamp / 1000) * 1000); };

var css_248z$3 = ".index_mobile-file-content__AUUwA{height:calc(100% - 100px);overflow-x:hidden;overflow-y:auto;padding-left:16px;width:100%}.index_mobile-file-content__AUUwA .index_mobile-file-item__830OY{align-items:center;display:flex;flex-direction:row;margin:10px 0;width:100%}.index_mobile-file-content__AUUwA .index_mobile-file-item__830OY .index_mobile-file-item-icon__zkmRw{height:32px;width:32px}.index_mobile-file-content__AUUwA .index_mobile-file-item__830OY .index_mobile-file-item-context__AQO-5{display:flex;flex-direction:column;margin-left:12px}.index_mobile-file-content__AUUwA .index_mobile-file-item__830OY .index_mobile-file-item-context__AQO-5 .index_mobile-file-item-title__Mm8Ee{color:rgba(0,0,0,.88);font-size:16px;font-weight:400;line-height:24px;max-width:calc(100vw - 110px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.index_mobile-file-content__AUUwA .index_mobile-file-item__830OY .index_mobile-file-item-context__AQO-5 .index_mobile-file-item-subtitle__lgh3u{display:flex;flex-direction:row}.index_mobile-file-content__AUUwA .index_mobile-file-item__830OY .index_mobile-file-item-context__AQO-5 .index_mobile-file-item-subtitle__text__ts6UD{color:rgba(0,0,0,.4);font-size:12px;font-weight:400;line-height:16px;max-width:calc(50vw - 55px);overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.index_mobile-file-content__AUUwA .index_mobile-file-item__830OY .index_mobile-file-item-context__AQO-5 .index_mobile-file-item-subtitle__divider__AD8Y6{background-color:rgba(0,0,0,.08);height:10px;margin:auto 4px;width:1px}.index_mobile-file-content__AUUwA .index_mobile-file-divider__dur1X{background-color:rgba(0,0,0,.04);height:1px;margin-left:60px;width:100%}.index_mobile-file-footer__jJ9p9{background-color:#fff;bottom:0;box-shadow:0 -2px 4px rgba(0,0,0,.05);display:flex;flex-direction:column;height:100px;position:absolute;width:100%}.index_mobile-file-footer__jJ9p9 .index_mobile-file-num__hhg5D{color:rgba(0,0,0,.64);font-size:14px;font-weight:400;margin:8px auto 14px 16px}.index_mobile-file-footer__jJ9p9 .index_mobile-file-button__gf7Dl{display:flex;flex-direction:row;justify-content:center}.index_mobile-file-footer__jJ9p9 .index_mobile-file-button__gf7Dl .index_auth-set-button__Pe8nZ{height:44px;margin-left:16px;min-width:140px;width:100%}.index_mobile-file-footer__jJ9p9 .index_mobile-file-button__gf7Dl .index_add-file-button__44J-O{height:44px;margin-left:15px;margin-right:16px;min-width:140px;width:100%}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL2FkZG9uLWZpbGUtc2VsZWN0b3IvZmlsZS1zZWxlY3Rvci1tb2JpbGUvaW5kZXgubGVzcyIsImluZGV4Lmxlc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsa0NBQ0UseUJBQUEsQ0FHQSxpQkFBQSxDQURBLGVBQUEsQ0FFQSxpQkFBQSxDQUhBLFVDSUYsQ0ROQSxpRUFZSSxrQkFBQSxDQUZBLFlBQUEsQ0FDQSxrQkFBQSxDQUZBLGFBQUEsQ0FEQSxVQ0tKLENEYkEscUdBZ0JNLFdBQUEsQ0FEQSxVQ0VOLENEakJBLHdHQW9CTSxZQUFBLENBQ0EscUJBQUEsQ0FDQSxnQkNBTixDRHRCQSw2SUE0QlEscUJBQUEsQ0FGQSxjQUFBLENBREEsZUFBQSxDQUVBLGdCQUFBLENBS0EsNkJBQUEsQ0FIQSxlQUFBLENBRUEsc0JBQUEsQ0FEQSxrQkNFUixDRGhDQSxnSkFvQ1EsWUFBQSxDQUNBLGtCQ0RSLENER1Esc0pBSUUsb0JBQUEsQ0FGQSxjQUFBLENBREEsZUFBQSxDQUVBLGdCQUFBLENBS0EsMkJBQUEsQ0FIQSxlQUFBLENBRUEsc0JBQUEsQ0FEQSxrQkNDVixDRElRLHlKQUlFLGdDQUFBLENBRkEsV0FBQSxDQUNBLGVBQUEsQ0FGQSxTQ0NWLENEcERBLG9FQWdFSSxnQ0FBQSxDQURBLFVBQUEsQ0FGQSxnQkFBQSxDQUNBLFVDSkosQ0RVQSxpQ0FNRSxxQkFBQSxDQUpBLFFBQUEsQ0FNQSxxQ0FBQSxDQUhBLFlBQUEsQ0FFQSxxQkFBQSxDQUpBLFlBQUEsQ0FGQSxpQkFBQSxDQUdBLFVDSkYsQ0RBQSwrREFhSSxxQkFBQSxDQURBLGNBQUEsQ0FEQSxlQUFBLENBR0EseUJDUkosQ0ROQSxrRUFrQkksWUFBQSxDQUNBLGtCQUFBLENBQ0Esc0JDVEosQ0RYQSxnR0F1Qk0sV0FBQSxDQUVBLGdCQUFBLENBREEsZUFBQSxDQUVBLFVDVE4sQ0RqQkEsZ0dBZ0NNLFdBQUEsQ0FGQSxnQkFBQSxDQUNBLGlCQUFBLENBRUEsZUFBQSxDQUNBLFVDVk4iLCJmaWxlIjoiaW5kZXgubGVzcyJ9 */";
var styles$3 = {"mobile-file-content":"index_mobile-file-content__AUUwA","mobile-file-item":"index_mobile-file-item__830OY","mobile-file-item-icon":"index_mobile-file-item-icon__zkmRw","mobile-file-item-context":"index_mobile-file-item-context__AQO-5","mobile-file-item-title":"index_mobile-file-item-title__Mm8Ee","mobile-file-item-subtitle":"index_mobile-file-item-subtitle__lgh3u","mobile-file-item-subtitle__text":"index_mobile-file-item-subtitle__text__ts6UD","mobile-file-item-subtitle__divider":"index_mobile-file-item-subtitle__divider__AD8Y6","mobile-file-divider":"index_mobile-file-divider__dur1X","mobile-file-footer":"index_mobile-file-footer__jJ9p9","mobile-file-num":"index_mobile-file-num__hhg5D","mobile-file-button":"index_mobile-file-button__gf7Dl","auth-set-button":"index_auth-set-button__Pe8nZ","add-file-button":"index_add-file-button__44J-O","mobile___file___content":"index_mobile-file-content__AUUwA","mobile___file___item":"index_mobile-file-item__830OY","mobile___file___item___icon":"index_mobile-file-item-icon__zkmRw","mobile___file___item___context":"index_mobile-file-item-context__AQO-5","mobile___file___item___title":"index_mobile-file-item-title__Mm8Ee","mobile___file___item___subtitle":"index_mobile-file-item-subtitle__lgh3u","mobile___file___item___subtitle__text":"index_mobile-file-item-subtitle__text__ts6UD","mobile___file___item___subtitle__divider":"index_mobile-file-item-subtitle__divider__AD8Y6","mobile___file___divider":"index_mobile-file-divider__dur1X","mobile___file___footer":"index_mobile-file-footer__jJ9p9","mobile___file___num":"index_mobile-file-num__hhg5D","mobile___file___button":"index_mobile-file-button__gf7Dl","auth___set___button":"index_auth-set-button__Pe8nZ","add___file___button":"index_add-file-button__44J-O"};
styleInject(css_248z$3);

var FileSelectorMobile = /** @class */ (function (_super) {
    __extends(FileSelectorMobile, _super);
    function FileSelectorMobile(props) {
        var _this = _super.call(this, props) || this;
        _this.render = function () {
            var _a = _this.props, addonId = _a.addonId, fileList = _a.fileList, confirmText = _a.confirmText, maxSelectNum = _a.maxSelectNum, filterType = _a.filterType, onConfirm = _a.onConfirm, onCancel = _a.onCancel;
            var _b = _this.state, visible = _b.visible, selectedFileId = _b.selectedFileId;
            return (React.createElement(PullPanel, { title: $t('选择腾讯文档'), okText: $t('取消'), zIndex: MODAL_Z_INDEX, panelHeight: '90%', visible: visible, pullable: false, mask: true, onOk: function () {
                    _this.onPullPanelClose();
                    onCancel();
                }, onClose: function () {
                    _this.onPullPanelClose();
                    onCancel();
                }, destroyOnClose: true },
                React.createElement(Fragment, null,
                    React.createElement(Checkbox.Group, { className: styles$3['mobile-file-content'], onChange: function (value) { return _this.setState({ selectedFileId: value }); } }, fileList.map(function (item) {
                        // 需要过滤符合插件需求的文件类型
                        var isFilter;
                        if (Array.isArray(filterType)) {
                            isFilter = filterType.includes(item.docType);
                        }
                        else {
                            isFilter = filterType === '' || item.docType === filterType;
                        }
                        if (isFilter) {
                            return (React.createElement(Checkbox, { value: item.fileID, shape: "circle", iconStyle: { top: '10px' }, style: { paddingBottom: 0 }, disabled: selectedFileId.length === maxSelectNum
                                    && selectedFileId.filter(function (element) { return item.fileID === element; }).length === 0 },
                                React.createElement("div", { className: styles$3['mobile-file-item'] },
                                    React.createElement("img", { className: styles$3['mobile-file-item-icon'], src: item.icon }),
                                    React.createElement("div", { className: styles$3['mobile-file-item-context'] },
                                        React.createElement("div", { className: styles$3['mobile-file-item-title'] }, item.fileName),
                                        React.createElement("div", { className: styles$3['mobile-file-item-subtitle'] },
                                            React.createElement("div", { className: styles$3['mobile-file-item-subtitle__text'] }, item.OwnerName),
                                            React.createElement("div", { className: styles$3['mobile-file-item-subtitle__divider'] }),
                                            React.createElement("div", { className: styles$3['mobile-file-item-subtitle__text'] }, getFileDate(Number(item.lastAccessTime) === 0 ? item.lastModifyTime : item.lastAccessTime))))),
                                React.createElement(Divider, null)));
                        }
                        return React.createElement(Fragment, null);
                    })),
                    React.createElement("div", { className: styles$3['mobile-file-footer'] },
                        React.createElement("div", { className: styles$3['mobile-file-num'] }, $t('已经选择{{$number}}个文件', { $number: selectedFileId.length })),
                        React.createElement("div", { className: styles$3['mobile-file-button'] },
                            React.createElement(Button, { className: styles$3['auth-set-button'], size: "large", type: "plain", onClick: function () {
                                    return tencentDocOpenUrlForAll({ url: "".concat(FILE_MANAGER_URL, "/?clientID=").concat(addonId, "&operate=openfilelist") });
                                } }, $t('修改授件范围')),
                            React.createElement(Button, { className: styles$3['add-file-button'], size: "large", type: "primary", onClick: function () {
                                    var selectedFileIdSet = new Set(_this.state.selectedFileId);
                                    var selectedFileList = _this.props.fileList.filter(function (item) { return selectedFileIdSet.has(item.fileID); });
                                    _this.onPullPanelClose();
                                    onConfirm(selectedFileList);
                                } }, confirmText))))));
        };
        _this.onPullPanelClose = function () {
            var _a;
            _this.setState({ visible: false });
            (_a = document.getElementById(FILE_SELECTOR_DOM_ID)) === null || _a === void 0 ? void 0 : _a.remove();
        };
        _this.state = { selectedFileId: [], visible: true };
        return _this;
    }
    return FileSelectorMobile;
}(React.Component));

var css_248z$2 = ".index_file-content__vRsYZ{display:flex;flex-direction:column}.index_file-content__vRsYZ .index_file-title__tI3Jp{align-items:center;background-color:#fff;color:rgba(0,0,0,.64);display:flex;flex-direction:row;font-size:12px;justify-content:space-between;line-height:16px;margin:20px 26px 20px 20px}.index_file-content__vRsYZ .index_file-list__Rii-g{display:flex;flex-direction:column;height:400px;overflow-y:scroll}.index_file-content__vRsYZ .index_file-list__Rii-g .index_file-item__tln73{align-items:center;display:flex;flex-direction:row;height:54px;justify-content:space-between;padding-bottom:0}.index_file-content__vRsYZ .index_file-list__Rii-g .index_file-item__tln73:hover{background:#f9fafb}.index_file-content__vRsYZ .index_file-list__Rii-g .index_file-item__title__owmyE{align-items:center;color:rgba(0,0,0,.88);display:flex;flex-direction:row;font-size:14px;font-style:normal;font-weight:400;line-height:20px}.index_file-content__vRsYZ .index_file-list__Rii-g .index_file-item__title-icon__2G9Po{height:16px;margin-right:8px;width:16px}.index_file-content__vRsYZ .index_file-list__Rii-g .index_file-item__title-text__7I67g{overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:232px}.index_file-content__vRsYZ .index_file-list__Rii-g .index_file-item__title-more__iJOxu{display:none;height:24px;margin:auto 10px;width:24px}.index_file-content__vRsYZ .index_file-list__Rii-g .index_file-item__title-more__iJOxu:hover{background:rgba(51,77,102,.06);cursor:pointer}.index_file-content__vRsYZ .index_file-list__Rii-g .index_file-item__content__advkj{color:rgba(0,0,0,.4);font-size:12px;font-style:normal;font-weight:400;line-height:16px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.index_file-name__q-HQq{display:flex;justify-content:start;width:290px}.index_file-owner__G0obn{display:flex;justify-content:start;margin-right:10px;width:92px}.index_file-timestamp__V4v7L{display:flex;justify-content:end;width:94px}.index_file-choose-footer__sMrYk{align-items:center;background-color:#fff;bottom:0;display:flex;height:84px;justify-content:space-between;position:fixed;width:512px}.index_file-choose-footer__tips__xKcAK{color:#666;font-size:14px}.index_file-choose-footer__button__Ae0E8{display:flex;justify-content:space-between;width:248px}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL2FkZG9uLWZpbGUtc2VsZWN0b3IvZmlsZS1zZWxlY3Rvci1wYy9pbmRleC5sZXNzIiwiaW5kZXgubGVzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSwyQkFDRSxZQUFBLENBRUEscUJDQUYsQ0RIQSxvREFVSSxrQkFBQSxDQUtBLHFCQUFBLENBREEscUJBQUEsQ0FSQSxZQUFBLENBRUEsa0JBQUEsQ0FHQSxjQUFBLENBRkEsNkJBQUEsQ0FHQSxnQkFBQSxDQUNBLDBCQ0NKLENEZEEsbURBb0JJLFlBQUEsQ0FFQSxxQkFBQSxDQUhBLFlBQUEsQ0FJQSxpQkNISixDRHBCQSwyRUErQk0sa0JBQUEsQ0FKQSxZQUFBLENBRUEsa0JBQUEsQ0FIQSxXQUFBLENBSUEsNkJBQUEsQ0FFQSxnQkNKTixDRE1NLGlGQUNFLGtCQ0pSLENET00sa0ZBSUUsa0JBQUEsQ0FLQSxxQkFBQSxDQVJBLFlBQUEsQ0FFQSxrQkFBQSxDQUlBLGNBQUEsQ0FGQSxpQkFBQSxDQUNBLGVBQUEsQ0FFQSxnQkNMUixDRFNNLHVGQUVFLFdBQUEsQ0FDQSxnQkFBQSxDQUZBLFVDTFIsQ0RVTSx1RkFFRSxlQUFBLENBQ0Esc0JBQUEsQ0FDQSxrQkFBQSxDQUhBLFdDTFIsQ0RXTSx1RkFJRSxZQUFBLENBSEEsV0FBQSxDQUVBLGdCQUFBLENBREEsVUNQUixDRFdRLDZGQUNFLDhCQUFBLENBQ0EsY0NUVixDRGFNLG9GQUtFLG9CQUFBLENBRkEsY0FBQSxDQUZBLGlCQUFBLENBQ0EsZUFBQSxDQUVBLGdCQUFBLENBRUEsZUFBQSxDQUNBLHNCQUFBLENBQ0Esa0JDWFIsQ0RpQkEsd0JBRUUsWUFBQSxDQUNBLHFCQUFBLENBRkEsV0NiRixDRGtCQSx5QkFFRSxZQUFBLENBQ0EscUJBQUEsQ0FDQSxpQkFBQSxDQUhBLFVDYkYsQ0RtQkEsNkJBRUUsWUFBQSxDQUNBLG1CQUFBLENBRkEsVUNmRixDRG9CQSxpQ0FPRSxrQkFBQSxDQUNBLHFCQUFBLENBTEEsUUFBQSxDQUZBLFlBQUEsQ0FLQSxXQUFBLENBSkEsNkJBQUEsQ0FFQSxjQUFBLENBQ0EsV0NmRixDRG9CRSx1Q0FFRSxVQUFBLENBREEsY0NqQkosQ0RxQkUseUNBRUUsWUFBQSxDQUNBLDZCQUFBLENBRkEsV0NqQkoiLCJmaWxlIjoiaW5kZXgubGVzcyJ9 */";
var styles$2 = {"file-content":"index_file-content__vRsYZ","file-title":"index_file-title__tI3Jp","file-list":"index_file-list__Rii-g","file-item":"index_file-item__tln73","file-item__title":"index_file-item__title__owmyE","file-item__title-icon":"index_file-item__title-icon__2G9Po","file-item__title-text":"index_file-item__title-text__7I67g","file-item__title-more":"index_file-item__title-more__iJOxu","file-item__content":"index_file-item__content__advkj","file-name":"index_file-name__q-HQq","file-owner":"index_file-owner__G0obn","file-timestamp":"index_file-timestamp__V4v7L","file-choose-footer":"index_file-choose-footer__sMrYk","file-choose-footer__tips":"index_file-choose-footer__tips__xKcAK","file-choose-footer__button":"index_file-choose-footer__button__Ae0E8","file___content":"index_file-content__vRsYZ","file___title":"index_file-title__tI3Jp","file___list":"index_file-list__Rii-g","file___item":"index_file-item__tln73","file___item__title":"index_file-item__title__owmyE","file___item__title___icon":"index_file-item__title-icon__2G9Po","file___item__title___text":"index_file-item__title-text__7I67g","file___item__title___more":"index_file-item__title-more__iJOxu","file___item__content":"index_file-item__content__advkj","file___name":"index_file-name__q-HQq","file___owner":"index_file-owner__G0obn","file___timestamp":"index_file-timestamp__V4v7L","file___choose___footer":"index_file-choose-footer__sMrYk","file___choose___footer__tips":"index_file-choose-footer__tips__xKcAK","file___choose___footer__button":"index_file-choose-footer__button__Ae0E8"};
styleInject(css_248z$2);

var FileSelectorPC = /** @class */ (function (_super) {
    __extends(FileSelectorPC, _super);
    function FileSelectorPC(props) {
        var _this = _super.call(this, props) || this;
        _this.render = function () {
            var _a = _this.props, addonId = _a.addonId, fileList = _a.fileList, confirmText = _a.confirmText, maxSelectNum = _a.maxSelectNum, filterType = _a.filterType, onConfirm = _a.onConfirm, onCancel = _a.onCancel;
            var _b = _this.state, visible = _b.visible, selectedFileId = _b.selectedFileId;
            return (React.createElement(Modal$1, { title: $t('选择腾讯文档'), zIndex: MODAL_Z_INDEX, style: { width: 560, height: 600 }, footer: _this.renderFileSelectFooter(addonId, onConfirm, confirmText), visible: visible, onClose: function () {
                    _this.onModalClose();
                    onCancel();
                }, destroyOnClose: true },
                React.createElement("div", { className: styles$2['file-content'] },
                    React.createElement("div", { className: styles$2['file-title'] },
                        React.createElement("div", { className: styles$2['file-name'] }, $t('名称')),
                        React.createElement("div", { className: styles$2['file-owner'] }, $t('来自')),
                        React.createElement("div", { className: styles$2['file-timestamp'] }, $t('最近查看'))),
                    React.createElement(Divider$1, null),
                    React.createElement(Checkbox$1.Group, { className: styles$2['file-list'], onChange: function (value) { return _this.setState({ selectedFileId: value }); } }, fileList.map(function (item) {
                        // 需要过滤符合插件需求的文件类型
                        var isFilter;
                        if (Array.isArray(filterType)) {
                            isFilter = filterType.includes(item.docType);
                        }
                        else {
                            isFilter = filterType === '' || item.docType === filterType;
                        }
                        if (isFilter) {
                            return (React.createElement(Checkbox$1, { value: item.fileID, shape: "circle", iconStyle: { top: '18px' }, style: { paddingBottom: 0 }, disabled: selectedFileId.length === maxSelectNum
                                    && selectedFileId.filter(function (element) { return item.fileID === element; }).length === 0 },
                                React.createElement("div", { className: styles$2['file-item'] },
                                    React.createElement("div", { className: "".concat(styles$2['file-item__title'], " ").concat(styles$2['file-name']) },
                                        React.createElement("img", { src: item.icon, className: styles$2['file-item__title-icon'] }),
                                        React.createElement("div", { className: styles$2['file-item__title-text'] }, item.fileName)),
                                    React.createElement("div", { className: "".concat(styles$2['file-item__content'], " ").concat(styles$2['file-owner']) }, item.OwnerName),
                                    React.createElement("div", { className: "".concat(styles$2['file-item__content'], " ").concat(styles$2['file-timestamp']) }, getFileDate(Number(item.lastAccessTime) === 0 ? item.lastModifyTime : item.lastAccessTime))),
                                React.createElement(Divider$1, null)));
                        }
                        return React.createElement(Fragment, null);
                    })))));
        };
        // 文件选择列表页脚
        _this.renderFileSelectFooter = function (addonId, successCallback, confirmText) { return (React.createElement("div", { className: styles$2['file-choose-footer'] },
            React.createElement("div", { className: styles$2['file-choose-footer__tips'] }, $t('已经选择{{$number}}个文件', { $number: _this.state.selectedFileId.length })),
            React.createElement("div", { className: styles$2['file-choose-footer__button'] },
                React.createElement(Button$1, { onClick: function () {
                        return tencentDocOpenUrlForAll({ url: "".concat(FILE_MANAGER_URL, "/?clientID=").concat(addonId, "&operate=openfilelist") });
                    } }, $t('修改授件范围')),
                React.createElement(Button$1, { type: "primary", onClick: function () {
                        var selectedFileIdSet = new Set(_this.state.selectedFileId);
                        var selectedFileList = _this.props.fileList.filter(function (item) { return selectedFileIdSet.has(item.fileID); });
                        successCallback(selectedFileList);
                        _this.onModalClose();
                    } }, confirmText)))); };
        _this.onModalClose = function () {
            var _a;
            _this.setState({ visible: false });
            (_a = document.getElementById(FILE_SELECTOR_DOM_ID)) === null || _a === void 0 ? void 0 : _a.remove();
        };
        _this.state = { selectedFileId: [], visible: true };
        return _this;
    }
    return FileSelectorPC;
}(React.Component));

/**
 * 插件文件选择器
 */
var FileSelectorComponent = /** @class */ (function (_super) {
    __extends(FileSelectorComponent, _super);
    function FileSelectorComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FileSelectorComponent.prototype.render = function () {
        if (ua.isMobile) {
            return React.createElement(FileSelectorMobile, __assign({}, this.props));
        }
        return React.createElement(FileSelectorPC, __assign({}, this.props));
    };
    return FileSelectorComponent;
}(React.Component));

var FileSelector;
(function (FileSelector) {
    (function (DocType) {
        // 在线文档
        DocType[DocType["DOC"] = 0] = "DOC";
        // 在线表格
        DocType[DocType["SHEET"] = 1] = "SHEET";
        // 在线收集表
        DocType[DocType["FORM"] = 2] = "FORM";
        // 文件夹类型
        DocType[DocType["FOLDER"] = 3] = "FOLDER";
        // 在线ppt
        DocType[DocType["SLIDE"] = 4] = "SLIDE";
        // 笔记
        DocType[DocType["NOTE"] = 5] = "NOTE";
        // 在线pdf
        DocType[DocType["PDF"] = 6] = "PDF";
        // 文档小应用
        DocType[DocType["AIO"] = 7] = "AIO";
        // 未知类型
        DocType[DocType["UNKNOW"] = 10] = "UNKNOW";
        // ProcessOn 思维导图
        DocType[DocType["MINDMAP"] = 90] = "MINDMAP";
        // ProcessOn 流程图
        DocType[DocType["FLOWCHART"] = 91] = "FLOWCHART";
        // drive云盘
        DocType[DocType["DRIVE"] = 101] = "DRIVE";
        // 语音速记
        DocType[DocType["REC"] = 102] = "REC";
    })(FileSelector.DocType || (FileSelector.DocType = {}));
})(FileSelector || (FileSelector = {}));
// docs-components-drive-selector 筛选文档类型
var TencentDocMimeType;
(function (TencentDocMimeType) {
    /** 协作空间 */
    TencentDocMimeType["TencentCollaborationSpace"] = "application/vnd.tdocs-apps.collaboration-space";
    /** 文件夹 */
    TencentDocMimeType["TencentFolder"] = "application/vnd.tdocs-apps.folder";
    /** Doc 文档 */
    TencentDocMimeType["TencentDoc"] = "application/vnd.tdocs-apps.doc";
    /** Sheet 电子表格 */
    TencentDocMimeType["TencentSheet"] = "application/vnd.tdocs-apps.sheet";
    /** Slide 幻灯片 */
    TencentDocMimeType["TencentSlide"] = "application/vnd.tdocs-apps.slide";
    /** PDF */
    TencentDocMimeType["PDF"] = "application/pdf";
    /** Form 收集表 */
    TencentDocMimeType["TencentForm"] = "application/vnd.tdocs-apps.form";
    /** ProcessOn 脑图 */
    TencentDocMimeType["ProcessOnMindMap"] = "application/vnd.tdocs-apps.mind";
    /** ProcessOn 流程图 */
    TencentDocMimeType["ProcessOnFlowChart"] = "application/vnd.tdocs-apps.flowchart";
    /** 搜狗语音速记 */
    TencentDocMimeType["SogouSpeech"] = "application/vnd.tdocs-apps.rec";
    /** SmartCanvas 智能画布 */
    TencentDocMimeType["SmartCanvas"] = "application/vnd.tdocs-apps.smartcanvas";
})(TencentDocMimeType || (TencentDocMimeType = {}));

var _a$2;
// 移动端 drive file selector DocType 映射 drive selector MimeType
var DocTypeToMimeType = (_a$2 = {},
    _a$2[FileSelector.DocType.DOC] = TencentDocMimeType.TencentDoc,
    _a$2[FileSelector.DocType.SHEET] = TencentDocMimeType.TencentSheet,
    _a$2[FileSelector.DocType.FORM] = TencentDocMimeType.TencentForm,
    _a$2[FileSelector.DocType.FOLDER] = TencentDocMimeType.TencentFolder,
    _a$2[FileSelector.DocType.SLIDE] = TencentDocMimeType.TencentSlide,
    _a$2[FileSelector.DocType.MINDMAP] = TencentDocMimeType.ProcessOnMindMap,
    _a$2[FileSelector.DocType.FLOWCHART] = TencentDocMimeType.ProcessOnFlowChart,
    _a$2[FileSelector.DocType.PDF] = TencentDocMimeType.PDF,
    _a$2);

var css_248z$1 = ".index_file-modal__2Rnm3{width:450px}.index_file-modal-footer__i-tfE{display:flex;justify-content:space-between;width:400px}.index_mobile-modal-footer__EB-Mj{color:rgba(0,0,0,.88);font-size:18px;font-weight:400;line-height:24px;width:100%}.index_mobile-modal-footer__item__nDv4O{display:flex;justify-content:center}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9maWxlLWF1dGgtbWFuYWdlci9pbmRleC5sZXNzIiwiaW5kZXgubGVzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSx5QkFDRSxXQ0NGLENERUEsZ0NBRUUsWUFBQSxDQUNBLDZCQUFBLENBRkEsV0NFRixDREdBLGtDQUtFLHFCQUFBLENBSEEsY0FBQSxDQUNBLGVBQUEsQ0FDQSxnQkFBQSxDQUhBLFVDR0YsQ0RHRSx3Q0FDRSxZQUFBLENBQ0Esc0JDREoiLCJmaWxlIjoiaW5kZXgubGVzcyJ9 */";
var styles$1 = {"file-modal":"index_file-modal__2Rnm3","file-modal-footer":"index_file-modal-footer__i-tfE","mobile-modal-footer":"index_mobile-modal-footer__EB-Mj","mobile-modal-footer__item":"index_mobile-modal-footer__item__nDv4O","file___modal":"index_file-modal__2Rnm3","file___modal___footer":"index_file-modal-footer__i-tfE","mobile___modal___footer":"index_mobile-modal-footer__EB-Mj","mobile___modal___footer__item":"index_mobile-modal-footer__item__nDv4O"};
styleInject(css_248z$1);

/**
 * 管理插件文件授权
 */
var FileManager = /** @class */ (function () {
    function FileManager() {
        var _this = this;
        // 处理文件授权
        this.handleFileAuth = function (addonId, addonName, successCallback, failCallback, filterType) {
            // 打开授权弹窗
            _this.modal = ua.isPC
                ? Modal$1.confirm({
                    title: $t('授权给「{{addonName}}」的文件', { addonName: addonName }),
                    content: $t('「{{addonName}}」想访问你的腾讯文档帐号下的文件，是否允许？', { addonName: addonName }),
                    style: { width: 450 },
                    zIndex: MODAL_Z_INDEX,
                    footer: _this.renderAuthFooter(addonId, successCallback, failCallback, filterType),
                })
                : Modal.confirm({
                    zIndex: MODAL_Z_INDEX,
                    title: $t('授权给「{{addonName}}」的文件', { addonName: addonName }),
                    content: $t('「{{addonName}}」想访问你的腾讯文档帐号下的文件，是否允许？', { addonName: addonName }),
                    footer: _this.renderMobileAuthFooter(addonId, successCallback, failCallback, filterType),
                });
        };
        // 处理文件选择
        this.handlePartFileSelect = function (addonId, fileList, confirmText, maxSelectNum, filterType, onConfirm, onCancel) {
            var rootContainer = document.createElement('div');
            document.body.appendChild(rootContainer);
            rootContainer.id = FILE_SELECTOR_DOM_ID;
            ReactDOM.render(React.createElement(FileSelectorComponent, { addonId: addonId, fileList: fileList, confirmText: confirmText, maxSelectNum: maxSelectNum, filterType: filterType, onConfirm: onConfirm, onCancel: onCancel }), rootContainer);
        };
        this.transformFilterType = function (filterType) {
            if (!filterType) {
                return;
            }
            if (typeof filterType === 'string') {
                return [filterType];
            }
            if (typeof filterType === 'number') {
                return [DocTypeToMimeType[filterType]].filter(function (item) { return !!item; });
            }
            if (Array.isArray(filterType)) {
                return filterType.map(function (item) { return DocTypeToMimeType[item]; }).filter(function (item) { return !!item; });
            }
            return;
        };
        // 自定义文件授权询问弹窗的 footer
        this.renderAuthFooter = function (addonId, successCallback, failCallback, filterType) { return (React.createElement("div", { className: styles$1['file-modal-footer'] },
            React.createElement(Button$1, { onClick: function () { return _this.onRejectClick(failCallback); } }, $t('不允许')),
            DocManager.getDocData().metaInfo.fileType === FileType.SUITE ? (React.createElement(Button$1, { onClick: function () { return _this.onAllowPartFilesClick(addonId, filterType !== null && filterType !== void 0 ? filterType : '', successCallback, failCallback); } }, $t('授权部分文件'))) : (React.createElement(Button$1, { onClick: function () { return _this.onAllowThisFileClick(addonId, successCallback, failCallback); } }, $t('授权当前文件'))),
            React.createElement(Button$1, { type: "primary", onClick: function () { return _this.onAllowAllFilesClick(addonId, successCallback, failCallback); } }, $t('授权所有文件')))); };
        // 自定义文件授权询问弹窗的 footer
        this.renderMobileAuthFooter = function (addonId, successCallback, failCallback, filterType) { return (React.createElement("div", { className: styles$1['mobile-modal-footer'] },
            React.createElement(Divider, null),
            React.createElement("div", { onClick: function () { return _this.onAllowAllFilesClick(addonId, successCallback, failCallback); }, className: styles$1['mobile-modal-footer__item'], style: { fontWeight: 500 } }, $t('授权所有文件')),
            React.createElement(Divider, null),
            DocManager.getDocData().metaInfo.fileType === FileType.SUITE ? (React.createElement("div", { onClick: function () { return _this.onAllowPartFilesClick(addonId, filterType !== null && filterType !== void 0 ? filterType : '', successCallback, failCallback); }, className: styles$1['mobile-modal-footer__item'] }, $t('授权部分文件'))) : (React.createElement("div", { onClick: function () { return _this.onAllowThisFileClick(addonId, successCallback, failCallback); }, className: styles$1['mobile-modal-footer__item'] }, $t('授权当前文件'))),
            React.createElement(Divider, null),
            React.createElement("div", { onClick: function () { return _this.onRejectClick(failCallback); }, className: styles$1['mobile-modal-footer__item'], style: { marginBottom: '8px' } }, $t('不允许')))); };
        // 不允许授权
        this.onRejectClick = function (failCallback) {
            failCallback();
            _this.modal.close();
        };
        // 授权当前文件
        this.onAllowThisFileClick = function (addonId, successCallback, failCallback) { return __awaiter(_this, void 0, void 0, function () {
            var params;
            var _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _c.trys.push([0, 2, , 3]);
                        params = {
                            clientID: addonId,
                            fileAuthType: FileAuthType.PART,
                            updateType: FileAuthUpdateType.ADD,
                            fileIDs: (_b = DocManager.getDocData().metaInfo.fileId) === null || _b === void 0 ? void 0 : _b.replace(/\d+\$/i, ''),
                        };
                        return [4 /*yield*/, authFiles(params)];
                    case 1:
                        _c.sent();
                        successCallback();
                        return [3 /*break*/, 3];
                    case 2:
                        _c.sent();
                        failCallback();
                        return [3 /*break*/, 3];
                    case 3:
                        this.modal.close();
                        return [2 /*return*/];
                }
            });
        }); };
        // 授权部分文件
        this.onAllowPartFilesClick = function (addonId, filterType, successCallback, failCallback) { return __awaiter(_this, void 0, void 0, function () {
            var extension;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, getArkExtension({ name: ARK_FILE_SELECTOR_COMPONENT })];
                    case 1:
                        extension = _b.sent();
                        extension.showSelector({
                            zIndex: MODAL_Z_INDEX,
                            filterType: filterType,
                            confirmText: $t('确定'),
                            maxSelector: MAX_SELECTOR_FILE,
                            onConfirm: function (fileList) { return __awaiter(_this, void 0, void 0, function () {
                                var fileIDs, params;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            fileIDs = fileList.map(function (item) { return item.padID; }).join(',');
                                            _b.label = 1;
                                        case 1:
                                            _b.trys.push([1, 3, , 4]);
                                            params = {
                                                clientID: addonId,
                                                fileAuthType: FileAuthType.PART,
                                                updateType: FileAuthUpdateType.ADD,
                                                fileIDs: String(fileIDs),
                                            };
                                            return [4 /*yield*/, authFiles(params)];
                                        case 2:
                                            _b.sent();
                                            successCallback();
                                            return [3 /*break*/, 4];
                                        case 3:
                                            _b.sent();
                                            failCallback();
                                            return [3 /*break*/, 4];
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); },
                            onCancel: function () { return failCallback(); },
                        });
                        this.modal.close();
                        return [2 /*return*/];
                }
            });
        }); };
        // 授权所有文件
        this.onAllowAllFilesClick = function (addonId, successCallback, failCallback) { return __awaiter(_this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        params = {
                            clientID: addonId,
                            fileAuthType: FileAuthType.ALL,
                        };
                        return [4 /*yield*/, authFiles(params)];
                    case 1:
                        _b.sent();
                        successCallback();
                        return [3 /*break*/, 3];
                    case 2:
                        _b.sent();
                        failCallback();
                        return [3 /*break*/, 3];
                    case 3:
                        this.modal.close();
                        return [2 /*return*/];
                }
            });
        }); };
    }
    // 打开本地文件选择器，目前仅支持微信或者 QQ 小程序环境
    FileManager.prototype.openPlatformFileSelector = function (addonId) {
        if (!ua.isMiniProgram && !ua.isQQMiniProgram) {
            throw new Error('操作失败，目前仅支持微信或者 QQ 小程序环境');
        }
        var openURL = getOpenPlatformFileSelectorURL(addonId, {
            fileType: String(DocManager.getMetaInfo().fileType),
            aidPosition: DocManager.getAidPosition(),
        });
        MiniApp.redirectTo({ url: openURL });
    };
    // 打开端腾讯文档选择器
    FileManager.prototype.openFileSelector = function (isMobile, options) {
        return __awaiter(this, void 0, void 0, function () {
            var selectorName, extension;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        selectorName = isMobile ? ARK_DRIVE_SELECTOR_MOBILE : ARK_FILE_SELECTOR_COMPONENT;
                        return [4 /*yield*/, getArkExtension({ name: selectorName })];
                    case 1:
                        extension = _b.sent();
                        return [2 /*return*/, new Promise(function (resolve, reject) {
                                var onConfirm = function (file) {
                                    resolve(strictFileField(file));
                                };
                                var onCancel = function () {
                                    reject(new Exception(AddonErrorCode.BACK_INNER_ERROR));
                                };
                                extension === null || extension === void 0 ? void 0 : extension.show(__assign(__assign({}, options), { onConfirm: onConfirm, onCancel: onCancel }));
                            })];
                }
            });
        });
    };
    FileManager.prototype.getSelectedFileIds = function () {
        var fileId = URLParse(window.location.href, true).query.file_id;
        return fileId ? [fileId] : [];
    };
    var _a;
    _a = FileManager;
    // 单例实现
    FileManager.getInstance = function () {
        if (!_a.instance) {
            _a.instance = new FileManager();
        }
        return _a.instance;
    };
    return FileManager;
}());

var authorize = function (addon) {
    return new Promise(function (resolve, reject) {
        // 权限弹窗链接需要是使用正式环境 addonId
        var prodAddonId = getEnvAddonId(addon.addonId, AddonEnvironmentType.PRODUCTION);
        AddonAuthManager.getInstance().handleAddonAuth(prodAddonId, function () {
            resolve();
        }, function () {
            reject(new Exception(AddonErrorCode.ADDON_NOT_AUTHORIZE));
        });
    });
};
var fileAuth = function (addon) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, new Promise(function (resolve, reject) {
                // 权限弹窗链接需要是使用正式环境 addonId
                var prodAddonId = getEnvAddonId(addon.addonId, AddonEnvironmentType.PRODUCTION);
                FileManager.getInstance().handleFileAuth(prodAddonId, addon.name, resolve, function () {
                    return reject(new Exception(AddonErrorCode.ADDON_NOT_AUTHORIZE));
                });
            })];
    });
}); };
// 判断是否需要发起文件授权流程
var needAuthFile = function (addonId) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, fileType, fileId, prodAddonId, _b, fileAuthType, list;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                if (!isConsumerEnv()) {
                    return [2 /*return*/, false];
                }
                _a = DocManager.getDocData().metaInfo, fileType = _a.fileType, fileId = _a.fileId;
                if (!(fileType !== FileType.SUITE)) return [3 /*break*/, 2];
                prodAddonId = getEnvAddonId(addonId, AddonEnvironmentType.PRODUCTION);
                return [4 /*yield*/, getAuthorizedFiles(prodAddonId)];
            case 1:
                _b = _c.sent(), fileAuthType = _b.fileAuthType, list = _b.list;
                // 当前插件未授权任何文件，或授权部分但未授权当前文件需要调起授权流程（匹配 fileId 时需要去掉前面的数字和 $）
                return [2 /*return*/, ((fileAuthType === FileAuthType.PART && !list.find(function (item) { return item.fileID === (fileId === null || fileId === void 0 ? void 0 : fileId.replace(/\d+\$/i, '')); }))
                        || fileAuthType === FileAuthType.NONE)];
            case 2: return [2 /*return*/, false];
        }
    });
}); };
var addonAuthorized = function (addonId) { return __awaiter(void 0, void 0, void 0, function () {
    var addon, isNeedAuthFile;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, AddonManager$1.getInstance().getAddon(addonId, { needInstalled: false })];
            case 1:
                addon = _a.sent();
                // 私有化不需要授权
                if (isPrivateEnv()) {
                    return [2 /*return*/, addon];
                }
                return [4 /*yield*/, authorize(addon)];
            case 2:
                _a.sent();
                return [4 /*yield*/, needAuthFile(addonId)];
            case 3:
                isNeedAuthFile = _a.sent();
                if (!isNeedAuthFile) return [3 /*break*/, 5];
                return [4 /*yield*/, fileAuth(addon)];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/, addon];
        }
    });
}); };
function executeActionWithAuth(addonId, action) {
    return __awaiter(this, void 0, void 0, function () {
        var addon, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // 如果 Action 不合法则直接抛出异常
                    if (!Object.values(ActionName).includes(action.name)) {
                        return [2 /*return*/, Promise.reject(new Exception(AddonErrorCode.ADDON_ARGUMENTS_ENUM_NOT_MATCH))];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, addonAuthorized(addonId)];
                case 2:
                    addon = _a.sent();
                    new ActionActuator(addon).executeActions([
                        {
                            funcName: action.name,
                            funcArgs: [action.options],
                        },
                    ]);
                    return [2 /*return*/, { data: null, ret: AddonErrorCode.SUCCESS, msg: '' }];
                case 3:
                    e_1 = _a.sent();
                    return [2 /*return*/, { data: null, ret: AddonErrorCode.CALL_ADDON_API_ERROR, msg: e_1.message }];
                case 4: return [2 /*return*/];
            }
        });
    });
}

function fileTypeToAddonPanelType(fileType) {
    var fileTypeDes = getFileTypeDes(fileType);
    if (fileTypeDes === FileTypeDes.SUITE) {
        return 'desktop';
    }
    return fileTypeDes;
}

/**
 * 带 ⭐️ 是用来记录后台的记录为空白的情况，前端赋予的一个值，达到前后台一致的目的
 */

var WordMimeTypes = [
/**
 * (.doc | .dot）微软 Office Word 格式（Microsoft Word 97 - 2004 document）
 */
'application/msword',
/**
 * (.docx) 微软 Office Word 文档格式
 */
'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
/**
 *  (.wps) 金山 Office 文字排版文件格式
 */
'application/kswps',
/**
 * (.wpt) 金山 Office 文字排版文件格式模板
 */
'application/kswpt',
/**
 * (.dotx) 微软 Office Word 文档格式模板
 */
'application/vnd.openxmlformats-officedocument.wordprocessingml.template',
/**
 * (.docm) Microsoft Word macro-enabled document
 */
'application/vnd.ms-word.document.macroEnabled.12',
/**
 * (.dotm) Microsoft Word macro-enabled document template
 */
'application/vnd.ms-word.template.macroEnabled.12'];
var ExcelMimeTypes = [
/**
 * (.xls .xlm .xla .xlc .xlt .xlw) 微软 Office Excel 格式（Microsoft Excel 97 - 2004 Workbook
 */
'application/vnd.ms-excel',
/**
 * (.xlsx) 微软 Office Excel 文档格式
 */
'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
/**
 * (.xltx) 微软 Office Excel 文档格式模板
 */
'application/vnd.openxmlformats-officedocument.spreadsheetml.template',
/*
 * (.csv) CSV 文件
 */
'text/csv', 'text/csv; charset=utf-8',
/**
 * (.xlsb) An XLSB file is a spreadsheet workbook created by Microsoft Excel
 */
'application/vnd.ms-excel.sheet.binary.macroEnabled.12',
/**
 * (.xlsm) An XLSM file is a macro-enabled spreadsheet created by Microsoft Excel
 */
'application/vnd.ms-excel.sheet.macroEnabled.12',
/**
 * (.xltm) An XLTM file is a macro-enabled spreadsheet template created by Microsoft Excel
 */
'application/vnd.ms-excel.template.macroEnabled.12',
/**
 * (.et) 金山 Office 表格文件格式
 */
'application/kset',
/**
 * (.ett) 金山 Office 表格文件格式模板
 */
'application/ksett'];
var PowerPointMimeTypes = [
/**
 * (.pptx) 微软 Office PowerPoint 文稿格式
 */
'application/vnd.openxmlformats-officedocument.presentationml.presentation',
/**
 * (.ppt .pps .pot) 微软 Office PowerPoint 格式（Microsoft PowerPoint 97 - 2003 演示文稿
 */
'application/vnd.ms-powerpoint',
/**
 * (.potx) Microsoft PowerPoint template
 */
'application/vnd.openxmlformats-officedocument.presentationml.template',
/**
 * (.ppsx) Microsoft PowerPoint slideshow
 */
'application/vnd.openxmlformats-officedocument.presentationml.slideshow',
/**
 * (.dps) 金山 Office 演示文稿格式
 */
'application/ksdps',
/**
 * (.dpt) 金山 Office 演示文稿格式模板
 */
'application/ksdpt',
/**
 * (.pptm) A PPTM file is a macro-enabled presentation created by Microsoft PowerPoint
 */
'application/vnd.ms-powerpoint.presentation.macroEnabled.12',
/**
 * (.potm) A POTM file is a macro-enabled presentation template created by Microsoft PowerPoint
 */
'application/vnd.ms-powerpoint.template.macroEnabled.12',
/**
 * (.ppsm) A PPSM file is a macro-enabled slide show created by Microsoft PowerPoint
 */
'application/vnd.ms-powerpoint.slideshow.macroEnabled.12'];
var TextMimeTypes = [
/**
 * (.lrc) 音乐歌词文件 ⭐️
 */
'text/lrc',
/**
 * (.asp) asp 程序文件
 */
'text/asp; charset=utf-8',
/**
 * (.bat .cmd .btm) ⭐️
 */
'application/x-msdownload',
/**
 * (.rtf) Rich Text Format file  ⭐️
 */
'text/richtext; charset=utf-8',
/**
 * (.bas, .txt, .log) BASIC Source Code
 */
'text/plain', 'text/plain; charset=utf-8',
/**
 * .xml
 */
'text/xml',
/**
 * (.htm, .html)
 */
'text/html', 'text/html; charset=utf-8',
/**
 * (.md)
 */
'text/markdown'];
var CodeMimeTypes = [
/**
 * (.c) ⭐️
 */
'text/x-c; charset=utf-8',
/**
 * (.cpp) ⭐️
 */
'text/x-c; charset=utf-8',
/**
 * (.h) ⭐️
 */
'text/x-chdr',
/**
 * (.asm , .s) ⭐️
 */
'text/x-asm; charset=utf-8',
/**
 * (.java) ⭐️
 */
'text/x-java-source; charset=utf-8',
/**
 * (.js, .jsx ,.ts ,.tsx) ⭐️
 */
'text/javascript',
/**
 * (.go)
 */
'text/x-go'];
var ImageMimeTypes = [
/**
 * (.raw) ⭐️
 * https://stackoverflow.com/questions/43473056/which-mime-type-should-be-used-for-a-raw-image#:~:text=GNOME%20RAW%20Thumbnailer%20project%2C%20the,image%2Fx%2Dsony%2Darw
 */
'image/x-sony-arw',
/**
 * (.bmp)
 */
'image/bmp',
/**
 * (.pcx)
 */
'image/vnd.zbrush.pcx', 'image/x-pcx',
/**
 * (.image/tiff)
 */
'image/tiff',
/**
 * (.gif)
 */
'image/gif',
/**
 * (.exif) ⭐️
 */
'image/x-exif',
/**
 *  (.jpeg jpg)
 */
'image/jpeg',
/**
 *  (.fpx)
 * https://www.fileformat.info/info/mimetype/image/vnd.fpx/index.htm
 */
'image/vnd.fpx',
/**
 * (.svg)
 */
'image/svg+xml',
/**
 * (.psd)
 */
'image/vnd.adobe.photoshop',
/**
 * (.cdr) ⭐️
 */
'image/x-cdr',
/** *
 * (.pcd) ⭐️
 */
'image/x-photo-cd',
/**
 * (.dxf)
 */
'image/vnd.dxf',
/**
 * (.ufo) ⭐️
 * https://fileinfo.com/extension/ufo
 */
'image/x-ufo',
/** *
 * .eps
 */
'application/postscript',
/**
 * (.png)
 */
'image/png',
/**
 * (.wmf)
 */
'image/wmf',
/**
 * (.webp)
 */
'image/webp',
/**
 * (.tga)
 */
'image/x-tga'];
var AudioMimeTypes = [
/**
 * (.mp3,.mpeg)
 */
'audio/mpeg',
/**
 * (.acc)
 */
'audio/aac',
/**
 * (.flac)
 */
'audio/x-flac',
/**
 * (.amr)
 */
'audio/amr', 'audio/AMR',
/**
 * (m4a, m4b)
 * https://stackoverflow.com/a/39898145
 */
'audio/mp4',
/**
 * (.wma)
 */
'audio/x-ms-wma',
/**
 * (.wav)
 */
'audio/x-wav',
/**
 * (.cd) ⭐️
 */
'audio/x-cd',
/**
 * (.wave) ⭐️
 */
'audio/x-wave',
/**
 * (.aiff)
 */
'audio/x-aiff',
/**
 * (.midi)
 */
'audio/midi',
/**
 * (.ra)
 */
'audio/x-realaudio',
/**
 * (.vqf)
 * https://en.wikipedia.org/wiki/TwinVQ
 */
'audio/x-twinvq',
/**
 * (.ogg)
 */
'audio/ogg',
/**
 * (.ape) ⭐️
 * http://www.wikidata.org/entity/Q1064017
 */
'audio/x-ape',
/**
 * (.weba) ⭐️
 * https://fileinfo.com/extension/weba
 */
'audio/webm',
/**
 * (mpeg-4)
 */
'audio/mpeg-4'];
var VideoMimeTypes = [
/**
 * (.mp4) ⭐️
 * (.m4v https://stackoverflow.com/a/15279480)
 */
'video/mp4',
/**
 * (.3gp)
 */
'video/3gpp',
/**
 * (.asf, .asx) ⭐️
 */
'video/x-ms-asf',
/**
 * (.avi)
 */
'video/x-msvideo',
/**
 * (.dv)
 */
'video/dv',
/**
 * (.flv)
 */
'video/x-flv',
/**
 * (.f4v) ⭐️
 */
'video/x-f4v',
/**
 * (.m3u8)
 */
'application/vnd.apple.mpegurl',
/**
 * (.mkv)
 */
'video/x-matroska',
/**
 * (.qt , .mov)
 */
'video/quicktime',
/**
 * (.mpg, .mpeg)
 */
'video/mpeg',
/**
 * (.mts https://en.wikipedia.org/wiki/.m2ts)
 */
'video/mp2t',
/**
 * (.rmvb)
 */
'application/vnd.rn-realmedia',
/**
 * (.rm)
 */
'audio/x-pn-realaudio',
/**
 * (.wmv)
 */
'video/x-ms-wmv',
/**
 * (.dat)
 */
'video/dat'];
var flowChatMimeTypes = ['application/vnd.ms-visio.drawing', 'application/x-visio', 'application/vnd.ms-visio.drawing.main+xml'];
var mindMimeTypes = ['application/vnd.pos'];

var _docTypeToMimeTypeMap, _drivePadTypeToMimeTy, _padTypeToMimeTypeMap;
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}
function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
// 常用的mimeType 需要单独枚举并导出
var MimeType = /*#__PURE__*/function (MimeType) {
  MimeType["Doc"] = "application/vnd.tdocs-apps.doc";
  MimeType["Sheet"] = "application/vnd.tdocs-apps.sheet";
  MimeType["Form"] = "application/vnd.tdocs-apps.form";
  MimeType["Folder"] = "application/vnd.tdocs-apps.folder";
  MimeType["CollaborationSpace"] = "application/vnd.tdocs-apps.collaboration-space";
  MimeType["CollaborationSpaceRoot"] = "application/vnd.tdocs-apps.collaboration-space-root";
  MimeType["SharedFolder"] = "application/vnd.tdocs-apps.shared-folder";
  MimeType["Share"] = "application/vnd.tdocs-apps.share-folder";
  MimeType["Slide"] = "application/vnd.tdocs-apps.slide";
  MimeType["Pdf"] = "application/pdf";
  MimeType["Aio"] = "application/vnd.tdocs-apps.aio";
  MimeType["SmartCanvas"] = "application/vnd.tdocs-apps.smartcanvas";
  MimeType["SmartSheet"] = "application/vnd.tdocs-apps.smartsheet";
  MimeType["Mind"] = "application/vnd.tdocs-apps.mind";
  MimeType["FlowChart"] = "application/vnd.tdocs-apps.flowchart";
  MimeType["Rec"] = "application/vnd.tdocs-apps.rec";
  MimeType["Word"] = "application/vnd.ms-word";
  MimeType["Excel"] = "application/vnd.ms-excel";
  MimeType["Powerpoint"] = "application/vnd.ms-powerpoint";
  MimeType["Zip"] = "application/zip";
  return MimeType;
}({});

/**
 * 历史遗留问题，保留一份
 */
var DocType = /*#__PURE__*/function (DocType) {
  DocType[DocType["Doc"] = 0] = "Doc";
  DocType[DocType["Sheet"] = 1] = "Sheet";
  DocType[DocType["Form"] = 2] = "Form";
  DocType[DocType["Folder"] = 3] = "Folder";
  DocType[DocType["Slide"] = 4] = "Slide";
  DocType[DocType["Pdf"] = 6] = "Pdf";
  DocType[DocType["Aio"] = 7] = "Aio";
  DocType[DocType["SmartCanvas"] = 8] = "SmartCanvas";
  DocType[DocType["Unknown"] = 10] = "Unknown";
  DocType[DocType["SmartSheet"] = 9] = "SmartSheet";
  DocType[DocType["Mind"] = 90] = "Mind";
  DocType[DocType["Flowchart"] = 91] = "Flowchart";
  DocType[DocType["FlowChart"] = 91] = "FlowChart";
  DocType[DocType["Drive"] = 101] = "Drive";
  DocType[DocType["Rec"] = 102] = "Rec";
  return DocType;
}({});
var PadType$1 = /*#__PURE__*/function (PadType) {
  PadType["Doc"] = "doc";
  PadType["Sheet"] = "sheet";
  PadType["Slide"] = "slide";
  PadType["Form"] = "form";
  PadType["Pdf"] = "pdf";
  PadType["Mind"] = "mind";
  PadType["FlowChart"] = "flowchart";
  PadType["Aio"] = "Aio";
  PadType["Folder"] = "folder";
  PadType["SmartCanvas"] = "smartcanvas";
  PadType["SmartSheet"] = "smartsheet";
  PadType["Drive"] = "drive";
  PadType["Rec"] = "rec";
  return PadType;
}({});
(_docTypeToMimeTypeMap = {}, _defineProperty(_docTypeToMimeTypeMap, DocType.Doc, MimeType.Doc), _defineProperty(_docTypeToMimeTypeMap, DocType.Sheet, MimeType.Sheet), _defineProperty(_docTypeToMimeTypeMap, DocType.Slide, MimeType.Slide), _defineProperty(_docTypeToMimeTypeMap, DocType.Form, MimeType.Form), _defineProperty(_docTypeToMimeTypeMap, DocType.SmartCanvas, MimeType.SmartCanvas), _defineProperty(_docTypeToMimeTypeMap, DocType.Mind, MimeType.Mind), _defineProperty(_docTypeToMimeTypeMap, DocType.FlowChart, MimeType.FlowChart), _defineProperty(_docTypeToMimeTypeMap, DocType.Rec, MimeType.Rec), _defineProperty(_docTypeToMimeTypeMap, DocType.Pdf, MimeType.Pdf), _defineProperty(_docTypeToMimeTypeMap, DocType.Aio, MimeType.Aio), _docTypeToMimeTypeMap);
[[WordMimeTypes, DocType.Doc], [ExcelMimeTypes, DocType.Sheet], [PowerPointMimeTypes, DocType.Slide], [[MimeType.Form], DocType.Form], [[MimeType.SmartCanvas], DocType.SmartCanvas], [[MimeType.SmartSheet], DocType.SmartSheet], [[MimeType.Doc], DocType.Doc], [[MimeType.Sheet], DocType.Sheet], [[MimeType.Slide], DocType.Slide], [[MimeType.Mind], DocType.Mind], [[MimeType.FlowChart], DocType.FlowChart], [CodeMimeTypes, DocType.Doc], [TextMimeTypes, DocType.Doc], [[MimeType.Pdf], DocType.Pdf], [flowChatMimeTypes, DocType.FlowChart], [mindMimeTypes, DocType.Mind], [[MimeType.Folder], DocType.Folder]];
(_drivePadTypeToMimeTy = {}, _defineProperty(_drivePadTypeToMimeTy, PadType$1.Doc, MimeType.Word), _defineProperty(_drivePadTypeToMimeTy, PadType$1.Sheet, MimeType.Excel), _defineProperty(_drivePadTypeToMimeTy, PadType$1.Slide, MimeType.Powerpoint), _drivePadTypeToMimeTy);
(_padTypeToMimeTypeMap = {}, _defineProperty(_padTypeToMimeTypeMap, PadType$1.Doc, MimeType.Doc), _defineProperty(_padTypeToMimeTypeMap, PadType$1.Sheet, MimeType.Sheet), _defineProperty(_padTypeToMimeTypeMap, PadType$1.Slide, MimeType.Slide), _defineProperty(_padTypeToMimeTypeMap, PadType$1.Form, MimeType.Form), _defineProperty(_padTypeToMimeTypeMap, PadType$1.SmartCanvas, MimeType.SmartCanvas), _defineProperty(_padTypeToMimeTypeMap, PadType$1.Mind, MimeType.Mind), _defineProperty(_padTypeToMimeTypeMap, PadType$1.FlowChart, MimeType.FlowChart), _defineProperty(_padTypeToMimeTypeMap, PadType$1.Pdf, MimeType.Pdf), _defineProperty(_padTypeToMimeTypeMap, PadType$1.Aio, MimeType.Aio), _padTypeToMimeTypeMap);
[[WordMimeTypes, PadType$1.Drive], [ExcelMimeTypes, PadType$1.Drive], [PowerPointMimeTypes, PadType$1.Drive], [[MimeType.Form], PadType$1.Form], [[MimeType.SmartCanvas], PadType$1.SmartCanvas], [[MimeType.SmartSheet], PadType$1.SmartSheet], [[MimeType.Doc], PadType$1.Doc], [[MimeType.Sheet], PadType$1.Sheet], [[MimeType.Slide], PadType$1.Slide], [[MimeType.Mind], PadType$1.Mind], [[MimeType.FlowChart], PadType$1.FlowChart], [CodeMimeTypes, PadType$1.Drive], [TextMimeTypes, PadType$1.Drive], [[MimeType.Pdf], PadType$1.Pdf], [flowChatMimeTypes, PadType$1.FlowChart], [mindMimeTypes, PadType$1.Mind], [ImageMimeTypes, PadType$1.Drive], [VideoMimeTypes, PadType$1.Drive], [AudioMimeTypes, PadType$1.Drive], [[MimeType.Rec], PadType$1.Rec]];

(() => {
  const link = typeof document === 'undefined' ? null : document.createElement('a');
  return url => {
    if (!link) return url;
    link.href = url;
    return link.href;
  };
})();
var Auth;
(function (Auth) {
  Auth[Auth["error"] = -1] = "error";
  Auth[Auth["owner"] = 0] = "owner";
  Auth[Auth["writer"] = 1] = "writer";
  Auth[Auth["reader"] = 2] = "reader";
})(Auth || (Auth = {}));
var Application;
(function (Application) {
  Application["CLIENT"] = "client";
  Application["MOBILE"] = "mobile";
  Application["WECHAT"] = "wechat";
  Application["BROWSER"] = "browser";
  Application["OTHER"] = "other";
})(Application || (Application = {}));
var Platform;
(function (Platform) {
  Platform["ANDROID"] = "android";
  Platform["iOS"] = "iOS";
  Platform["WIN"] = "win";
  Platform["MAC"] = "mac";
  Platform["OTHER"] = "other";
})(Platform || (Platform = {}));
var Page;
(function (Page) {
  Page["tab_timeline"] = "tab-timeline";
  Page["tab_all"] = "tab-all";
  Page["detail"] = "detail";
  Page["setting_auth"] = "setting-auth";
  Page["template"] = "template";
  Page["error"] = "error";
  Page["activities"] = "activities";
  Page["login"] = "login";
  Page["member"] = "member";
  Page["tab_container"] = "tab-container";
  Page["tab_icon"] = "tab-icon";
  Page["m_setting_auth"] = "m-setting-auth";
  Page["m_detail_menu"] = "m-detail-menu";
  Page["m_tab_all_menu"] = "m-tab-all-menu";
  Page["m_activities"] = "m- activities";
  Page["m_member"] = "m-member";
  Page["m_form_app"] = "m-form-app";
  Page["m_gourp_form_app"] = "m-gourp-form-app";
  Page["m_tab_timeline"] = "m-tab-timeline";
  Page["m_tab_all"] = "m-tab-all";
  Page["m_group_doc"] = "m-group-doc";
})(Page || (Page = {}));
var PadType;
(function (PadType) {
  PadType["Doc"] = "doc";
  PadType["Sheet"] = "sheet";
  PadType["Slide"] = "slide";
  PadType["Form"] = "form";
  PadType["Pdf"] = "pdf";
  PadType["Mind"] = "mind";
  PadType["FlowChart"] = "flowchart";
  PadType["Aio"] = "Aio";
  PadType["Folder"] = "folder";
  PadType["SmartSheet"] = "smartsheet";
  PadType["Drive"] = "drive";
})(PadType || (PadType = {}));
var _a$1;
const DocsConfigModule = DocsConfig.default || DocsConfig;
const appConfigInstance = DocsConfigModule.getInstance();
const npmConfig = appConfigInstance.getConfig('npm["@tencent/tencent-doc-report"]') || {};
const LOCATION_HOST = location.host;
const SDK_BUNDLE_URL = npmConfig.SDK_BUNDLE_URL || 'https://docs.gtimg.com/alloy-report-sdk/latest/v4/alloyreport.sdk.js';
const ENT_SDK_BUNDLE_URL = npmConfig.ENT_SDK_BUNDLE_URL || 'https://res.wx.qq.com/d/alloy-report-sdk/latest/v4/alloyreport.sdk.js';
npmConfig.docrpWeixinOrigin || 'https://docrp.weixin.qq.com';
const wecomMainHost = npmConfig.wecomMainHost || 'doc.weixin.qq.com';
const wecomAddonHost = npmConfig.wecomAddonHost || 'wecom-addon.tencentsuite.com';
npmConfig.cookieDomain || '.docs.qq.com';
npmConfig.reportIdqqimgOrigin || 'https://report.idqqimg.com';
npmConfig.reportIdqqimgHost || 'report.idqqimg.com';
npmConfig.reportUrlOrigin || 'https://report.url.cn';
npmConfig.reportUrlHost || 'report.url.cn';
npmConfig.reportHuatuoOrigin || 'https://report.huatuo.qq.com';
npmConfig.beaconOrigin || 'https://otheve.beacon.qq.com';
npmConfig.tencentDocCdnGoOrigin || 'https://tencent-doc.cdn-go.cn';
npmConfig.qqwebQQHost || 'qqweb.qq.com';
npmConfig.qunQQHost || 'qun.qq.com';
npmConfig.interceptorIgnoreUrls || ['report.url.cn', 'huatuo.qq.com', 'aegis.qq.com', 'report.idqqimg.com'];
(_a$1 = appConfigInstance.getConfig('runtime.apiRoot')) !== null && _a$1 !== void 0 ? _a$1 : 'docs.qq.com';
appConfigInstance.getConfig('domain') === 'saas-tdocs';
appConfigInstance.getConfig('runtime.domainName') || LOCATION_HOST;
const wecomHostNames = [wecomMainHost, wecomAddonHost];
const runtimeIsWeWorkEnv = function () {
  const isWecomEnv = wecomHostNames.includes(typeof location !== 'undefined' && location.origin.split('//')[1] || '');
  return () => isWecomEnv;
}();
const _window = (() => {
  if (typeof window !== 'undefined' && window && window.navigator) {
    return window;
  }
  return null;
})();
const _wx = (() => {
  if (isNativeMiniProgram()) {
    return qq || wx;
  }
  return null;
})();
(() => {
  if (_window && _window.localStorage && typeof _window.localStorage.getItem === 'function') {
    return 1;
  }
  if (isNativeMiniProgram() && typeof _wx.getStorage === 'function') {
    return 2;
  }
  return 0;
})();
function isNativeMiniProgram() {
  if (typeof qq === 'object' && qq.canIUse) {
    return qq.canIUse('request');
  }
  if (typeof wx === 'object' && wx.canIUse) {
    return wx.canIUse('request');
  }
  return false;
}
const isInBorwser = () => typeof document !== 'undefined';
if (isInBorwser()) {
  const version = ua.getWxWorkVersion();
  if (version) {
    `${ua.isWxWorkQt ? 'QT' : ''}${version}`;
  }
}
const reportProxyID = '@tencent-tencent-doc-report';
function injectScript(url) {
  return new Promise(resolve => {
    const script = document.createElement('script');
    script.async = true;
    script.src = url;
    script.id = reportProxyID;
    script.crossOrigin = 'anonymous';
    script.setAttribute('retry-when-error', 'true');
    script.onload = () => {
      var _a;
      resolve((_a = window.TencentDocReport) === null || _a === void 0 ? void 0 : _a.tencentDocReportSDK);
    };
    if (!window.TencentDocReport) {
      window.TencentDocReport = {};
    }
    if (!window.TencentDocReport.tencentDocReportInjected) {
      window.TencentDocReport.tencentDocReportInjected = true;
      window.tencentDocReportInjected = true;
      (document.head || document.body).appendChild(script);
    }
  });
}
function safeStringify(obj) {
  const seen = new Set();
  return JSON.stringify(obj, (key, value) => {
    if (isObject(value) || Array.isArray(value)) {
      if (seen.has(value)) {
        return '[Circular]';
      }
      seen.add(value);
    }
    return value;
  });
}
function isObject(obj) {
  return isType('Object', obj);
}
function isType(type, obj) {
  return Object.prototype.toString.call(obj) === `[object ${type}]`;
}
function isClassMethodType(caller) {
  return "className" in caller;
}
function init(sdkUrl) {
  var _a;
  if ((_a = window.TencentDocReport) === null || _a === void 0 ? void 0 : _a.tencentDocReportInjected) return;
  if (!window.TencentDocReport) {
    window.TencentDocReport = {
      tencentDocReportBundleURL: sdkUrl,
      tencentDocReportInjected: false
    };
  }
  injectScript(sdkUrl).then(() => {
    var _a, _b, _c, _d, _e;
    if (!window.tencentDocReportBuffers) return;
    for (const caller of window.tencentDocReportBuffers) {
      if (isClassMethodType(caller)) {
        ((_b = (_a = window.TencentDocReport) === null || _a === void 0 ? void 0 : _a.tencentDocReportSDK) === null || _b === void 0 ? void 0 : _b[caller.className][caller.methodName]).apply(null, JSON.parse(caller.argsStringified));
      } else {
        (_e = (_d = (_c = window.TencentDocReport) === null || _c === void 0 ? void 0 : _c.tencentDocReportSDK) === null || _d === void 0 ? void 0 : _d[caller.functionName]) === null || _e === void 0 ? void 0 : _e.apply(null, JSON.parse(caller.argsStringified));
      }
    }
  }).then(() => {
    clearBuffers();
  }).catch(() => {
    clearBuffers();
  });
}
function invokeFunction(functionName, args) {
  var _a, _b;
  try {
    if ((_a = window.TencentDocReport) === null || _a === void 0 ? void 0 : _a.tencentDocReportSDK) {
      (_b = window.TencentDocReport) === null || _b === void 0 ? void 0 : _b.tencentDocReportSDK[functionName].apply(null, args);
      return;
    }
    pushBuffer({
      functionName,
      argsStringified: safeStringify(args)
    });
  } catch (error) {
    console.error(error);
  }
}
function pushBuffer(buffer) {
  var _a;
  window.tencentDocReportBuffers = (_a = window.tencentDocReportBuffers) !== null && _a !== void 0 ? _a : [];
  window.tencentDocReportBuffers.push(buffer);
}
function clearBuffers() {
  window.tencentDocReportBuffers = [];
  delete window.tencentDocReportBuffers;
}
if (isInBorwser()) {
  init(runtimeIsWeWorkEnv() ? ENT_SDK_BUNDLE_URL : SDK_BUNDLE_URL);
}
function tdw(...params) {
  invokeFunction('tdw', params);
}

var project = 'addon';
var attrPrefix = '[docs-addon-sdk]';
var verifyMessage = function (event) { return event.origin === location.origin; };
var reportManager = new AddonReportManager({ project: project, attrPrefix: attrPrefix, needReceiveMessage: true, verifyMessage: verifyMessage });
reportManager.updateGetAddonInfo(function (encAddonId) {
    if (encAddonId === void 0) { encAddonId = ''; }
    return __awaiter(void 0, void 0, void 0, function () {
        var _a, _b, addonId, _c, packageId;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, AddonManager$1.getInstance().getAddonByCurWindow(encAddonId)];
                case 1:
                    _a = _d.sent(), _b = _a.addonId, addonId = _b === void 0 ? '' : _b, _c = _a.packageId, packageId = _c === void 0 ? '' : _c;
                    return [2 /*return*/, {
                            addonId: addonId,
                            packageId: packageId,
                        }];
            }
        });
    });
});
// tool_id 为插件 id ，tool_name 为插件名称
var reportAddonDocCoreEvent = function (option) {
    tdw(__assign({ opername: DOC_CORE_OPERNAME, file_type: TOOL_FILE_TYPE }, option));
};

/**
 *  打开插件，未安装时会打开商城详情页
 *  addonId 插件 id
 *  marketId 商城 id，传了才能打开商城详情页
 */
function openAddon(options) {
    return __awaiter(this, void 0, void 0, function () {
        var addonId, _a, marketId, _b, directAuth, _c, installed, name, fileType, openAddonDirectly, reportDocCoreEvent;
        var _this = this;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    addonId = options.addonId, _a = options.marketId, marketId = _a === void 0 ? '' : _a, _b = options.directAuth, directAuth = _b === void 0 ? false : _b;
                    return [4 /*yield*/, AddonManager$1.getInstance().getAddon(addonId, {
                            shouldGetLatest: true,
                            needInstalled: false,
                        })];
                case 1:
                    _c = _d.sent(), installed = _c.installed, name = _c.name;
                    fileType = DocManager.getMetaInfo().fileType;
                    openAddonDirectly = function (addonId) { return __awaiter(_this, void 0, void 0, function () {
                        var menuConfig;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, AddonManager$1.getInstance().fetchAddonMenu(addonId)];
                                case 1:
                                    menuConfig = _a.sent();
                                    return [4 /*yield*/, executeActionWithAuth(addonId, menuConfig)];
                                case 2:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); };
                    reportDocCoreEvent = function () {
                        reportAddonDocCoreEvent({
                            module: DOC_CORE_MODULE.visit,
                            action: DOC_CORE_ACTION.detailPage,
                            frontend_ext: {
                                tool_id: addonId,
                                tool_name: name,
                            },
                        });
                    };
                    if (installed || directAuth) {
                        // 已安装直接打开
                        openAddonDirectly(addonId);
                        reportDocCoreEvent();
                    }
                    else {
                        // 未安装打开商城详情页
                        AddonMallManager.getInstance().openAddonMall({
                            type: fileTypeToAddonPanelType(fileType),
                            page: 'detail',
                            query: { id: marketId, title: name },
                            onOpenAddon: function (_a) {
                                var id = _a.id;
                                return __awaiter(_this, void 0, void 0, function () {
                                    return __generator(this, function (_b) {
                                        switch (_b.label) {
                                            case 0: 
                                            // 更新插件状态
                                            return [4 /*yield*/, AddonManager$1.getInstance().getAddon(addonId, { shouldGetLatest: true })];
                                            case 1:
                                                // 更新插件状态
                                                _b.sent();
                                                // 打开插件
                                                return [4 /*yield*/, openAddonDirectly(id)];
                                            case 2:
                                                // 打开插件
                                                _b.sent();
                                                return [4 /*yield*/, AddonMallManager.getInstance().closeAddonMall()];
                                            case 3:
                                                _b.sent();
                                                reportDocCoreEvent();
                                                return [2 /*return*/];
                                        }
                                    });
                                });
                            },
                        });
                    }
                    return [2 /*return*/];
            }
        });
    });
}

var AddonDialogSize;
(function (AddonDialogSize) {
    AddonDialogSize[AddonDialogSize["MAX_WIDTH"] = 860] = "MAX_WIDTH";
    AddonDialogSize[AddonDialogSize["MAX_HEIGHT"] = 496] = "MAX_HEIGHT";
    AddonDialogSize[AddonDialogSize["MIN_WIDTH"] = 340] = "MIN_WIDTH";
    AddonDialogSize[AddonDialogSize["MIN_HEIGHT"] = 168] = "MIN_HEIGHT";
    AddonDialogSize[AddonDialogSize["HEADER_SIZE"] = 64] = "HEADER_SIZE";
    AddonDialogSize[AddonDialogSize["DEFAULT_WIDTH"] = 400] = "DEFAULT_WIDTH";
    AddonDialogSize[AddonDialogSize["DEFAULT_HEIGHT"] = 400] = "DEFAULT_HEIGHT";
})(AddonDialogSize || (AddonDialogSize = {}));

var ActionActuator = /** @class */ (function () {
    function ActionActuator(addon) {
        var _this = this;
        /**
         * 批量执行Action
         * @param actions Actions数组
         */
        this.executeActions = function (actions) {
            if (actions === void 0) { actions = []; }
            actions.forEach(function (_a) {
                var funcName = _a.funcName, funcArgs = _a.funcArgs;
                _this.executeActionItem(funcName, funcArgs);
            });
        };
        /**
         * 执行单个Action
         * @param funcName action方法名
         * @param funcArgs action参数
         */
        this.executeActionItem = function (funcName, funcArgs) {
            if (funcArgs === void 0) { funcArgs = []; }
            // action方法与实现的Mapping
            var actionExecuteFuncMapping = {
                openDialog: _this.openDialog,
                openSidebar: _this.openSidebar,
                openPage: _this.openPage,
                openURL: _this.openURL,
                close: _this.close,
                insertDocElement: _this.insertDocElement,
                updateDocElement: _this.updateDocElement,
                uploadImage: _this.uploadImage,
                importSlide: _this.importSlide,
                callOCR: _this.callOCR,
                updateDialog: UIManager.updateDialog,
                updateSidebar: UIManager.updateSidebar,
                report: _this.report,
                pay: _this.pay,
                setCellObjects: _this.setCellObjects,
                subscribeVIP: _this.subscribeVIP,
                openFileSelector: _this.openFileSelector,
                openPlatformFileSelector: _this.openPlatformFileSelector,
                getSelectedFileIds: _this.getSelectedFileIds,
                openAddon: _this.openAddon,
                refreshResumeData: function () { var _a, _b; return (_b = (_a = DocManager.getEditor()) === null || _a === void 0 ? void 0 : _a.refreshResumeData) === null || _b === void 0 ? void 0 : _b.call(_a); },
            };
            var actionExecuteFunc = actionExecuteFuncMapping[funcName].bind(_this);
            if (!actionExecuteFunc) {
                return;
            }
            // 判断为特定的 action ，修改 addonId 为带环境标识的 addonId
            // 当修改为带环境标识的 addonId ，invoke 请求时才能识别到相应的环境
            var addonAddonIdEnvActions = ['insertDocElement'];
            var newFuncArgs;
            if (addonAddonIdEnvActions.indexOf(funcName) !== -1) {
                var env_1 = _this.addon.env;
                newFuncArgs = funcArgs.map(function (arg) {
                    // arg 为 unknown 类型，需要进行类型转换才能对可能存在的 addonId 做处理
                    var resArg = arg;
                    if (resArg === null || resArg === void 0 ? void 0 : resArg.addonId) {
                        resArg.addonId = getEnvAddonId(resArg.addonId, env_1);
                    }
                    return resArg;
                });
            }
            return actionExecuteFunc.apply(void 0, __spreadArray([], __read((newFuncArgs || funcArgs)), false));
        };
        /**
         * Action - 打开Dialog
         * @param options dialog配置
         */
        this.openDialog = function (options) { return _this.openAddonWindow(AddonWindowType.DIALOG, options); };
        /**
         * Action - 打开Sidebar
         * @param options sidebar配置
         */
        this.openSidebar = function (options) { return _this.openAddonWindow(AddonWindowType.SIDEBAR, options); };
        /**
         * Action - 关闭插件(Dialog/Sidebar)
         * @param encAddonId 插件的encAddonId
         * @returns
         */
        this.close = function (encAddonId) {
            var addonWindow = AddonManager$1.getInstance().getCurAddonWindowById(encAddonId);
            if (!addonWindow) {
                return;
            }
            switch (addonWindow === null || addonWindow === void 0 ? void 0 : addonWindow.type) {
                case AddonWindowType.DIALOG: {
                    UIManager.closeDialog();
                    break;
                }
                case AddonWindowType.SIDEBAR: {
                    UIManager.closeSidebar();
                    break;
                }
            }
        };
        /**
         * @description: 设置 sheet 区域格子的背景颜色和宽高
         * @param {CellObjectsData} data
         * @return {*}
         */
        this.setCellObjects = function (data) {
            var _a, _b;
            (_b = (_a = DocManager.getService().advanced).setCellObjects) === null || _b === void 0 ? void 0 : _b.call(_a, data);
        };
        // 拼接插件的url
        this.generateAddonSrc = function (src) {
            return "https://".concat(_this.addon.staticHost, "/").concat(_this.addon.staticPath, "/").concat(src);
        };
        /**
         * Action - dialog数据上报
         * @param reportData 上报数据
         */
        this.report = function (reportData) {
            var _a, _b;
            (_b = (_a = DocManager.getService().advanced).report) === null || _b === void 0 ? void 0 : _b.call(_a, reportData);
        };
        this.addon = addon;
    }
    /**
     * 新页面打开插件
     * @param addonId 插件ID
     */
    ActionActuator.prototype.openPage = function () {
        return __awaiter(this, void 0, void 0, function () {
            var addonId, _a, fileId, fileType;
            var _this = this;
            return __generator(this, function (_b) {
                addonId = this.addon.addonId;
                _a = DocManager.getMetaInfo(), fileId = _a.fileId, fileType = _a.fileType;
                return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                        var successCb, failCb;
                        return __generator(this, function (_a) {
                            successCb = function () {
                                var _a;
                                var url = getOpenSuitAddonH5URL(addonId, {
                                    fileId: fileId,
                                    fileType: String(fileType),
                                    aidPosition: DocManager.getAidPosition(),
                                });
                                var openUrlMethod = ((_a = DocManager.getService().ui) === null || _a === void 0 ? void 0 : _a.customOpenURL) || (function (url) { return tencentDocOpenUrlForAll({ url: url }); });
                                openUrlMethod(url);
                                resolve();
                            };
                            failCb = function () {
                                reject('插件安装授权失败');
                            };
                            AddonAuthManager.getInstance().handleAddonAuth(addonId, successCb, failCb);
                            return [2 /*return*/];
                        });
                    }); })];
            });
        });
    };
    // 上报插件页面打开
    ActionActuator.prototype.reportVisitDocCoreEvent = function () {
        var _a = this.addon, addonId = _a.addonId, name = _a.name;
        reportAddonDocCoreEvent({
            module: DOC_CORE_MODULE.visit,
            action: DOC_CORE_ACTION.detailPage,
            frontend_ext: {
                tool_id: addonId,
                tool_name: name,
            },
        });
    };
    // 上报插件调用 sdk 编辑相关能力
    ActionActuator.prototype.reportEditDocCoreEvent = function () {
        var _a = this.addon, addonId = _a.addonId, name = _a.name;
        reportAddonDocCoreEvent({
            module: DOC_CORE_MODULE.edit,
            action: DOC_CORE_ACTION.editText,
            frontend_ext: {
                tool_id: addonId,
                tool_name: name,
            },
        });
    };
    /**
     * Action - 打开链接
     * @param url 链接地址
     */
    ActionActuator.prototype.openURL = function (url) {
        tencentDocOpenUrlForAll({ url: url });
    };
    /**
     * Action - 插入文档元素(包含text,image,web等)，如果没有提供 editor.insertDocElement API，则什么都不干
     * @param docElement
     */
    ActionActuator.prototype.insertDocElement = function (docElement, range) {
        var _a;
        (_a = DocManager.getEditor()) === null || _a === void 0 ? void 0 : _a.insertDocElement(docElement, range);
        this.reportEditDocCoreEvent();
    };
    /**
     * Action - 更新文档元素(包含text,image,web等)，如果没有提供 editor.updateDocElement API，则什么都不干
     * @param docElement
     */
    ActionActuator.prototype.updateDocElement = function (docElement) {
        var _a;
        (_a = DocManager.getEditor()) === null || _a === void 0 ? void 0 : _a.updateDocElement(docElement);
        this.reportEditDocCoreEvent();
    };
    // 打开addonWindow
    ActionActuator.prototype.openAddonWindow = function (type, options) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var src, _e, id, title, _f, addonId, env, name, encAddonId, addonWindowURL, addonWindowHref, addonWindowOptions, hookOptions, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        src = options.src, _e = options.id, id = _e === void 0 ? generateAddonWindowId() : _e, title = options.title;
                        _f = this.addon, addonId = _f.addonId, env = _f.env, name = _f.name;
                        encAddonId = generateEncAddonId();
                        // 记录当前的addon window
                        AddonManager$1.getInstance().addCurAddonWindow({
                            encAddonId: encAddonId,
                            type: type,
                            addonId: addonId,
                            windowId: id,
                        });
                        addonWindowURL = "".concat(location.origin).concat(this.getCurrentAddonWindowPath());
                        addonWindowHref = addURLHashParam(addonWindowURL, {
                            encAddonId: encAddonId,
                            src: encodeURIComponent(this.generateAddonSrc(src)),
                            renderType: this.addon.renderType || AddonRenderType.IFRAME,
                        });
                        addonWindowOptions = __assign(__assign({}, options), { 
                            // 覆盖插件的src属性为拼接后的地址
                            src: addonWindowHref, 
                            // 默认title为当前插件的名称
                            title: getEnvContent(title || name, env) });
                        hookOptions = {
                            addonId: addonId,
                            type: type,
                        };
                        _g = type;
                        switch (_g) {
                            case AddonWindowType.DIALOG: return [3 /*break*/, 1];
                            case AddonWindowType.SIDEBAR: return [3 /*break*/, 3];
                        }
                        return [3 /*break*/, 5];
                    case 1: return [4 /*yield*/, ((_b = (_a = DocManager.getAddonHook()) === null || _a === void 0 ? void 0 : _a.onOpen) === null || _b === void 0 ? void 0 : _b.call(_a, hookOptions))];
                    case 2:
                        _h.sent();
                        UIManager.openDialog(this.fixDialogOptions(addonWindowOptions), {
                            onClose: function () {
                                var _a, _b;
                                // 关闭时触发
                                (_b = (_a = DocManager.getAddonHook()) === null || _a === void 0 ? void 0 : _a.onClose) === null || _b === void 0 ? void 0 : _b.call(_a, hookOptions);
                                AddonManager$1.getInstance().removeCurAddonWindow(encAddonId);
                                DocManager.clearOCRRes();
                            },
                        });
                        this.reportVisitDocCoreEvent();
                        return [3 /*break*/, 6];
                    case 3: return [4 /*yield*/, ((_d = (_c = DocManager.getAddonHook()) === null || _c === void 0 ? void 0 : _c.onOpen) === null || _d === void 0 ? void 0 : _d.call(_c, hookOptions))];
                    case 4:
                        _h.sent();
                        UIManager.openSidebar(addonWindowOptions, {
                            onClose: function () {
                                var _a, _b;
                                (_b = (_a = DocManager.getAddonHook()) === null || _a === void 0 ? void 0 : _a.onClose) === null || _b === void 0 ? void 0 : _b.call(_a, hookOptions);
                                AddonManager$1.getInstance().removeCurAddonWindow(encAddonId);
                                DocManager.clearOCRRes();
                            },
                        });
                        this.reportVisitDocCoreEvent();
                        return [3 /*break*/, 6];
                    case 5: return [3 /*break*/, 6];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ActionActuator.prototype.updateLogo = function (options) {
        var showLogo = WITH_LOGO_ADDON_ID_LIST.includes(this.addon.addonId);
        var _a = this.addon.config, _b = _a === void 0 ? {} : _a, _c = _b.domains, _d = _c === void 0 ? [] : _c, _e = __read(_d, 1), _f = _e[0], _g = _f === void 0 ? {} : _f, _h = _g.icon, icon = _h === void 0 ? '' : _h;
        return __assign(__assign({}, options), { logo: showLogo ? this.generateAddonSrc(icon) : '' });
    };
    ActionActuator.prototype.fixDialogOptions = function (options) {
        var _a, _b;
        var fixedOptions = this.updateLogo(options);
        fixedOptions.width = (_a = fixedOptions.width) !== null && _a !== void 0 ? _a : AddonDialogSize.DEFAULT_WIDTH;
        fixedOptions.height = (_b = fixedOptions.height) !== null && _b !== void 0 ? _b : AddonDialogSize.DEFAULT_HEIGHT;
        fixedOptions.width = ensureValueInScope(fixedOptions.width, AddonDialogSize.MIN_WIDTH, AddonDialogSize.MAX_WIDTH);
        fixedOptions.height = ensureValueInScope(fixedOptions.height, AddonDialogSize.MIN_HEIGHT, AddonDialogSize.MAX_HEIGHT)
            + AddonDialogSize.HEADER_SIZE;
        return fixedOptions;
    };
    // 上传图片
    ActionActuator.prototype.uploadImage = function (image, ratio) {
        var uploadImage = DocManager.getService().advanced.uploadImage;
        if (!uploadImage) {
            throw new Exception(AddonErrorCode.CALL_ADDON_API_ERROR);
        }
        this.reportEditDocCoreEvent();
        return uploadImage(image, ratio);
    };
    // 上传幻灯片
    ActionActuator.prototype.importSlide = function (data) {
        var importSlideService = DocManager.getService().advanced.importSlide;
        if (!importSlideService) {
            return Promise.reject(new Exception(AddonErrorCode.CALL_ADDON_API_ERROR));
        }
        this.reportEditDocCoreEvent();
        return importSlideService(data);
    };
    // 调用OCR识别
    ActionActuator.prototype.callOCR = function (type) {
        if (type === void 0) { type = OCRType.LATEX; }
        var callOCRService = DocManager.getService().advanced.callOCR;
        if (!callOCRService) {
            return Promise.reject(new Exception(AddonErrorCode.CALL_ADDON_API_ERROR));
        }
        this.reportEditDocCoreEvent();
        return callOCRService(type);
    };
    // 获取当前的插件窗口域名地址
    ActionActuator.prototype.getCurrentAddonWindowPath = function () {
        return isEnterpriseWecomEnv() ? AddonWindowPathType.ENTERPRISE_WECOM : AddonWindowPathType.DEFAULT;
    };
    /**
     * 支付
     * @param productId 商品 id
     * @param extra 支付 extra 字段(透传)
     * @param sandbox 是否沙箱环境
     * @returns 支付结果
     */
    ActionActuator.prototype.pay = function (productIdOrOptions, extra, sandbox) {
        var _this = this;
        if (extra === void 0) { extra = ''; }
        var payWithOptions = function (options) {
            var _a = options.productId, productId = _a === void 0 ? '' : _a, _b = options.source, source = _b === void 0 ? '' : _b, _c = options.extra, extra = _c === void 0 ? '' : _c, _d = options.sandbox, sandbox = _d === void 0 ? 0 : _d;
            _this.reportEditDocCoreEvent();
            return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var _a, addonId, packageId, env, componentName, extension;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _a = this.addon, addonId = _a.addonId, packageId = _a.packageId, env = _a.env;
                            componentName = 'docs-component-product-pay';
                            return [4 /*yield*/, getArkExtension({ name: componentName })];
                        case 1:
                            extension = _b.sent();
                            extension.show({
                                theme: PayTheme.COMMON_PRODUCT,
                                data: {
                                    productId: productId,
                                    productType: ProductType.ADDON,
                                    productPackageId: addonId,
                                    extraData: {
                                        userData: extra,
                                        packageId: packageId,
                                        env: env,
                                    },
                                },
                                payConfig: {
                                    sandbox: sandbox,
                                },
                                // 该参数只对移动端生效，PC 端各方约定俗称了一套 zIndex
                                zIndex: MOBILE_ADDON_Z_INDEX + 1,
                                // 支付的来源, 用于运营区分, 格式: txdocs_singlebuy_web_[插件 id]
                                source: source ? concatAID(source, addonId) : "txdocs_singlebuy_web_".concat(addonId),
                                onSuccess: function () {
                                    resolve();
                                },
                                onError: function (error) {
                                    reject(new Exception(AddonErrorCode.STORE_PAY_ERROR, error));
                                },
                                onClose: function () {
                                    reject(new Exception(AddonErrorCode.STORE_PAY_CANCEL));
                                },
                            });
                            return [2 /*return*/];
                    }
                });
            }); });
        };
        if (typeof productIdOrOptions === 'string') {
            return payWithOptions({
                productId: productIdOrOptions,
                extra: extra,
                sandbox: sandbox,
            });
        }
        return payWithOptions(productIdOrOptions);
    };
    ActionActuator.prototype.subscribeVIP = function (source, VIPType, extra) {
        var _this = this;
        if (VIPType === void 0) { VIPType = SVIP; }
        if (extra === void 0) { extra = ''; }
        this.reportEditDocCoreEvent();
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var componentName, extension, _a, addonId, packageId, env, extraData;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        componentName = 'docs-component-pay';
                        return [4 /*yield*/, getArkExtension({ name: componentName })];
                    case 1:
                        extension = _b.sent();
                        _a = this.addon, addonId = _a.addonId, packageId = _a.packageId, env = _a.env;
                        if (typeof extra !== 'string') {
                            reject(new Exception(AddonErrorCode.BACK_INNER_ERROR));
                        }
                        extraData = '';
                        try {
                            extraData = JSON.stringify({
                                packageId: packageId,
                                env: env,
                                userData: extra,
                            });
                        }
                        catch (err) {
                            reject(err);
                        }
                        // 自定义的show方法
                        extension.show({
                            source: concatAID(source, this.addon.addonId),
                            payWrapperStyle: {
                                zIndex: String(MODAL_Z_INDEX),
                            },
                            extParam: {
                                extraData: extraData,
                                vipTabType: VIPType,
                                packageId: addonId,
                            },
                            onSuccess: function () {
                                resolve();
                            },
                            onClose: reject,
                        });
                        return [2 /*return*/];
                }
            });
        }); });
    };
    ActionActuator.prototype.openPlatformFileSelector = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, addonId, env;
            return __generator(this, function (_b) {
                _a = this.addon, addonId = _a.addonId, env = _a.env;
                // 使用带环境的 addonId ，选择完微信文件后的回调 url 才能打开正确环境的插件
                this.reportEditDocCoreEvent();
                return [2 /*return*/, FileManager.getInstance().openPlatformFileSelector(getEnvAddonId(addonId, env))];
            });
        });
    };
    ActionActuator.prototype.openFileSelector = function (selectorOptions) {
        return __awaiter(this, void 0, void 0, function () {
            var addonId, prodAddonId, confirmText, maxSelectNum, _a, filterType, _b, fileAuthType, list;
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        addonId = this.addon.addonId;
                        prodAddonId = getEnvAddonId(addonId, AddonEnvironmentType.PRODUCTION);
                        confirmText = selectorOptions.confirmText, maxSelectNum = selectorOptions.maxSelectNum, _a = selectorOptions.filterType, filterType = _a === void 0 ? '' : _a;
                        return [4 /*yield*/, getAuthorizedFiles(prodAddonId)];
                    case 1:
                        _b = _d.sent(), fileAuthType = _b.fileAuthType, list = _b.list;
                        if (!(fileAuthType === FileAuthType.NONE)) return [3 /*break*/, 4];
                        return [4 /*yield*/, fileAuth(this.addon)];
                    case 2:
                        _d.sent();
                        return [4 /*yield*/, getAuthorizedFiles(prodAddonId)];
                    case 3:
                        // 授权流程结束后重新获取权限
                        (_c = _d.sent(), fileAuthType = _c.fileAuthType, list = _c.list);
                        _d.label = 4;
                    case 4:
                        // 用户授权插件部分文件，返回已授权文件列表
                        if (fileAuthType === FileAuthType.PART) {
                            this.reportEditDocCoreEvent();
                            return [2 /*return*/, new Promise(function (resolve, reject) {
                                    FileManager.getInstance().handlePartFileSelect(prodAddonId, list, confirmText !== null && confirmText !== void 0 ? confirmText : '确定', maxSelectNum !== null && maxSelectNum !== void 0 ? maxSelectNum : 9, filterType, function (file) { return resolve(strictPartFileField(file)); }, function () { return reject(new Exception(AddonErrorCode.BACK_INNER_ERROR)); });
                                })];
                        }
                        // 用户授权插件所有文件，返回文件选择器
                        if (fileAuthType === FileAuthType.ALL) {
                            this.reportEditDocCoreEvent();
                            if (ua.isMobile) {
                                return [2 /*return*/, FileManager.getInstance().openFileSelector(true, {
                                        mimeTypes: FileManager.getInstance().transformFilterType(filterType),
                                        maxNumber: maxSelectNum,
                                        permissions: [
                                            MobileFileSelectorPermission.CanCopy,
                                            MobileFileSelectorPermission.CanExport,
                                            MobileFileSelectorPermission.CanPrint,
                                        ],
                                        style: { zIndex: MODAL_Z_INDEX },
                                    })];
                            }
                            return [2 /*return*/, FileManager.getInstance().openFileSelector(false, {
                                    zIndex: MODAL_Z_INDEX,
                                    filterType: filterType,
                                    confirmText: confirmText,
                                    maxSelector: maxSelectNum,
                                })];
                        }
                        // 否则返回未授权
                        return [2 /*return*/, Promise.reject(new Exception(AddonErrorCode.ADDON_NOT_AUTHORIZE))];
                }
            });
        });
    };
    ActionActuator.prototype.getSelectedFileIds = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, FileManager.getInstance().getSelectedFileIds()];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * 插件内打开其他插件
     * @param addonId 插件 id
     */
    ActionActuator.prototype.openAddon = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var addonId, _a, marketId, allowAddonList;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        addonId = options.addonId, _a = options.marketId, marketId = _a === void 0 ? '' : _a;
                        allowAddonList = [
                            // C 端签名插件
                            '8a489982e55b4606b85c87f4d0c4ee95',
                        ];
                        if (!allowAddonList.includes(this.addon.addonId)) {
                            throw new Error('不在白名单内');
                        }
                        return [4 /*yield*/, openAddon({ addonId: addonId, marketId: marketId })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return ActionActuator;
}());

var FaaS;
(function (FaaS) {
    FaaS["CALL_FUNC"] = "call-func-from-client";
    FaaS["SEND_RESULT"] = "send-result-from-worker";
})(FaaS || (FaaS = {}));
var EventCenter = {
    FaaS: FaaS,
};

function getPromiseObj() {
    var resolve;
    var reject;
    var promise = new Promise(function (res, rej) {
        resolve = res;
        reject = rej;
    });
    return {
        resolve: resolve,
        reject: reject,
        promise: promise
    };
}

var FaaSHandler = /** @class */ (function () {
    function FaaSHandler() {
    }
    FaaSHandler.getAddonList = function (data) {
        return FaaSHandler.sendMessage(IReqType.LIST, data);
    };
    FaaSHandler.invoke = function (data) {
        return FaaSHandler.sendMessage(IReqType.INVOKE, data);
    };
    FaaSHandler.register = function () {
        if (!('Worker' in window)) {
            console.error('[addon-worker-client] web worker not support!');
            return null;
        }
        return FaaSHandler.registerFaaSWorker();
    };
    FaaSHandler.registerFaaSWorker = function () {
        var wb = new Worker('/addons/worker.js');
        wb.addEventListener('message', FaaSHandler.handleMessage);
        wb.addEventListener('error', function (event) {
            console.error('[addon-worker-client] worker load error', event);
        });
        console.log('[addon-worker-client] worker is created');
        return wb;
    };
    FaaSHandler.generateMessageId = function () {
        var timestamp = new Date().getTime();
        var random = getRandomString(4);
        return "".concat(timestamp).concat(random);
    };
    FaaSHandler.sendMessage = function (reqType, data) {
        var _a = getPromiseObj(), promise = _a.promise, resolve = _a.resolve, reject = _a.reject;
        var worker = FaaSHandler.register();
        if (!worker) {
            reject(new Error('[addon-worker-client] worker is missed'));
            return promise;
        }
        var messageId = FaaSHandler.generateMessageId();
        worker.postMessage({
            type: EventCenter.FaaS.CALL_FUNC,
            data: {
                messageId: messageId,
                reqType: reqType,
                data: data,
            },
        });
        FaaSHandler.callbackPromiseMap.set(messageId, resolve);
        return promise;
    };
    FaaSHandler.handleMessage = function (event) {
        console.log('[addon-worker-client] receive message', event.data.type, event.data.data);
        switch (event.data.type) {
            case EventCenter.FaaS.SEND_RESULT: {
                var _a = event.data.data, messageId = _a.messageId, data = _a.data;
                var resolve = FaaSHandler.callbackPromiseMap.get(messageId);
                resolve(data);
                break;
            }
        }
    };
    FaaSHandler.callbackPromiseMap = new Map();
    return FaaSHandler;
}());

function serviceInvoke(addonId, _a) {
    var scene = _a.scene, funcName = _a.funcName, _b = _a.funcArgs, funcArgs = _b === void 0 ? [] : _b;
    return __awaiter(this, void 0, void 0, function () {
        var addon, env, packageId, prodAddonId, context, privateOptions, _c, _d, result, _e, _f, actions, data, ret, _g, msg, actionActuator;
        var _h;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0: return [4 /*yield*/, AddonManager$1.getInstance().getAddon(addonId)];
                case 1:
                    addon = _j.sent();
                    env = addon.env, packageId = addon.packageId;
                    prodAddonId = getEnvAddonId(addonId, AddonEnvironmentType.PRODUCTION);
                    return [4 /*yield*/, DocManager.getDocContext()];
                case 2:
                    context = _j.sent();
                    return [4 /*yield*/, getContext(addon)];
                case 3:
                    // 体验和审核环境还原 context 的 addonId
                    context = _j.sent();
                    _h = {
                        addonId: addonId,
                        packageId: packageId,
                        scene: scene,
                        funcName: funcName,
                        funcArgs: JSON.stringify(funcArgs)
                    };
                    _d = (_c = JSON).stringify;
                    return [4 /*yield*/, DocManager.getDocContext()];
                case 4:
                    privateOptions = (_h.context = _d.apply(_c, [_j.sent()]),
                        _h);
                    if (!isPrivateEnv()) return [3 /*break*/, 6];
                    return [4 /*yield*/, FaaSHandler.invoke(privateOptions)];
                case 5:
                    _e = _j.sent();
                    return [3 /*break*/, 8];
                case 6: return [4 /*yield*/, invokeAddonService({
                        addonId: prodAddonId,
                        packageId: packageId,
                        scene: scene,
                        funcName: funcName,
                        funcArgs: JSON.stringify(funcArgs),
                        context: JSON.stringify(context),
                        env: env,
                    })];
                case 7:
                    _e = _j.sent();
                    _j.label = 8;
                case 8:
                    result = (_e).data.result;
                    _f = JSON.parse(result), actions = _f.actions, data = _f.data, ret = _f.ret, _g = _f.msg, msg = _g === void 0 ? '' : _g;
                    actionActuator = new ActionActuator(addon);
                    actionActuator.executeActions(actions);
                    return [2 /*return*/, { data: data, ret: ret, msg: msg }];
            }
        });
    });
}

/*
 * @Author: fugao
 * @Date: 2021-06-14 20:53:59
 * @Last Modified by: fugao
 * @Last Modified time: 2021-10-18 15:34:59
 *
 * 云函数Hook, 用于触发插件云端的一些hook函数
 */
var ServiceHook = /** @class */ (function () {
    function ServiceHook(addonId) {
        // 缓存当前插件的contentContainer
        this.contentContainerMap = new Map();
        this.addonId = addonId;
    }
    /**
     * 获取插件子菜单, 触发service.js onInitMent Hook函数
     * 如果插件存在子菜单，获取子菜单信息；如果插件不存在子菜单，获取插件信息
     * @returns 当前插件的子菜单列表(也可以直接是一个Action)
     */
    ServiceHook.prototype.onInitMenus = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, menuConfiguration, addonId, res, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this, menuConfiguration = _a.menuConfiguration, addonId = _a.addonId;
                        if (menuConfiguration) {
                            return [2 /*return*/, {
                                    data: menuConfiguration,
                                    ret: AddonErrorCode.SUCCESS,
                                    msg: CODE_MESSAGE_MAPPING[AddonErrorCode.SUCCESS],
                                }];
                        }
                        return [4 /*yield*/, serviceInvoke(addonId, { scene: InvokeScene.MENU, funcName: 'onInitMenus' })];
                    case 1:
                        res = _b.sent();
                        data = res.data;
                        if (data) {
                            this.menuConfiguration = data;
                        }
                        return [2 /*return*/, res];
                }
            });
        });
    };
    /**
     * 获取内容插件信息,触发service.js onConfigureBlock Hook函数
     *
     * @return {*}  {Promise<CallbackRes<ContentContainer>>} 当前插件的toolbar配置
     */
    ServiceHook.prototype.onConfigureBlock = function (anchorId) {
        var _a = this, contentContainerMap = _a.contentContainerMap, addonId = _a.addonId;
        // 获取插件示例的
        if (anchorId && contentContainerMap.has(anchorId)) {
            return contentContainerMap.get(anchorId);
        }
        var promise = serviceInvoke(addonId, {
            scene: InvokeScene.TOOLBAR,
            funcName: 'onConfigureBlock',
        });
        // 如果传了 anchorId，则缓存对应插件实例的 promise 数据
        if (anchorId) {
            contentContainerMap.set(anchorId, promise);
            promise.catch(function () {
                // invoke 请求出错，删除对应的 promise 缓存
                contentContainerMap.delete(anchorId);
            });
        }
        return promise;
    };
    /**
     * 通过service.js parseAsAddon Hook获取将信息插件化后的iframe信息
     * @returns iframe信息实例
     */
    ServiceHook.prototype.onParseAsAddon = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var addonId, res, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        addonId = this.addonId;
                        return [4 /*yield*/, serviceInvoke(addonId, {
                                scene: InvokeScene.DOC,
                                funcName: 'onParseAsAddon',
                                funcArgs: [context],
                            })];
                    case 1:
                        res = _a.sent();
                        data = res.data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return ServiceHook;
}());

var MessageType;
(function (MessageType) {
    // 系统能力
    MessageType[MessageType["SYSTEM"] = 0] = "SYSTEM";
    // 自定义云函数能力
    MessageType[MessageType["CUSTOM"] = 1] = "CUSTOM";
})(MessageType || (MessageType = {}));
var CustomizedType;
(function (CustomizedType) {
    // 数据上报
    CustomizedType["REPORT"] = "report";
    // 弹Snackbar
    CustomizedType["SHOW_SNACKBAR"] = "showSnackbar";
    // 更新iframe
    CustomizedType["UPDATE_IFRAME"] = "updateIframe";
})(CustomizedType || (CustomizedType = {}));
/**
 * 插件内容内被注入的函数名
 */
var InjectedFuncName;
(function (InjectedFuncName) {
    // 获取注入数据
    InjectedFuncName["GET_INJECTED_DATA"] = "getInjectedData";
})(InjectedFuncName || (InjectedFuncName = {}));

var _a, _b, _c;
var LINK_INFO_LIST = (_a = {},
    _a[LinkType.UNKNOWN] = { title: '第三方插件', print: PrintMode.NONE },
    _a[LinkType.TENCENT_VIDEO] = { title: '腾讯视频', print: PrintMode.NONE },
    _a[LinkType.BILIBILI] = { title: '哔哩哔哩', print: PrintMode.NONE },
    _a[LinkType.PROCESSON] = { title: 'ProcessOn', print: PrintMode.AUTO },
    _a[LinkType.YINXIANG] = { title: '印象笔记', print: PrintMode.AUTO },
    _a[LinkType.CANVA] = { title: 'Canva', print: PrintMode.AUTO },
    _a[LinkType.MODAO] = { title: '墨刀', print: PrintMode.AUTO },
    _a[LinkType.MOKE] = { title: '摹客', print: PrintMode.AUTO },
    _a[LinkType.QQ_MUSIC] = { title: 'QQ音乐', print: PrintMode.NONE },
    _a);
var LINK_ADDON_ID = isEnterpriseWecomEnv()
    ? 'b51399bf7c8445eea8c196a4c3c8af3c'
    : '0b69e1b9517e44a4aee35d33ee021b55';
var FORMULA_ADDON_ID = isEnterpriseWecomEnv()
    ? '8856ef52bd434c2d938fbf0c16d82a96'
    : '42da4f2d95c146abb5896087ca5f03dd';
var SIGN_ADDON_ID = isEnterpriseWecomEnv()
    ? '4064104ee70242e8825c8d2b279f2a30'
    : '8a489982e55b4606b85c87f4d0c4ee95';
var MEETING_ADDON_ID = 'meeting_release';
var MEETING_TEST_ADDON_ID = 'meeting_test';
var COUNTDOWN_ADDON_ID = '511d36d9a6b343c3b89577f63e69a7c0';
var VOTE_ADDON_ID = '4f182e69ac8d4ca5b55095c00c472ade';
// 绘图插件 id
var GRAPH_ADDON_ID = '690b965dbc944a1fa8709461ec6156ec';
// Native 版本的插件 ID 列表
var NATIVE_ADDON_ID_LIST = ['d4e26e4b77124ad6856b64fcf74490ba'];
// 拉起公式插件Dialog配置
var FORMULA_ADDON_WINDOW_OPTIONS = {
    id: generateAddonWindowId(),
    src: 'pages/dialog/index.html',
    title: '插入LaTex公式',
    confirmable: true,
    width: 860,
    height: 484,
};
// 合法调用 report 的 addonId
var REPORT_VALID_LIST = [
    // 腾讯会议
    'meeting_test',
    'meeting_release',
    // 制作证件照
    '6682b5e614a64690a2080d893d84a088',
    // 魔法擦除笔
    'd8535c5b54654370acf491180a1b1927',
    // 智能抠图
    '1bb3d650a97c41a9b25b46679e0631f9',
];
// 合法调用 report 的 origin
var REPORT_VALID_ORIGIN = ['https://pre.txmeeting.tencent.com', 'https://meeting.tencent.com'];
// 合法调用 showSnackbar 的 addonId
var SHOW_SNACKBAR_VALID_LIST = [COUNTDOWN_ADDON_ID];
// 合法调用 showSnackbar 的 origin
var SHOW_SNACKBAR_VALID_ORIGIN = ['https://cdn.addon.tencentsuite.com', 'https://docs.qq.com'];
// 合法调用 updateIframe 的 origin
var IFRAME_UPDATE_VALID_ORIGIN = ['https://docs.qq.com'];
// 合法 addonID 和 origin 的 mapping
var VALIDITY_MAPPING = (_b = {},
    _b[CustomizedType.REPORT] = {
        validAddon: REPORT_VALID_LIST,
        validOrigin: REPORT_VALID_ORIGIN,
    },
    _b[CustomizedType.SHOW_SNACKBAR] = {
        validAddon: SHOW_SNACKBAR_VALID_LIST,
        validOrigin: SHOW_SNACKBAR_VALID_ORIGIN,
    },
    _b[CustomizedType.UPDATE_IFRAME] = {
        validAddon: [VOTE_ADDON_ID],
        validOrigin: IFRAME_UPDATE_VALID_ORIGIN,
    },
    _b);
// TODO(muyanyang): 用于过滤PPT的QQ音乐入口,后续去掉
var QQ_MUSIC_TITLE = 'QQ音乐';
// 官方插件 id 与对应 type 的映射 map，用于返回给品类侧做特殊处理
var OFFICIAL_ADDON_TYPE_MAP = (_c = {},
    _c[LINK_ADDON_ID] = OfficialAddonType.LINK,
    _c[FORMULA_ADDON_ID] = OfficialAddonType.FORMULA,
    _c[SIGN_ADDON_ID] = OfficialAddonType.SIGN,
    _c[MEETING_ADDON_ID] = OfficialAddonType.MEETING,
    _c[MEETING_TEST_ADDON_ID] = OfficialAddonType.MEETING_TEST,
    _c[COUNTDOWN_ADDON_ID] = OfficialAddonType.COUNTDOWN,
    _c[VOTE_ADDON_ID] = OfficialAddonType.VOTE,
    _c[GRAPH_ADDON_ID] = OfficialAddonType.GRAPH,
    _c);

/**
 * 获取第三内容插件的链接类型信息
 * @param type 类型
 * @returns 链接类型信息
 */
function getLinkTypeInfo(type) {
    return LINK_INFO_LIST[type] || LINK_INFO_LIST[LinkType.UNKNOWN];
}
/**
 * 获取内容插件的打印模式
 * @param addonId 插件id
 * @param extraData 插件扩展字段
 * @returns 打印模式
 */
function getPrintMode(addonId, extraData) {
    var type = getLinkType(addonId, extraData);
    return getLinkTypeInfo(type).print;
}
/**
 * 获取第三方内容插件的链接类型
 * @param addonId 插件id
 * @param extraData 插件扩展字段
 * @returns 链接类型
 */
function getLinkType(addonId, extraData) {
    if (extraData === void 0) { extraData = ''; }
    if (addonId !== LINK_ADDON_ID) {
        return LinkType.UNKNOWN;
    }
    try {
        var type = parseInt(JSON.parse(extraData).type, 10);
        return isNaN(type) ? LinkType.UNKNOWN : type;
    }
    catch (error) {
        return LinkType.UNKNOWN;
    }
}
/**
 * 通过ocr识别结果拉取公式插件
 * @param res 识别结果
 * @returns
 */
function invokeFormulaAddonWithLaTexOCR(res) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, DocManager.setOCRRes({ latex: res })];
                case 1:
                    _a.sent();
                    return [2 /*return*/, serviceInvoke(FORMULA_ADDON_ID, {
                            scene: InvokeScene.DOC,
                            funcName: ActionName.DIALOG,
                            funcArgs: [FORMULA_ADDON_WINDOW_OPTIONS],
                        })];
            }
        });
    });
}
/**
 * 获取对应官方插件类型，用于品类侧中做特殊处理
 * @param addonId 插件 id
 * @returns
 */
function getOfficialAddonType(addonId) {
    return OFFICIAL_ADDON_TYPE_MAP[addonId] || OfficialAddonType.UNKNOWN;
}

var PROD_SCENE_CONFIG_URL = 'https://cdn.addon.tencentsuite.com/lib/scene-config/prod.json';

/**
 * 获取场景化相关配置
 * @return 场景化配置
 */
function getSceneConfig() {
    return __awaiter(this, void 0, void 0, function () {
        var data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Axios.get(PROD_SCENE_CONFIG_URL)];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, data];
            }
        });
    });
}

// 场景化插件
var SceneAddon = /** @class */ (function () {
    function SceneAddon() {
        var _this = this;
        // addonId 和商城 market_item_id 的映射表
        this.marketItemMap = new Map();
        // 各个场景化对应的插件 id 列表
        this.sceneAddonIdMap = new Map();
        // topicId 和场景化 scene 的映射表
        this.topicIdToSceneMap = new Map();
        // 是否设置过专题信息
        this.hasSetTopicData = false;
        this.setSceneAddonIdMap = function (topicItem) {
            var id = topicItem.topic.id, items = topicItem.items;
            var scene = _this.topicIdToSceneMap.get(id);
            if (scene) {
                _this.sceneAddonIdMap.set(scene, items.map(function (addonInfo) { return addonInfo.id; }));
            }
        };
        this.setMallTopicData = function (topicItem) {
            var marketingItems = topicItem.marketingItems, items = topicItem.items;
            marketingItems.forEach(function (marketingItem) {
                var addonId = marketingItem.itemId;
                var addonItem = items.find(function (item) { return item.id === addonId; });
                _this.marketItemMap.set(addonId, { marketingItem: marketingItem, addonItem: addonItem });
            });
        };
        this.initSceneConfig = function () { return __awaiter(_this, void 0, void 0, function () {
            var addonConfig, sceneTopicIdsMap_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.sceneConfig) return [3 /*break*/, 2];
                        return [4 /*yield*/, getSceneConfig()];
                    case 1:
                        addonConfig = _a.sent();
                        this.sceneConfig = addonConfig;
                        sceneTopicIdsMap_1 = this.sceneConfig.sceneTopicIdsMap;
                        Object.keys(sceneTopicIdsMap_1).forEach(function (scene) {
                            _this.topicIdToSceneMap.set(sceneTopicIdsMap_1[scene], scene);
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        this.getInitAddonData = function () { return ({ installed: [], uninstalled: [] }); };
    }
    // 单例实现
    SceneAddon.getInstance = function () {
        if (!this.instance) {
            this.instance = new SceneAddon();
        }
        return this.instance;
    };
    SceneAddon.prototype.getAddonList = function (_a) {
        var scene = _a.scene, _b = _a.extraAddonIds, extraAddonIds = _b === void 0 ? [] : _b;
        return __awaiter(this, void 0, void 0, function () {
            var sceneAddonIds;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0: return [4 /*yield*/, this.initSceneConfig()];
                    case 1:
                        _c.sent();
                        return [4 /*yield*/, this.setTopicAddonInfo()];
                    case 2:
                        _c.sent();
                        sceneAddonIds = Array.from(this.sceneAddonIdMap.get(scene) || []);
                        // reverse 会修改原数组，用新数组代替
                        Array.from(extraAddonIds)
                            .reverse()
                            .forEach(function (id) {
                            var index = sceneAddonIds.indexOf(id);
                            // 把 id 提取到第一位
                            if (index !== -1) {
                                sceneAddonIds.splice(index, 1);
                            }
                            sceneAddonIds.unshift(id);
                        });
                        // 过滤不在商城中的插件
                        sceneAddonIds = sceneAddonIds.filter(function (addonId) { return !!_this.marketItemMap.get(addonId); });
                        return [4 /*yield*/, this.getAddonDataByIds(sceneAddonIds)];
                    case 3: return [2 /*return*/, _c.sent()];
                }
            });
        });
    };
    SceneAddon.prototype.setTopicAddonInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var topicAddonInfo, mallTopicId;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // 已经获取过商城数据
                        if (this.hasSetTopicData) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.getTopicData()];
                    case 1:
                        topicAddonInfo = _a.sent();
                        mallTopicId = this.getMallTopicId();
                        topicAddonInfo.forEach(function (topicItem) {
                            _this.setSceneAddonIdMap(topicItem);
                            if (mallTopicId === topicItem.topic.id) {
                                _this.setMallTopicData(topicItem);
                            }
                        });
                        this.setI18NextSceneName();
                        this.hasSetTopicData = true;
                        return [2 /*return*/];
                }
            });
        });
    };
    SceneAddon.prototype.setI18NextSceneName = function () {
        var _this = this;
        var _a, _b;
        var usSceneNameData = {};
        var hkSceneNameData = {};
        Object.keys(this.sceneConfig.sceneAddonNames).forEach(function (addonId) {
            var _a, _b;
            var _c = _this.sceneConfig.sceneAddonNames[addonId], usName = _c.usName, hkName = _c.hkName;
            var cnName = _this.sceneConfig.sceneAddonNames[addonId].cnName;
            cnName = cnName || ((_b = (_a = _this.marketItemMap.get(addonId)) === null || _a === void 0 ? void 0 : _a.addonItem) === null || _b === void 0 ? void 0 : _b.name) || '';
            if (cnName) {
                usSceneNameData[cnName] = usName || cnName;
                hkSceneNameData[cnName] = hkName || cnName;
            }
        });
        (_a = i18next.addResources) === null || _a === void 0 ? void 0 : _a.call(i18next, 'en-US', AddonSDKDocsNamespace, usSceneNameData);
        (_b = i18next.addResources) === null || _b === void 0 ? void 0 : _b.call(i18next, 'zh-HK', AddonSDKDocsNamespace, hkSceneNameData);
    };
    SceneAddon.prototype.getTopicData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var fileType, sceneTopicIdsMap, limitNumber, topicIdInfo, detail;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        fileType = DocManager.getDocData().metaInfo.fileType;
                        sceneTopicIdsMap = this.sceneConfig.sceneTopicIdsMap;
                        limitNumber = 10000;
                        topicIdInfo = __spreadArray(__spreadArray([], __read(Object.values(sceneTopicIdsMap)), false), [this.getMallTopicId()], false).map(function (topicId) { return ({
                            id: topicId,
                            offset: 0,
                            limit: limitNumber,
                        }); });
                        return [4 /*yield*/, getTopicData({
                                addonTypes: [fileType],
                                // 获取全部数据
                                limits: topicIdInfo,
                            })];
                    case 1:
                        detail = (_a.sent()).result.detail;
                        return [2 /*return*/, detail];
                }
            });
        });
    };
    SceneAddon.prototype.getMallTopicId = function () {
        var _a;
        return ((_a = this.sceneConfig) === null || _a === void 0 ? void 0 : _a.mallTopicIdsMap[ua.isMobile ? MallTopic.MOBILE : MallTopic.PC]) || '';
    };
    SceneAddon.prototype.getAddonDataByIds = function (addonIds) {
        return __awaiter(this, void 0, void 0, function () {
            var initAddonData, addons;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        initAddonData = this.getInitAddonData();
                        // 插件 id 长度为 0，返回空的插件数据
                        if (addonIds.length === 0) {
                            return [2 /*return*/, initAddonData];
                        }
                        return [4 /*yield*/, AddonManager$1.getInstance().getAddonsByIds(addonIds, false)];
                    case 1:
                        addons = _a.sent();
                        // 根据 addonIds 顺序设置 initAddonData
                        addonIds.forEach(function (addonId) {
                            var _a, _b;
                            var addon = addons.find(function (addon) { return addon.addonId === addonId; });
                            if (addon) {
                                var name_1 = addon.name, addonId_1 = addon.addonId, installed = addon.installed;
                                // 增加 marketId 和 sceneName 数据
                                var newAddonData = __assign(__assign({}, addon), { marketId: ((_a = _this.marketItemMap.get(addon.addonId)) === null || _a === void 0 ? void 0 : _a.marketingItem.marketingItemId) || '', 
                                    // 优先使用配置的场景化名称
                                    sceneName: _this.getSceneName({
                                        sceneName: (_b = _this.sceneConfig.sceneAddonNames[addonId_1]) === null || _b === void 0 ? void 0 : _b.cnName,
                                        addonName: name_1,
                                    }) });
                                installed ? initAddonData.installed.push(newAddonData) : initAddonData.uninstalled.push(newAddonData);
                            }
                        });
                        return [2 /*return*/, initAddonData];
                }
            });
        });
    };
    SceneAddon.prototype.getSceneName = function (_a) {
        var sceneName = _a.sceneName, addonName = _a.addonName;
        if (sceneName) {
            return $t(sceneName);
        }
        return $t('插入{{$name}}', { $name: $t(addonName) });
    };
    return SceneAddon;
}());

var AddonManager = /** @class */ (function () {
    function AddonManager() {
        // 目的用于标识整个 client 的唯一 id
        this.addonClientId = '';
        // 缓存并管理所有插件
        this.addonsMap = new Map();
        // 当前打开的插件窗口
        this.curAddonWindow = {};
        // 代理地址随机数
        this.proxyURLNonce = '';
        // topicId -> MallAddonDataDetailItem
        this.topicAddonMap = new Map();
        this.addonClientId = v4();
    }
    // 单例实现
    AddonManager.getInstance = function () {
        if (!this.instance) {
            this.instance = new AddonManager();
        }
        return this.instance;
    };
    AddonManager.prototype.getMallAddonByTopicId = function (topicId) {
        return __awaiter(this, void 0, void 0, function () {
            var fileType, _a, detailItem;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        fileType = DocManager.getDocData().metaInfo.fileType;
                        if (this.topicAddonMap.has(topicId)) {
                            return [2 /*return*/, this.topicAddonMap.get(topicId)];
                        }
                        return [4 /*yield*/, getTopicData({
                                addonTypes: [fileType],
                                // 获取全量数据
                                limits: [{ id: topicId, offset: 0, limit: 10000 }],
                            })];
                    case 1:
                        _a = 
                        // 使用对应 topicId 获取的商城插件数据
                        __read.apply(void 0, [(_b.sent()).result.detail, 1]), detailItem = _a[0];
                        this.topicAddonMap.set(topicId, detailItem);
                        return [2 /*return*/, detailItem];
                }
            });
        });
    };
    /**
     * @description: 获取插件列表菜单的请求
     * @param {AddonInfo} addonList
     * @return {Promise<AddonInfo[]>}
     */
    AddonManager.prototype.getAddonMenuRequestList = function (addonList) {
        return __awaiter(this, void 0, void 0, function () {
            var addonMenuRequestList;
            var _this = this;
            return __generator(this, function (_a) {
                addonMenuRequestList = addonList.map(function (addonInfo) {
                    return (function () { return __awaiter(_this, void 0, void 0, function () {
                        var addonId, addon, menuConfiguration;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    addonId = addonInfo.addonId;
                                    addon = this.addonsMap.get(addonId);
                                    if (!addon) return [3 /*break*/, 5];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, this.fetchAddonMenu(addonId)];
                                case 2:
                                    menuConfiguration = _a.sent();
                                    if (menuConfiguration) {
                                        addon.menuConfiguration = menuConfiguration;
                                        return [2 /*return*/, __assign(__assign({}, addonInfo), { menuConfiguration: menuConfiguration })];
                                    }
                                    return [2 /*return*/, addonInfo];
                                case 3:
                                    _a.sent();
                                    return [2 /*return*/, addonInfo];
                                case 4: return [3 /*break*/, 6];
                                case 5: return [2 /*return*/, addonInfo];
                                case 6: return [2 /*return*/];
                            }
                        });
                    }); })();
                });
                return [2 /*return*/, Promise.all(addonMenuRequestList)];
            });
        });
    };
    /**
     * @description: 初始化 addon 的 ServiceHook，生成 addon 信息，并添加到 addonsMap
     * @param {AddonInfo} addonList
     * @return {*}
     */
    AddonManager.prototype.initAddonList = function (addonList) {
        var _this = this;
        addonList.forEach(function (addonInfo) {
            var addonId = addonInfo.addonId;
            // 保留上一次的缓存，只做增量修改
            if (!_this.addonsMap.has(addonId)) {
                var serviceHook = new ServiceHook(addonId);
                var addon = __assign(__assign({}, addonInfo), { serviceHook: serviceHook });
                _this.addonsMap.set(addonId, addon);
            }
            else {
                var addon = _this.addonsMap.get(addonId);
                addon && _this.addonsMap.set(addonId, __assign(__assign({}, addon), addonInfo));
            }
        });
    };
    /**
     * @description: 根据服务端返回插件列表获取正式和体验环境的总插件列表
     * @param {AddonInfo} addonList
     * @return {AddonInfo[]}
     */
    AddonManager.prototype.getAllEnvAddonList = function (addonList) {
        var _a;
        var _this = this;
        var allEnvAddonList = (_a = {},
            _a[AddonEnvironmentType.PRODUCTION] = [],
            _a[AddonEnvironmentType.PREVIEW] = [],
            _a[AddonEnvironmentType.AUDIT] = [],
            _a[AddonEnvironmentType.DEVELOPMENT] = [],
            _a);
        addonList.forEach(function (addon) {
            var envs = addon.envs, addonInfo = __rest(addon, ["envs"]);
            envs === null || envs === void 0 ? void 0 : envs.forEach(function (envInfo) {
                allEnvAddonList[envInfo.env].push(_this.getAddonInfo(envInfo, addonInfo));
            });
            // 兼容 B 端: envs 为空, 直接取根节点下的数据
            if (!(envs === null || envs === void 0 ? void 0 : envs.length)) {
                allEnvAddonList[AddonEnvironmentType.PRODUCTION].push(__assign(__assign({}, addonInfo), { env: AddonEnvironmentType.PRODUCTION, installed: true, 
                    // B 端没有 installTimestamp
                    installTimestamp: '' }));
            }
        });
        return __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(allEnvAddonList[AddonEnvironmentType.PRODUCTION]), false), __read(this.sortAddonListByInstallTime(allEnvAddonList[AddonEnvironmentType.PREVIEW])), false), __read(this.sortAddonListByInstallTime(allEnvAddonList[AddonEnvironmentType.AUDIT])), false), __read(this.sortAddonListByInstallTime(allEnvAddonList[AddonEnvironmentType.DEVELOPMENT])), false);
    };
    AddonManager.prototype.sortAddonListByInstallTime = function (addonList) {
        return addonList.sort(function (first, second) { return Number(second.installTimestamp) - Number(first.installTimestamp); });
    };
    AddonManager.prototype.getSceneAddonList = function (sceneData) {
        return __awaiter(this, void 0, void 0, function () {
            var addonData, installed, uninstalled;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, SceneAddon.getInstance().getAddonList(sceneData)];
                    case 1:
                        addonData = _a.sent();
                        installed = addonData.installed, uninstalled = addonData.uninstalled;
                        this.initAddonList(__spreadArray(__spreadArray([], __read(installed), false), __read(uninstalled), false));
                        return [2 /*return*/, addonData];
                }
            });
        });
    };
    AddonManager.prototype.getAddonInfo = function (envInfo, addonItem) {
        var addonId = addonItem.addonId, name = addonItem.name, isOfficial = addonItem.isOfficial;
        var packageId = envInfo.packageId, staticPath = envInfo.staticPath, env = envInfo.env, installTimestamp = envInfo.installTimestamp;
        var envAddonId = getEnvAddonId(addonId, env);
        return __assign(__assign({}, addonItem), { addonId: envAddonId, name: getEnvContent(name, env), env: env, packageId: packageId, 
            // 非 Production 环境的插件设置为非官方插件
            isOfficial: env === AddonEnvironmentType.PRODUCTION ? isOfficial : false, staticPath: staticPath, installTimestamp: installTimestamp, 
            // 插件列表的插件 installed 固定为 true
            installed: true });
    };
    /**
     * 获取插件列表
     * @param requestData 获取插件列表的请求参数，shouldFetchMenu 为 true，默认拉取插件列表，区分正式和体验
     * @returns 插件列表
     */
    AddonManager.prototype.fetchAddonList = function (requestData) {
        if (requestData === void 0) { requestData = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var addonList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.fetchAddonListPromise) {
                            return [2 /*return*/, this.fetchAddonListPromise];
                        }
                        this.fetchAddonListPromise = this.fetchAddonListRequest(requestData);
                        return [4 /*yield*/, this.fetchAddonListPromise];
                    case 1:
                        addonList = _a.sent();
                        this.fetchAddonListPromise = undefined;
                        return [2 /*return*/, addonList];
                }
            });
        });
    };
    AddonManager.prototype.fetchAddonListRequest = function (requestData) {
        return __awaiter(this, void 0, void 0, function () {
            var fileType, _a, shouldFetchMenu, _b, channel, addonListOptions, addonList, _c, addonInfoList;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        fileType = DocManager.getMetaInfo().fileType;
                        _a = requestData.shouldFetchMenu, shouldFetchMenu = _a === void 0 ? true : _a, _b = requestData.channel, channel = _b === void 0 ? AddonListChannel.PC : _b;
                        addonListOptions = { fileType: fileType, channel: channel };
                        if (!isPrivateEnv()) return [3 /*break*/, 2];
                        return [4 /*yield*/, FaaSHandler.getAddonList(addonListOptions)];
                    case 1:
                        _c = _d.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, getAddonList(addonListOptions)];
                    case 3:
                        _c = _d.sent();
                        _d.label = 4;
                    case 4:
                        addonList = (_c).data.addons;
                        // 特性需求：屏蔽掉QQ体系和企微体系的会议入口 && 过滤 Native 插件
                        addonList = this.filterNativeAddon(this.filterMeetingAddon(addonList));
                        addonInfoList = this.getAllEnvAddonList(addonList);
                        // 2. 初始化所有插件的 ServiceHook，生成 addonInfo ，加入到 addonsMap
                        this.initAddonList(addonInfoList);
                        // 3. 根据 shouldFetchMenu 判断是否去拉取插件配置（插件自身配置 or 插件子菜单配置），不拉取直接返回对应 list
                        if (shouldFetchMenu) {
                            return [2 /*return*/, this.getAddonMenuRequestList(addonInfoList)];
                        }
                        return [2 /*return*/, addonInfoList];
                }
            });
        });
    };
    /**
     * 获取插件子菜单
     * @param addonId 插件id
     * @returns 插件子菜单
     */
    AddonManager.prototype.fetchAddonMenu = function (addonId) {
        return __awaiter(this, void 0, void 0, function () {
            var addon, serviceHook, fileType, _a, menuConfiguration;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getAddon(addonId)];
                    case 1:
                        addon = _b.sent();
                        serviceHook = addon.serviceHook;
                        fileType = DocManager.getMetaInfo().fileType;
                        return [4 /*yield*/, serviceHook.onInitMenus()];
                    case 2:
                        _a = (_b.sent()).data, menuConfiguration = _a === void 0 ? [] : _a;
                        // 需要在此处筛选，因为品类侧会直接调用该接口返回插件配置
                        // TODO(muyanyang): 暂时屏蔽PPT的QQ音乐入口,后续去掉
                        if (addonId === LINK_ADDON_ID) {
                            menuConfiguration = this.filterQQMusicInSlide(menuConfiguration, fileType);
                        }
                        addon.menuConfiguration = menuConfiguration;
                        return [2 /*return*/, menuConfiguration];
                }
            });
        });
    };
    /**
     * 将context解析为插件
     * @param context: 需要识别的内容
     * @returns 若可以识别，返回插件化后的结果，否则返回null
     */
    AddonManager.prototype.parseAsAddon = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var supportedAddons, supportedAddonId, serviceHook, parseRes, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getSupportedAddon(context)];
                    case 1:
                        supportedAddons = _b.sent();
                        supportedAddonId = supportedAddons.find(Boolean);
                        if (!supportedAddonId) {
                            return [2 /*return*/, null];
                        }
                        return [4 /*yield*/, AddonManager.getInstance().getAddon(supportedAddonId)];
                    case 2:
                        serviceHook = (_b.sent()).serviceHook;
                        return [4 /*yield*/, serviceHook.onParseAsAddon(context)];
                    case 3:
                        parseRes = _b.sent();
                        if (!parseRes) return [3 /*break*/, 5];
                        parseRes.addonId = supportedAddonId;
                        _a = parseRes;
                        return [4 /*yield*/, this.getIconOfAddonLink(context, supportedAddonId)];
                    case 4:
                        _a.iconPath = _b.sent();
                        _b.label = 5;
                    case 5: return [2 /*return*/, parseRes];
                }
            });
        });
    };
    /**
     * 根据id获取插件
     * @param addonId 插件id
     * @param {GetAddonConfig} needInstalled 插件是否需要已安装
     * @param {GetAddonConfig} shouldGetLatest 是否清除缓存，需要获取最新的插件
     * @return 插件
     */
    AddonManager.prototype.getAddon = function (addonId, _a) {
        var _b = _a === void 0 ? { needInstalled: true, shouldGetLatest: false } : _a, needInstalled = _b.needInstalled, shouldGetLatest = _b.shouldGetLatest;
        return __awaiter(this, void 0, void 0, function () {
            var addon;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (shouldGetLatest
                            // 带环境的插件不清缓存。
                            // getAddonsByIds 不支持获取多环境信息，又因为多环境使用场景有限，只能从 editor-addons 接口获取信息
                            // 因此这里带环境的插件不清缓存，保证 getAddon 能获取到多环境插件信息
                            && isOriginalAddonId(addonId)) {
                            this.addonsMap.delete(addonId);
                        }
                        addon = this.addonsMap.get(addonId);
                        if (addon) {
                            return [2 /*return*/, addon];
                        }
                        if (!(isConsumerEnv() && !isPrivateEnv())) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getAddonsByIds([addonId], needInstalled)];
                    case 1: 
                    // 如果获取不到插件则发起插件查询请求
                    return [2 /*return*/, (_c.sent())[0]];
                    case 2: 
                    // 非 C 端环境暂未上线查询单个，先异步等待列表查询接口
                    return [4 /*yield*/, AddonManager.getInstance().fetchAddonList()];
                    case 3:
                        // 非 C 端环境暂未上线查询单个，先异步等待列表查询接口
                        _c.sent();
                        if (this.addonsMap.has(addonId)) {
                            return [2 /*return*/, this.addonsMap.get(addonId)];
                        }
                        throw new Exception(AddonErrorCode.ADDON_NOT_FOUND);
                }
            });
        });
    };
    /**
     * 获取最新的插件，会请求并更新缓存，此方法后台只上线了 C 端，在 B 端不可用
     * @param addonIds 插件Ids，至少传一个
     * @param needInstalled 插件是否需要已安装
     * @returns 返回插件数组
     */
    AddonManager.prototype.getAddonsByIds = function (addonIds, needInstalled) {
        if (needInstalled === void 0) { needInstalled = true; }
        return __awaiter(this, void 0, void 0, function () {
            var addons, addonList;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getAddons(addonIds)];
                    case 1:
                        addons = (_a.sent()).addons;
                        addonList = [];
                        addons.forEach(function (addon) {
                            var basicInfo = addon.basicInfo, packageId = addon.packageId, installed = addon.installed;
                            // 当插件类型为非drive时，static属性必有
                            var newAddon = __assign(__assign({}, basicInfo), { staticHost: basicInfo.staticHost, staticPath: basicInfo.staticPath, packageId: packageId.prodId, renderType: basicInfo.renderType, serviceHook: new ServiceHook(addon.basicInfo.addonId), installed: installed, 
                                // 场景化入口,不需要安装时间
                                installTimestamp: '', 
                                // 场景化入口不支持多环境
                                env: AddonEnvironmentType.PRODUCTION });
                            _this.addonsMap.set(newAddon.addonId, newAddon);
                            // 不需要安装和需要安装且已安装，把插件信息插入数组返回
                            if (!needInstalled || (needInstalled && installed)) {
                                addonList.push(newAddon);
                            }
                        });
                        if (addonList.length === 0) {
                            throw new Exception(AddonErrorCode.ADDON_NOT_FOUND);
                        }
                        return [2 /*return*/, addonList];
                }
            });
        });
    };
    /**
     * 根据插件信息获取iconPath
     * @param url: 插件链接, addonId: 插件id
     * @returns
     */
    AddonManager.prototype.getIconOfAddonLink = function (url, addonId) {
        return __awaiter(this, void 0, void 0, function () {
            var addon, supportParseDomains;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAddon(addonId, { needInstalled: false })];
                    case 1:
                        addon = _a.sent();
                        supportParseDomains = this.domainsRegExp(url, addon);
                        if (!supportParseDomains) {
                            return [2 /*return*/, ''];
                        }
                        return [2 /*return*/, "https://".concat(addon.staticHost, "/").concat(addon.staticPath, "/").concat(supportParseDomains.icon)];
                }
            });
        });
    };
    /**
     * 根据addon window的encAddonId获取插件
     * @param encAddonId
     * @returns 插件
     */
    AddonManager.prototype.getAddonByCurWindow = function (encAddonId) {
        return __awaiter(this, void 0, void 0, function () {
            var addonWindow, addon, addonId, prodAddonId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        addonWindow = this.curAddonWindow[encAddonId];
                        if (!addonWindow) {
                            throw new Exception(AddonErrorCode.ADDON_NOT_FOUND);
                        }
                        return [4 /*yield*/, this.getAddon(addonWindow.addonId)];
                    case 1:
                        addon = _a.sent();
                        addonId = addon.addonId;
                        prodAddonId = getEnvAddonId(addonId, AddonEnvironmentType.PRODUCTION);
                        // addonId 修改为正式环境 id，后续流程根据 addon 中的 env 判断环境
                        return [2 /*return*/, __assign(__assign({}, addon), { addonId: prodAddonId })];
                }
            });
        });
    };
    /**
     * 添加当前打开的addon window
     * @param windowInfo addon window 信息
     */
    AddonManager.prototype.addCurAddonWindow = function (windowInfo) {
        this.curAddonWindow[windowInfo.encAddonId] = windowInfo;
    };
    /**
     * 移除当前打开的addon window
     * @param encAddonId
     */
    AddonManager.prototype.removeCurAddonWindow = function (encAddonId) {
        if (this.curAddonWindow[encAddonId]) {
            this.curAddonWindow[encAddonId] = undefined;
        }
    };
    /**
     * 获取插件 map，addonId -> addonInfo
     */
    AddonManager.prototype.getAddonMap = function () {
        return this.addonsMap;
    };
    /**
     * 通过encAddonId获取当前addon window的身份信息
     * @param encAddonId
     * @returns addon window身份信息
     */
    AddonManager.prototype.getCurAddonWindowById = function (encAddonId) {
        return this.curAddonWindow[encAddonId];
    };
    /**
     * 获取 web 插件 iframe 显示的代理 url
     * @param url 插件的 url
     * @param addonId 插件 id
     * @returns 代理地址
     */
    AddonManager.prototype.getWebAddonProxyURL = function (url, addonId) {
        var _a;
        // 兼容新旧版AddonProperty中embedUrl的内容（私有化环境不用代理）
        // 旧版embedUrl：第三方传入的可展示链接的基础上，加了proxy前缀+参数后缀
        // 新版embedUrl：第三方传入的可展示链接
        if (isPrivateEnv() || url.startsWith(WEB_ADDON_PROXY_URL)) {
            return url;
        }
        var _b = DocManager.getMetaInfo(), fileId = _b.fileId, fileType = _b.fileType, uid = _b.uid, creatorId = _b.creatorId;
        var packageId = (_a = this.addonsMap.get(addonId)) === null || _a === void 0 ? void 0 : _a.packageId;
        if (!this.proxyURLNonce) {
            this.proxyURLNonce = generateProxyURLNonce();
        }
        return addURLQueryParam(WEB_ADDON_PROXY_URL, {
            uid: uid,
            creator: creatorId,
            redirect: encodeURIComponent(url),
            docType: fileType,
            docID: fileId,
            addonID: addonId,
            packageID: packageId !== null && packageId !== void 0 ? packageId : '',
            nonce: this.proxyURLNonce,
        });
    };
    /**
     * 获取官方插件菜单栏黑白icon
     * @param addonId: 插件id
     * @returns
     */
    AddonManager.prototype.getOfficialAddonIcon = function (addonId) {
        var addonType = getOfficialAddonType(addonId);
        return OFFICIAL_ICON_MAPPING[addonType] || '';
    };
    // 特性需求：屏蔽掉QQ体系和企微体系的会议入口
    AddonManager.prototype.filterMeetingAddon = function (addonList) {
        return addonList.filter(function (item) { return !(item.addonId === MEETING_ADDON_ID && MultiTools.loginType() !== 'wx'); });
    };
    // 过滤登月等 Native 插件
    AddonManager.prototype.filterNativeAddon = function (addonList) {
        var _this = this;
        return addonList.filter(function (item) { return !_this.isNativeAddon(item.addonId); });
    };
    AddonManager.prototype.filterQQMusicInSlide = function (menuConfiguration, fileType) {
        // TODO(muyanyang): 暂时屏蔽PPT的QQ音乐入口,后续去掉
        return menuConfiguration.filter(function (menu) { return !(menu.title === QQ_MUSIC_TITLE && fileType === FileType.SLIDE); });
    };
    AddonManager.prototype.isNativeAddon = function (addonId) {
        return NATIVE_ADDON_ID_LIST.includes(addonId);
    };
    // 获取支持解析内容的插件
    AddonManager.prototype.getSupportedAddon = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            var addonInfoList, supportedAddonList;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        addonInfoList = Object.values(Object.fromEntries(this.addonsMap));
                        if (!!addonInfoList) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.fetchAddonList()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        supportedAddonList = addonInfoList.map(function (addon) {
                            var supportParseDomains = _this.domainsRegExp(context, addon);
                            return supportParseDomains ? addon.addonId : '';
                        });
                        return [2 /*return*/, supportedAddonList];
                }
            });
        });
    };
    AddonManager.prototype.domainsRegExp = function (url, addon) {
        var supportParseDomains = addon.config.domains.find(function (_a) {
            var _b = _a.domain, domain = _b === void 0 ? '' : _b;
            var regex = new RegExp(domain.replace(/\*/g, '[^ ]*'));
            return regex.test(url);
        });
        return supportParseDomains;
    };
    /**
     * 获取 iframe 在小程序中的渲染白名单
     * @return 白名单
     */
    AddonManager.prototype.getMiniAppIframeWhiteList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var whiteList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getMiniAppRenderWhiteList()];
                    case 1:
                        whiteList = (_a.sent()).data.whiteList;
                        return [2 /*return*/, whiteList];
                }
            });
        });
    };
    /**
     * 协同编辑下，生成唯一 clientId
     *
     * @return addonClientId
     */
    AddonManager.prototype.getAddonClientId = function () {
        return this.addonClientId;
    };
    return AddonManager;
}());
var AddonManager$1 = AddonManager;

var AddonContentMessageService = /** @class */ (function () {
    function AddonContentMessageService() {
    }
    AddonContentMessageService.register = function () {
        window.addEventListener('message', this.receiveMessage, false);
    };
    AddonContentMessageService.unregister = function () {
        window.removeEventListener('message', this.receiveMessage, false);
    };
    AddonContentMessageService.receiveMessage = function (event) {
        var origin = event.origin, source = event.source, data = event.data;
        if (!source) {
            return;
        }
        if (!AddonContentMessageService.isAvailableMsg(event)) {
            return;
        }
        var sourceWindow = source;
        // 将消息交给 DocAddonService 处理,并拿到处理结果,回调给插件内容
        AddonContentMessageService.handleReceiveMessage(data, origin)
            .then(function (res) {
            sourceWindow === null || sourceWindow === void 0 ? void 0 : sourceWindow.postMessage(res, origin);
        })
            .catch(function (error) {
            sourceWindow === null || sourceWindow === void 0 ? void 0 : sourceWindow.postMessage(error, origin);
        });
    };
    AddonContentMessageService.isAvailableMsg = function (_a) {
        var data = _a.data;
        return data === null || data === void 0 ? void 0 : data.fromTencentDocsAddonContent;
    };
    AddonContentMessageService.handleReceiveMessage = function (messageData, origin) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var funcName, addonId, resRet, resMsg, baseRet, addon, data, addonConfigContent, addonContentWhileList, noNeedWhileList, _c, injectedData, e_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        funcName = messageData.funcName, addonId = messageData.addonId;
                        resRet = AddonErrorCode.SUCCESS;
                        resMsg = CODE_MESSAGE_MAPPING[resRet];
                        baseRet = {
                            funcName: funcName,
                            fromTencentDocsAddonPlatform: true,
                        };
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 5, , 6]);
                        if (!(funcName === InjectedFuncName.GET_INJECTED_DATA)) return [3 /*break*/, 4];
                        return [4 /*yield*/, AddonManager$1.getInstance().getAddon(addonId)];
                    case 2:
                        addon = _d.sent();
                        return [4 /*yield*/, addon.serviceHook.onConfigureBlock()];
                    case 3:
                        data = (_d.sent()).data;
                        addonConfigContent = addon.config.content;
                        addonContentWhileList = addonConfigContent === null || addonConfigContent === void 0 ? void 0 : addonConfigContent.urls;
                        noNeedWhileList = (addonContentWhileList === null || addonContentWhileList === void 0 ? void 0 : addonContentWhileList.length) === 1 && addonContentWhileList[0] === '*';
                        if (!addonConfigContent || (!noNeedWhileList && !(addonContentWhileList === null || addonContentWhileList === void 0 ? void 0 : addonContentWhileList.includes(origin)))) {
                            // 校验 iframe origin 在插件的白名单内
                            resRet = AddonErrorCode.MESSAGE_RESOURCE_ILLEGAL;
                            return [2 /*return*/, { ret: resRet, msg: CODE_MESSAGE_MAPPING[resRet], data: baseRet }];
                        }
                        if (!((_b = (_a = addon.config.content) === null || _a === void 0 ? void 0 : _a.invokeFuncs) === null || _b === void 0 ? void 0 : _b.includes(funcName))) {
                            // 校验方法在插件的调用白名单内
                            resRet = AddonErrorCode.MESSAGE_CONTEXT_ILLEGAL;
                            return [2 /*return*/, { ret: resRet, msg: CODE_MESSAGE_MAPPING[resRet], data: baseRet }];
                        }
                        _c = (data !== null && data !== void 0 ? data : {}).injectedData, injectedData = _c === void 0 ? {} : _c;
                        return [2 /*return*/, {
                                data: __assign({ injectedData: injectedData }, baseRet),
                                ret: resRet,
                                msg: resMsg,
                            }];
                    case 4: return [3 /*break*/, 6];
                    case 5:
                        e_1 = _d.sent();
                        resRet = AddonErrorCode.CALL_ADDON_API_ERROR;
                        return [2 /*return*/, { ret: resRet, msg: "".concat(CODE_MESSAGE_MAPPING[resRet], ":").concat(e_1.message), data: baseRet }];
                    case 6: return [2 /*return*/, {
                            ret: AddonErrorCode.SUCCESS,
                            msg: resMsg,
                            data: baseRet,
                        }];
                }
            });
        });
    };
    return AddonContentMessageService;
}());

var ReportAttr;
(function (ReportAttr) {
    ReportAttr["HANDLE_SYSTEM_MESSAGE"] = "\u63D2\u4EF6\u4FE1\u606F\u5904\u7406-\u7CFB\u7EDF\u51FD\u6570\u8C03\u7528";
    ReportAttr["HANDLE_CUSTOM_MESSAGE"] = "\u63D2\u4EF6\u4FE1\u606F\u5904\u7406-\u4E91\u51FD\u6570\u8C03\u7528";
})(ReportAttr || (ReportAttr = {}));

var MessageService = /** @class */ (function () {
    function MessageService() {
    }
    MessageService.register = function () {
        window.addEventListener('message', this.receiveMessage, false);
    };
    MessageService.unregister = function () {
        window.removeEventListener('message', this.receiveMessage, false);
    };
    // 接收插件的消息
    MessageService.receiveMessage = function (event) {
        var origin = event.origin, source = event.source, data = event.data;
        if (!source) {
            return;
        }
        if (!MessageService.isAvailableMsg(event)) {
            return;
        }
        var sourceWindow = source;
        // 将消息交给DocAddonService处理,并拿到处理结果,回调给插件
        MessageService.handleReceiveMessage(data)
            .then(function (res) {
            sourceWindow === null || sourceWindow === void 0 ? void 0 : sourceWindow.postMessage(res, origin);
        })
            .catch(function (error) {
            sourceWindow === null || sourceWindow === void 0 ? void 0 : sourceWindow.postMessage(error, origin);
        });
    };
    // 目前专门为会议数据上报添加白名单
    MessageService.isValidReport = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var funcName, encAddonId, addonId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        funcName = data.funcName, encAddonId = data.encAddonId;
                        if (funcName !== CustomizedType.REPORT) {
                            return [2 /*return*/, true];
                        }
                        return [4 /*yield*/, AddonManager$1.getInstance().getAddonByCurWindow(encAddonId)];
                    case 1: return [4 /*yield*/, _a.sent()];
                    case 2:
                        addonId = (_a.sent()).addonId;
                        return [2 /*return*/, REPORT_VALID_LIST.includes(addonId)];
                }
            });
        });
    };
    MessageService.isAvailableMsg = function (_a) {
        var origin = _a.origin, data = _a.data;
        if (origin !== location.origin) {
            return false;
        }
        if (!this.isValidReport(data)) {
            return false;
        }
        // 必须要有消息id和encAddonId
        return (data === null || data === void 0 ? void 0 : data.msgId) && (data === null || data === void 0 ? void 0 : data.encAddonId);
    };
    MessageService.handleReceiveMessage = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var encAddonId, funcName, funcArgs, msgId, type, href, addon, staticPath, pathname, resData, resRet, resMsg, _a;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        encAddonId = data.encAddonId, funcName = data.funcName, funcArgs = data.funcArgs, msgId = data.msgId, type = data.type, href = data.href;
                        return [4 /*yield*/, AddonManager$1.getInstance().getAddonByCurWindow(encAddonId)];
                    case 1:
                        addon = _d.sent();
                        staticPath = addon.staticPath;
                        pathname = URLParse(href).pathname;
                        if (!pathname.startsWith("/".concat(staticPath))) {
                            return [2 /*return*/, { ret: AddonErrorCode.ADDON_NOT_FOUND, msg: CODE_MESSAGE_MAPPING[AddonErrorCode.ADDON_NOT_FOUND] }];
                        }
                        resRet = AddonErrorCode.SUCCESS;
                        resMsg = CODE_MESSAGE_MAPPING[resRet];
                        _a = type;
                        switch (_a) {
                            case MessageType.SYSTEM: return [3 /*break*/, 2];
                            case MessageType.CUSTOM: return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 6];
                    case 2: return [4 /*yield*/, this.handleSystemMessage(addon, funcName, funcArgs)];
                    case 3:
                        (_b = _d.sent(), resData = _b.data, resRet = _b.ret, resMsg = _b.msg);
                        return [3 /*break*/, 7];
                    case 4: return [4 /*yield*/, this.handleCustomMessage(addon, funcName, funcArgs)];
                    case 5:
                        (_c = _d.sent(), resData = _c.data, resRet = _c.ret, resMsg = _c.msg);
                        return [3 /*break*/, 7];
                    case 6: return [3 /*break*/, 7];
                    case 7: return [2 /*return*/, { ret: resRet, msg: resMsg, data: { msgId: msgId, type: type, data: resData } }];
                }
            });
        });
    };
    MessageService.handleSystemMessage = function (addon, funcName, funcArgs) {
        return __awaiter(this, void 0, void 0, function () {
            var actionActuator, resData, resRet, resMsg, addonId, packageId, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        actionActuator = new ActionActuator(addon);
                        resRet = AddonErrorCode.SUCCESS;
                        resMsg = CODE_MESSAGE_MAPPING[resRet];
                        addonId = addon.addonId, packageId = addon.packageId;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, actionActuator.executeActionItem(funcName, funcArgs)];
                    case 2:
                        resData = _a.sent();
                        reportManager.reportStatus({
                            attrid: ReportAttr.HANDLE_SYSTEM_MESSAGE,
                            status: ReportStatus.SUCCESS,
                            addonId: addonId,
                            packageId: packageId,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        (resData = error_1.data, resRet = error_1.code, resMsg = error_1.msg);
                        reportManager.reportStatus({
                            attrid: ReportAttr.HANDLE_SYSTEM_MESSAGE,
                            status: ReportStatus.FAIL,
                            errmsg: JSON.stringify(error_1),
                            addonId: addonId,
                            packageId: packageId,
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        resRet = this.handleCatchResRetFail(resRet);
                        return [2 /*return*/, { data: resData, ret: resRet, msg: resMsg }];
                }
            });
        });
    };
    MessageService.handleCustomMessage = function (addon, funcName, funcArgs) {
        return __awaiter(this, void 0, void 0, function () {
            var env, originalAddonId, packageId, addonId, resData, resRet, resMsg, invokeOptions, error_2;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        env = addon.env, originalAddonId = addon.addonId, packageId = addon.packageId;
                        addonId = getEnvAddonId(originalAddonId, env);
                        resRet = AddonErrorCode.SUCCESS;
                        resMsg = CODE_MESSAGE_MAPPING[resRet];
                        invokeOptions = {
                            scene: InvokeScene.ADDON,
                            funcName: funcName,
                            funcArgs: funcArgs,
                        };
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, serviceInvoke(addonId, invokeOptions)];
                    case 2:
                        (_a = _b.sent(), resData = _a.data, resRet = _a.ret, resMsg = _a.msg);
                        reportManager.reportStatus({
                            attrid: ReportAttr.HANDLE_CUSTOM_MESSAGE,
                            status: ReportStatus.SUCCESS,
                            addonId: originalAddonId,
                            packageId: packageId,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _b.sent();
                        (resData = error_2.data, resRet = error_2.code, resMsg = error_2.msg);
                        reportManager.reportStatus({
                            attrid: ReportAttr.HANDLE_CUSTOM_MESSAGE,
                            status: ReportStatus.FAIL,
                            errmsg: JSON.stringify(error_2),
                            addonId: originalAddonId,
                            packageId: packageId,
                        });
                        return [3 /*break*/, 4];
                    case 4:
                        resRet = this.handleCatchResRetFail(resRet);
                        return [2 /*return*/, { data: resData, ret: resRet, msg: resMsg }];
                }
            });
        });
    };
    // 用于处理未获得resRet数据的情况
    // TODO(muyanyang):此处新增了用于反馈无效返回值的错误码，具体针对这部分错误怎么处理待讨论排期
    MessageService.handleCatchResRetFail = function (resRet) {
        return resRet !== null && resRet !== void 0 ? resRet : AddonErrorCode.FUNC_NETWORK_FAIL;
    };
    return MessageService;
}());

/**
 * 判断 menu configuration 的类型
 * @param menuConfiguration
 * @returns 类型
 */
function getMenuConfigurationType(menuConfiguration) {
    var e_1, _a;
    var typeGuardMap = new Map([
        [MenuConfigurationType.ACTION, isMenuConfigurationTypeAction],
        [MenuConfigurationType.MENUS, isMenuConfigurationTypeMenus],
    ]);
    try {
        for (var typeGuardMap_1 = __values(typeGuardMap), typeGuardMap_1_1 = typeGuardMap_1.next(); !typeGuardMap_1_1.done; typeGuardMap_1_1 = typeGuardMap_1.next()) {
            var _b = __read(typeGuardMap_1_1.value, 2), key = _b[0], value = _b[1];
            if (value(menuConfiguration)) {
                return key;
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (typeGuardMap_1_1 && !typeGuardMap_1_1.done && (_a = typeGuardMap_1.return)) _a.call(typeGuardMap_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return MenuConfigurationType.UNKNOWN;
}
function isMenuConfigurationTypeAction(menuConfiguration) {
    return checkPropertiesInObject(['name', 'options'], menuConfiguration);
}
function isMenuConfigurationTypeMenus(menuConfiguration) {
    return Array.isArray(menuConfiguration);
}

/**
 *  处理插件postmessage个性化需求，临时方案
 */
var CustomizedMessageService = /** @class */ (function () {
    function CustomizedMessageService() {
    }
    CustomizedMessageService.register = function () {
        window.addEventListener('message', this.receiveMessage, false);
    };
    CustomizedMessageService.unregister = function () {
        window.removeEventListener('message', this.receiveMessage, false);
    };
    // 接收插件的消息
    CustomizedMessageService.receiveMessage = function (event) {
        // 校验postmessage的合法性
        if (!CustomizedMessageService.isAvailableMsg(event)) {
            return;
        }
        CustomizedMessageService.handleReceiveMessage(event);
    };
    CustomizedMessageService.isInValidMsgData = function (data) {
        var addonId = data.addonId, type = data.type;
        return !addonId || !type;
    };
    CustomizedMessageService.isAvailableMsg = function (_a) {
        var data = _a.data, source = _a.source, origin = _a.origin;
        var addonId = data.addonId, type = data.type;
        // 检查是否有source
        if (!source) {
            return false;
        }
        if (CustomizedMessageService.isInValidMsgData(data)) {
            return false;
        }
        var validCheck = VALIDITY_MAPPING[type];
        if (!validCheck) {
            return false;
        }
        // 检查对应addonId
        var isValidAddon = validCheck.validAddon.includes(addonId);
        // 检查对应origin
        var isValidOrigin = validCheck.validOrigin.includes(origin);
        return isValidAddon && isValidOrigin;
    };
    CustomizedMessageService.handleReceiveMessage = function (event) {
        var _a, _b, _c, _d, _e, _f;
        var data = event.data;
        var type = data.type, payload = data.payload;
        switch (type) {
            // 数据上报report
            case CustomizedType.REPORT: {
                (_b = (_a = DocManager.getService().advanced).report) === null || _b === void 0 ? void 0 : _b.call(_a, payload);
                break;
            }
            case CustomizedType.SHOW_SNACKBAR: {
                (_d = (_c = DocManager.getService().ui).showSnackbar) === null || _d === void 0 ? void 0 : _d.call(_c, payload);
                break;
            }
            case CustomizedType.UPDATE_IFRAME: {
                (_f = (_e = DocManager.getService().advanced).updateIframe) === null || _f === void 0 ? void 0 : _f.call(_e, payload);
                break;
            }
        }
    };
    return CustomizedMessageService;
}());

/**
 * 对品类 global 下注入 addonApi 命名空间
 */
var DocNamespaceManager = /** @class */ (function () {
    function DocNamespaceManager() {
    }
    DocNamespaceManager.initDocGlobalNamespace = function () {
        if (!window[this.namespace]) {
            window[this.namespace] = {};
        }
    };
    DocNamespaceManager.setAddonNamespace = function (key, value) {
        this.addonApi.set(key, value);
        window[this.namespace] = Object.fromEntries(this.addonApi);
    };
    DocNamespaceManager.namespace = 'addonApi';
    DocNamespaceManager.addonApi = new Map();
    return DocNamespaceManager;
}());

var JSBridgeInvokeService = /** @class */ (function () {
    function JSBridgeInvokeService() {
    }
    JSBridgeInvokeService.mountJSBridgeInvoke = function () {
        if (this.isNativeLegal()) {
            DocNamespaceManager.setAddonNamespace('invoke', DocAddonBridge.invokeAddonWithFunc.bind(DocAddonBridge));
            DocNamespaceManager.setAddonNamespace('auth', AddonAuthManager.getInstance().handleAddonAuth.bind(AddonAuthManager));
        }
    };
    JSBridgeInvokeService.isNativeLegal = function () {
        return this.nativeWhiteList.some(function (name) { return isUAExist(name); });
    };
    JSBridgeInvokeService.nativeWhiteList = [
        // TXEduPlatform: 登月客户端
        'TXEduPlatform',
        'TXEduPlatformDev',
        'TXEduPlatformRuntime',
    ];
    return JSBridgeInvokeService;
}());

// 插件自定义事件的 target 类型
var AddonEventTarget;
(function (AddonEventTarget) {
    AddonEventTarget["HINA"] = "hina";
    AddonEventTarget["IFRAME"] = "iframe";
    AddonEventTarget["DIALOG"] = "dialog";
    AddonEventTarget["SIDEBAR"] = "sidebar";
})(AddonEventTarget || (AddonEventTarget = {}));

var MAX_REQUESTS_THRESHOLD = 3; // 图片 icon 请求最大次数
var REQUEST_IMG_COUNT = new Map(); // 离线或请求错误时候, 尝试请求次数
function hideImage(event, iconSrc) {
    var e = event;
    if (!iconSrc) {
        e.currentTarget.style.visibility = 'hidden';
        return;
    }
    var hasRequestBefore = REQUEST_IMG_COUNT.has(iconSrc); // 是否之前请求过
    // 如果之前就没请求过
    if (!hasRequestBefore) {
        e.currentTarget.src = iconSrc; // 重新请求一次
        REQUEST_IMG_COUNT.set(iconSrc, 1);
        return;
    }
    // 遇到断网, 可能会请求多次情况
    var requestCount = REQUEST_IMG_COUNT.get(iconSrc);
    // 如果请求次数低于 阈值, 重新请求直到 阈值
    if (requestCount && requestCount <= MAX_REQUESTS_THRESHOLD) {
        e.currentTarget.src = iconSrc; // 重新请求一次
        var count = REQUEST_IMG_COUNT.get(iconSrc) || 0;
        REQUEST_IMG_COUNT.set(iconSrc, count + 1);
        return;
    }
    // 如果请求次数高于 阈值, 直接不展示图片
    // 然后重置请求次数, 为下一次打开菜单做准备
    if (requestCount && requestCount >= MAX_REQUESTS_THRESHOLD) {
        e.currentTarget.style.visibility = 'hidden';
        REQUEST_IMG_COUNT.set(iconSrc, 0);
        return;
    }
    e.currentTarget.style.visibility = 'hidden';
}

var img$5 = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M14.35%2c18.9 C14.7089851%2c18.9 15%2c19.1910149 15%2c19.55 C15%2c19.9089851 14.7089851%2c20.2 14.35%2c20.2 L9.65%2c20.2 C9.29101491%2c20.2 9%2c19.9089851 9%2c19.55 C9%2c19.1910149 9.29101491%2c18.9 9.65%2c18.9 L14.35%2c18.9 Z M15.2115385%2c4 C15.625752%2c4 15.9615385%2c4.33578644 15.9615385%2c4.75 L15.961%2c7.2 L18%2c7.2 C18.5128358%2c7.2 18.9355072%2c7.58604019 18.9932723%2c8.08337887 L19%2c8.2 L19%2c15 C19%2c16.7673112 17.5673112%2c18.2 15.8%2c18.2 L15.8%2c18.2 L8.2%2c18.2 C6.4326888%2c18.2 5%2c16.7673112 5%2c15 L5%2c15 L5%2c8.2 C5%2c7.64771525 5.44771525%2c7.2 6%2c7.2 L6%2c7.2 L8%2c7.2 L8%2c4.75 C8%2c4.33578644 8.33578644%2c4 8.75%2c4 C9.16421356%2c4 9.5%2c4.33578644 9.5%2c4.75 L9.5%2c7.2 L14.461%2c7.2 L14.4615385%2c4.75 C14.4615385%2c4.33578644 14.7973249%2c4 15.2115385%2c4 Z M17.7%2c8.501 L6.3%2c8.501 L6.3%2c15 L6.3057164%2c15.1484839 C6.38146567%2c16.1284272 7.2006276%2c16.9 8.2%2c16.9 L8.2%2c16.9 L15.8%2c16.9 L15.9484839%2c16.8942836 C16.9284272%2c16.8185343 17.7%2c15.9993724 17.7%2c15 L17.7%2c15 L17.7%2c8.501 Z' fill='%23464D5A'/%3e%3c/svg%3e";

var img$4 = "data:image/svg+xml,%3c%3fxml version='1.0' encoding='UTF-8'%3f%3e%3csvg width='24px' height='24px' viewBox='0 0 24 24' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3ctitle%3emenu_add%3c/title%3e %3cg id='PC' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3e %3cg id='%e7%bc%96%e7%bb%84'%3e %3crect id='%e7%9f%a9%e5%bd%a2' x='0' y='0' width='24' height='24' rx='2'%3e%3c/rect%3e %3cpath d='M12.75%2c5 L12.75%2c11.25 L19%2c11.25 L19%2c12.75 L12.75%2c12.75 L12.75%2c19 L11.25%2c19 L11.25%2c12.749 L5%2c12.75 L5%2c11.25 L11.25%2c11.249 L11.25%2c5 L12.75%2c5 Z' id='%e5%bd%a2%e7%8a%b6%e7%bb%93%e5%90%88' fill='%23464D5A' fill-rule='nonzero'%3e%3c/path%3e %3c/g%3e %3c/g%3e%3c/svg%3e";

var AddonMenuSchemaPrefix = 'addon-';
var AddonSubMenuSchemaPrefix = 'sub-addon-';
var SDKUnofficialAddonMenuKey = 'sdk-unofficial-addons';
var SDKUnofficialAddonToolbarKey = 'sdk-unofficial-addons-toolbar';
var WorkbenchBuiltInSchema = {
    DIVIDER: 'divider',
    NONE: 'none',
};
var ThirdPartyAddonsPanelTitleSchema = 'third-party-addons-panel-title';
var MenuItemStyle = {
    width: '152px',
    padding: '9px 16px',
};
var PanelTitleStyle = __assign(__assign({}, MenuItemStyle), { opacity: 'initial', color: 'rgba(0,0,0,.4)', cursor: 'default' });
var getThirdPartyAddonsPanelTitleConfig = function () { return ({
    name: ThirdPartyAddonsPanelTitleSchema,
    content: $t('第三方插件'),
    respectOffline: true,
    style: PanelTitleStyle,
}); };
var SecondLevelMenuAddons = [
    // 插入第三方内容 b端
    'b51399bf7c8445eea8c196a4c3c8af3c',
    // 插入第三方内容 c端
    '0b69e1b9517e44a4aee35d33ee021b55',
];
var AddonMallsSchema = ['divider', 'addon-mall-setting', 'addon-mall-shop'];
var getAddonMallMenuConfigs = function () { return [
    {
        name: 'addon-mall-setting',
        content: $t('管理插件'),
        icon: React.createElement("img", { src: img$5 }),
        style: MenuItemStyle,
    },
    {
        name: 'addon-mall-shop',
        content: $t('获取更多'),
        icon: React.createElement("img", { src: img$4 }),
        style: MenuItemStyle,
    },
]; };
var AddonMallPageType;
(function (AddonMallPageType) {
    AddonMallPageType["shop"] = "index";
    AddonMallPageType["setting"] = "custom";
})(AddonMallPageType || (AddonMallPageType = {}));

var MenuController = /** @class */ (function () {
    function MenuController() {
        this.getAddonIdByMenuId = function (menuId) {
            var _a;
            var _b = (DocManager.getMenuConfig() || {}).officialAddonSchema, officialAddonSchema = _b === void 0 ? [] : _b;
            var addonId = (_a = officialAddonSchema.find(function (_a) {
                var schemaKey = _a.schemaKey;
                return schemaKey === AddonMenuSchemaPrefix + menuId;
            })) === null || _a === void 0 ? void 0 : _a.addonId;
            return addonId || menuId;
        };
    }
    MenuController.prototype.shouldPanelTitleDisabled = function () {
        return true;
    };
    /**
     * 处理插件菜单项 shouldDisabled
     */
    MenuController.prototype.shouldAddonDisabled = function (id) {
        var _a, _b, _c;
        var addonId = this.getAddonIdByMenuId(id);
        var _d = (DocManager.getMenuConfig() || {}).officialAddonSchema, officialAddonSchema = _d === void 0 ? [] : _d;
        var isOfficial = officialAddonSchema.find(function (item) { return item.addonId === addonId; });
        if (!isOfficial && ua.isMiniProgram && ua.isPC) {
            // PC 小程序 禁用非官方插件
            return true;
        }
        // 文档不可编辑时，判断插件访问策略，是否能访问
        var getPermission = DocManager.getService().config.getPermission;
        if (getPermission) {
            var _e = getPermission(), isEditable = _e.isEditable, isCopyable = _e.isCopyable;
            var accesses = ((_a = AddonManager$1.getInstance().getAddonMap()
                .get(id)) === null || _a === void 0 ? void 0 : _a.accesses) || [];
            if (!isEditable) {
                // 可查看且允许复制的文档，才能使用相应插件；目前不可复制的文档中，没有可以使用的插件
                if (!(isCopyable && accesses.includes(AddonAccessStrategy.VIEWABLE))) {
                    return true;
                }
            }
        }
        return !!((_c = (_b = DocManager.getAddonHook()) === null || _b === void 0 ? void 0 : _b.shouldAddonMenuItemDisabled) === null || _c === void 0 ? void 0 : _c.call(_b, { addonId: addonId }));
    };
    /**
     * 处理插件菜单项点击事件
     */
    MenuController.prototype.addonClickHandler = function (id, actionPointInfo) {
        var _this = this;
        var _a, _b;
        var addonId = this.getAddonIdByMenuId(id);
        var handler = function () { return __awaiter(_this, void 0, void 0, function () {
            var menuConfig, menuConfigurationType;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, AddonManager$1.getInstance().fetchAddonMenu(addonId)];
                    case 1:
                        menuConfig = _a.sent();
                        menuConfigurationType = getMenuConfigurationType(menuConfig);
                        if (menuConfigurationType !== MenuConfigurationType.ACTION) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, executeActionWithAuth(addonId, menuConfig)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        handler();
        (_b = (_a = DocManager.getAddonHook()) === null || _a === void 0 ? void 0 : _a.onAddonMenuItemClick) === null || _b === void 0 ? void 0 : _b.call(_a, {
            addonId: addonId,
            action: handler,
            actionPointInfo: actionPointInfo,
        });
    };
    /**
     * 处理插件二级菜单项点击事件
     */
    MenuController.prototype.subMenuClickHandler = function (id, actionPointInfo) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var wordArray, index, addonId, menuItems, menuItem, handler;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        wordArray = id.split('_');
                        index = Number(wordArray.pop());
                        addonId = wordArray.join('_');
                        return [4 /*yield*/, AddonManager$1.getInstance().fetchAddonMenu(addonId)];
                    case 1:
                        menuItems = (_c.sent());
                        menuItem = menuItems[index];
                        handler = function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, executeActionWithAuth(addonId, menuItem.action)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        handler();
                        (_b = (_a = DocManager.getAddonHook()) === null || _a === void 0 ? void 0 : _a.onAddonMenuItemClick) === null || _b === void 0 ? void 0 : _b.call(_a, {
                            addonId: addonId,
                            action: handler,
                            subMenuInfo: { index: index, schemaKey: AddonSubMenuSchemaPrefix + id, menuItem: menuItem },
                            actionPointInfo: actionPointInfo,
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 处理插件商城入口点击事件
     */
    MenuController.prototype.clickHandler = function (tab) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var _d, openAddonMall, closeAddonMall, page, fileType;
            var _this = this;
            return __generator(this, function (_e) {
                _d = AddonMallManager.getInstance(), openAddonMall = _d.openAddonMall, closeAddonMall = _d.closeAddonMall;
                page = (_a = AddonMallPageType[tab]) !== null && _a !== void 0 ? _a : 'index';
                fileType = DocManager.getMetaInfo().fileType;
                openAddonMall({
                    page: page,
                    // 'doc' | 'sheet' | 'form' | 'slide' | 'desktop'
                    type: fileTypeToAddonPanelType(fileType),
                    onOpenAddon: function (_a) {
                        var addonId = _a.id;
                        return __awaiter(_this, void 0, void 0, function () {
                            var addon;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0: return [4 /*yield*/, AddonManager$1.getInstance().getAddon(addonId, { shouldGetLatest: true })];
                                    case 1:
                                        addon = _b.sent();
                                        return [4 /*yield*/, AddonManager$1.getInstance().fetchAddonMenu(addonId)];
                                    case 2:
                                        _b.sent();
                                        return [4 /*yield*/, executeActionWithAuth(addonId, addon.menuConfiguration)];
                                    case 3:
                                        _b.sent();
                                        return [4 /*yield*/, closeAddonMall()];
                                    case 4:
                                        _b.sent();
                                        return [2 /*return*/];
                                }
                            });
                        });
                    },
                });
                (_c = (_b = DocManager.getAddonHook()) === null || _b === void 0 ? void 0 : _b.onAddonMallClick) === null || _c === void 0 ? void 0 : _c.call(_b, { page: page });
                return [2 /*return*/];
            });
        });
    };
    /**
     * 处理插件商城入口 disabled
     */
    MenuController.prototype.shouldAddonMallDisabled = function (tab) {
        var _a, _b, _c;
        var page = (_a = AddonMallPageType[tab]) !== null && _a !== void 0 ? _a : 'index';
        if (ua.isMiniProgram && ua.isPC) {
            // PC 小程序 禁用商城入口
            return true;
        }
        return !!((_c = (_b = DocManager.getAddonHook()) === null || _b === void 0 ? void 0 : _b.shouldAddonMallDisabled) === null || _c === void 0 ? void 0 : _c.call(_b, { page: page }));
    };
    MenuController.prototype.mountMenu = function () {
        return React.createElement(MainMenu, { align: "auto", name: SDKUnofficialAddonMenuKey, mode: "menu" });
    };
    __decorate([
        Menu(ThirdPartyAddonsPanelTitleSchema, 'shouldDisabled'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MenuController.prototype, "shouldPanelTitleDisabled", null);
    __decorate([
        Menu('addon-:menuid', 'shouldDisabled'),
        __param(0, Param('menuid')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], MenuController.prototype, "shouldAddonDisabled", null);
    __decorate([
        Menu('addon-:menuid', 'onClick'),
        __param(0, Param('menuid')),
        __param(1, ActionPointInfo()),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", void 0)
    ], MenuController.prototype, "addonClickHandler", null);
    __decorate([
        Menu('sub-addon-:menuid', 'onClick'),
        __param(0, Param('menuid')),
        __param(1, ActionPointInfo()),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, Object]),
        __metadata("design:returntype", Promise)
    ], MenuController.prototype, "subMenuClickHandler", null);
    __decorate([
        Menu('addon-mall-:tab', 'onClick'),
        __param(0, Param('tab')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], MenuController.prototype, "clickHandler", null);
    __decorate([
        Menu('addon-mall-:tab', 'shouldDisabled'),
        __param(0, Param('tab')),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], MenuController.prototype, "shouldAddonMallDisabled", null);
    __decorate([
        Toolbar(SDKUnofficialAddonToolbarKey, 'dropdownContent'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MenuController.prototype, "mountMenu", null);
    MenuController = __decorate([
        Controller()
    ], MenuController);
    return MenuController;
}());

var img$3 = "data:image/svg+xml,%3csvg width='26' height='14' viewBox='0 0 26 14' xmlns='http://www.w3.org/2000/svg'%3e%3cdefs%3e%3clinearGradient x1='-7.549%25' y1='35.503%25' x2='96.8%25' y2='62.488%25' id='a'%3e%3cstop stop-color='%23FFB490' offset='0%25'/%3e%3cstop stop-color='%23FF8246' offset='100%25'/%3e%3c/linearGradient%3e%3c/defs%3e%3cg fill='none' fill-rule='evenodd'%3e%3crect width='26' height='14' rx='2' fill='url(%23a)'/%3e%3cpath d='M12.4768118%2c10.9681117 L12.9538118%2c10.2121117 C12.3328118%2c9.8521117 11.8288118%2c9.4201117 11.4508118%2c8.9251117 C11.9278118%2c8.6731117 12.3598118%2c8.3221117 12.7378118%2c7.8721117 L12.1888118%2c7.3231117 C11.8288118%2c7.7551117 11.4508118%2c8.0881117 11.0548118%2c8.3221117 C10.8388118%2c7.9261117 10.6768118%2c7.5031117 10.5868118%2c7.0441117 L12.1978118%2c7.0441117 L12.1978118%2c3.0211117 L8.13881184%2c3.0211117 L8.13881184%2c9.8971117 C8.13881184%2c10.0141117 8.05781184%2c10.0951117 7.91381184%2c10.1491117 L8.12081184%2c10.8961117 C9.11981184%2c10.6351117 9.94781184%2c10.3651117 10.6048118%2c10.0951117 L10.4068118%2c9.3031117 C9.93881184%2c9.5191117 9.46181184%2c9.6991117 8.97581184%2c9.8431117 L8.97581184%2c7.0441117 L9.82181184%2c7.0441117 C10.1098118%2c8.7001117 11.0008118%2c10.0051117 12.4768118%2c10.9681117 Z M5.74481184%2c11.0401117 L5.74481184%2c3.8311117 L6.97781184%2c3.8311117 C6.74381184%2c4.5511117 6.42881184%2c5.3701117 6.02381184%2c6.2701117 C6.63581184%2c7.0261117 6.94181184%2c7.7011117 6.94181184%2c8.3131117 C6.94181184%2c8.4661117 6.89681184%2c8.5741117 6.81581184%2c8.6371117 C6.72581184%2c8.6911117 6.56381184%2c8.7271117 6.31181184%2c8.7451117 C6.18581184%2c8.7451117 6.03281184%2c8.7271117 5.85281184%2c8.7001117 L6.13181184%2c9.5641117 C6.79781184%2c9.5551117 7.25681184%2c9.4381117 7.52681184%2c9.2131117 C7.70681184%2c9.0331117 7.79681184%2c8.7271117 7.79681184%2c8.3131117 C7.76081184%2c7.6921117 7.45481184%2c6.9721117 6.88781184%2c6.1441117 C7.24781184%2c5.2891117 7.56281184%2c4.4791117 7.83281184%2c3.7051117 L7.83281184%2c3.0301117 L4.90781184%2c3.0301117 L4.90781184%2c11.0401117 L5.74481184%2c11.0401117 Z M11.3608118%2c4.6681117 L8.97581184%2c4.6681117 L8.97581184%2c3.8311117 L11.3608118%2c3.8311117 L11.3608118%2c4.6681117 Z M11.3608118%2c6.2611117 L8.97581184%2c6.2611117 L8.97581184%2c5.4421117 L11.3608118%2c5.4421117 L11.3608118%2c6.2611117 Z M14.2408118%2c11.0581117 C16.0048118%2c10.3741117 17.1118118%2c9.5101117 17.5798118%2c8.4841117 C17.6518118%2c8.3401117 17.7148118%2c8.1871117 17.7688118%2c8.0251117 L18.0838118%2c8.0251117 L18.0838118%2c9.8431117 C18.0838118%2c10.5451117 18.3898118%2c10.8961117 19.0108118%2c10.8961117 L20.8018118%2c10.8961117 C21.1258118%2c10.8961117 21.3598118%2c10.8151117 21.5128118%2c10.6531117 C21.6748118%2c10.4731117 21.7828118%2c9.9421117 21.8548118%2c9.0421117 L21.0448118%2c8.7811117 C21.0268118%2c9.4021117 20.9818118%2c9.7711117 20.9098118%2c9.8971117 C20.8558118%2c10.0051117 20.7658118%2c10.0681117 20.6398118%2c10.0681117 L19.2718118%2c10.0681117 C19.0468118%2c10.0681117 18.9388118%2c9.9331117 18.9388118%2c9.6631117 L18.9388118%2c8.0251117 L20.9728118%2c8.0251117 L20.9728118%2c5.1361117 L18.9118118%2c5.1361117 C19.2268118%2c4.8481117 19.5418118%2c4.4971117 19.8658118%2c4.0921117 L19.8658118%2c3.4441117 L16.8598118%2c3.4441117 C16.9948118%2c3.2551117 17.1298118%2c3.0661117 17.2558118%2c2.8681117 L16.3918118%2c2.6791117 C15.6358118%2c3.7951117 14.7358118%2c4.6591117 13.6738118%2c5.2891117 L14.2138118%2c5.9461117 C14.3848118%2c5.8381117 14.5558118%2c5.7211117 14.7178118%2c5.6041117 L14.7178118%2c8.0251117 L16.8598118%2c8.0251117 C16.8238118%2c8.0971117 16.7788118%2c8.1781117 16.7428118%2c8.2681117 C16.2568118%2c9.1051117 15.2488118%2c9.8161117 13.7008118%2c10.3921117 L14.2408118%2c11.0581117 Z M17.8408118%2c5.1361117 L15.3028118%2c5.1361117 C15.6268118%2c4.8571117 15.9328118%2c4.5511117 16.2388118%2c4.2181117 L18.7588118%2c4.2181117 C18.4528118%2c4.5601117 18.1468118%2c4.8661117 17.8408118%2c5.1361117 Z M20.1538118%2c7.2241117 L18.0028118%2c7.2241117 C18.0838118%2c6.8281117 18.1378118%2c6.3961117 18.1558118%2c5.9281117 L20.1538118%2c5.9281117 L20.1538118%2c7.2241117 Z M17.1208118%2c7.2241117 L15.5458118%2c7.2241117 L15.5458118%2c5.9281117 L17.3008118%2c5.9281117 C17.2738118%2c6.3961117 17.2108118%2c6.8281117 17.1208118%2c7.2241117 Z' fill='white' fill-rule='nonzero'/%3e%3c/g%3e%3c/svg%3e";

var img$2 = "data:image/svg+xml,%3csvg width='35' height='14' viewBox='0 0 35 14' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e%3cdefs%3e%3clinearGradient x1='4.098%25' y1='42%25' x2='96.8%25' y2='56.892%25' id='a'%3e%3cstop stop-color='%23F6DDB1' offset='0%25'/%3e%3cstop stop-color='%23E3B775' offset='100%25'/%3e%3c/linearGradient%3e%3cpath d='M12.208%2c5.887 L12.73%2c5.095 C10.912%2c4.393 9.625%2c3.565 8.878%2c2.629 L8.122%2c2.629 C7.222%2c3.646 5.935%2c4.465 4.261%2c5.095 L4.783%2c5.887 C6.277%2c5.329 7.519%2c4.537 8.5%2c3.502 C9.31%2c4.447 10.552%2c5.239 12.208%2c5.887 Z M8.788%2c5.752 L9.346%2c5.104 C8.995%2c4.798 8.617%2c4.528 8.221%2c4.294 L7.618%2c4.834 C8.032%2c5.086 8.419%2c5.392 8.788%2c5.752 Z M6.394%2c10.945 L6.394%2c10.603 L10.615%2c10.603 L10.615%2c10.945 L11.533%2c10.945 L11.533%2c7.759 L10.093%2c7.759 C10.462%2c7.417 10.804%2c7.048 11.11%2c6.643 L11.11%2c5.905 L5.728%2c5.905 L5.728%2c6.733 L9.94%2c6.733 C9.544%2c7.147 9.166%2c7.489 8.797%2c7.759 L5.476%2c7.759 L5.476%2c10.945 L6.394%2c10.945 Z M10.615%2c9.739 L6.394%2c9.739 L6.394%2c8.623 L10.615%2c8.623 L10.615%2c9.739 Z M15.376%2c10.954 L15.376%2c4.717 C15.691%2c4.15 15.952%2c3.556 16.15%2c2.944 L15.268%2c2.53 C14.836%2c3.925 14.161%2c5.14 13.252%2c6.166 L13.558%2c7.138 C13.873%2c6.814 14.17%2c6.472 14.44%2c6.13 L14.44%2c10.954 L15.376%2c10.954 Z M19.399%2c10.9 C20.056%2c10.9 20.389%2c10.558 20.389%2c9.883 L20.389%2c5.374 L21.613%2c5.374 L21.613%2c4.456 L20.389%2c4.456 L20.389%2c2.647 L19.444%2c2.647 L19.444%2c4.456 L16.222%2c4.456 L16.222%2c5.374 L19.444%2c5.374 L19.444%2c9.649 C19.444%2c9.91 19.318%2c10.045 19.075%2c10.045 C18.679%2c10.045 18.265%2c10.018 17.833%2c9.982 L18.049%2c10.9 L19.399%2c10.9 Z M17.896%2c8.749 L18.697%2c8.191 C18.337%2c7.615 17.833%2c6.931 17.185%2c6.157 L16.411%2c6.634 C17.032%2c7.408 17.527%2c8.119 17.896%2c8.749 Z M24.61%2c9.487 L24.61%2c7.786 L28.624%2c7.786 L28.624%2c9.487 L29.56%2c9.487 L29.56%2c6.958 L24.547%2c6.958 C24.817%2c6.814 25.042%2c6.661 25.222%2c6.49 C25.384%2c6.319 25.528%2c6.13 25.645%2c5.914 L27.04%2c5.914 L27.04%2c6.823 L27.949%2c6.823 L27.949%2c5.914 L29.416%2c5.914 C29.416%2c6.022 29.389%2c6.103 29.353%2c6.175 C29.308%2c6.229 29.173%2c6.256 28.948%2c6.256 C28.795%2c6.256 28.633%2c6.247 28.462%2c6.229 L28.633%2c6.868 C28.777%2c6.877 28.921%2c6.886 29.065%2c6.886 C29.596%2c6.877 29.938%2c6.769 30.082%2c6.571 C30.226%2c6.373 30.307%2c5.923 30.307%2c5.212 L27.949%2c5.212 L27.949%2c4.816 L29.821%2c4.816 L29.821%2c2.962 L27.949%2c2.962 L27.949%2c2.593 L27.04%2c2.593 L27.04%2c2.962 L25.942%2c2.962 L25.942%2c2.593 L25.033%2c2.593 L25.033%2c2.962 L23.062%2c2.962 L23.062%2c3.709 L25.033%2c3.709 L25.033%2c4.105 L23.332%2c4.105 L22.972%2c5.914 L24.556%2c5.914 L24.511%2c5.959 C24.205%2c6.256 23.602%2c6.508 22.693%2c6.706 L23.161%2c7.435 C23.341%2c7.39 23.512%2c7.345 23.683%2c7.291 L23.683%2c9.487 L24.61%2c9.487 Z M27.04%2c4.105 L25.942%2c4.105 L25.942%2c3.709 L27.04%2c3.709 L27.04%2c4.105 Z M28.948%2c4.105 L27.949%2c4.105 L27.949%2c3.709 L28.948%2c3.709 L28.948%2c4.105 Z M24.943%2c5.212 L23.989%2c5.212 L24.097%2c4.816 L25.024%2c4.816 C25.006%2c4.942 24.979%2c5.077 24.943%2c5.212 Z M27.04%2c5.212 L25.879%2c5.212 C25.897%2c5.086 25.915%2c4.96 25.933%2c4.816 L27.04%2c4.816 L27.04%2c5.212 Z M23.035%2c10.972 C24.736%2c10.846 25.807%2c10.558 26.248%2c10.126 C26.662%2c9.784 26.932%2c9.1 27.058%2c8.065 L26.122%2c7.975 C26.059%2c8.731 25.834%2c9.262 25.438%2c9.577 C24.988%2c9.883 24.061%2c10.072 22.657%2c10.126 L23.035%2c10.972 Z M29.857%2c11.017 L30.361%2c10.234 C29.407%2c9.856 28.345%2c9.541 27.184%2c9.289 L26.707%2c9.991 C27.787%2c10.243 28.84%2c10.585 29.857%2c11.017 Z' id='b'/%3e%3c/defs%3e%3cg fill='none' fill-rule='evenodd'%3e%3crect fill='url(%23a)' width='35' height='14' rx='2'/%3e%3cg fill-rule='nonzero'%3e%3cuse fill='%23DB8F1C' xlink:href='%23b'/%3e%3cuse fill='%23754A0A' xlink:href='%23b'/%3e%3c/g%3e%3c/g%3e%3c/svg%3e";

var img$1 = "data:image/svg+xml,%3csvg width='16' height='16' viewBox='0 0 16 16' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3e %3cdefs%3e %3cpath d='M6 3.833 10.286 8 6 12.167l.857.833 4.774-4.642a.5.5 0 0 0 0-.716L6.857 3 6 3.833z' id='a'/%3e %3c/defs%3e %3cg fill-rule='nonzero' fill='none'%3e %3cuse fill='%23CBCDD1' xlink:href='%23a'/%3e %3cuse fill-opacity='.04' fill='black' xlink:href='%23a'/%3e %3c/g%3e%3c/svg%3e";
  var nextIcon = img$1;

var css_248z = ".menu-item-tooltip_tooltip_preview__F5--R{background-clip:padding-box;background-color:#f3f5f7;background-size:cover;border:1px solid rgba(0,0,0,.04);border-radius:2px;height:108px;margin:16px 0;width:192px}.menu-item-tooltip_tooltip_preview_title__AxIp1{align-items:center;color:rgba(0,0,0,.88);display:flex;flex:auto;flex-direction:row;font-family:PingFangSC-Regular;font-size:14px;font-weight:600;line-height:14px;-webkit-user-select:none;-moz-user-select:none;user-select:none}.menu-item-tooltip_tooltip_preview_title__AxIp1>div{flex:1}.menu-item-tooltip_tooltip_preview_title__AxIp1 img{display:block}.menu-item-tooltip_tooltip_preview_supplier__ikkKw{align-items:center;color:#999;display:flex;font-size:12px;line-height:1;margin:10px 0 16px}.menu-item-tooltip_tooltip_preview_supplier__ikkKw>a{align-items:center;color:inherit;display:flex;flex-direction:row;text-decoration:none}.menu-item-tooltip_tooltip_preview_text__4Kprs{color:rgba(0,0,0,.88);font-family:PingFangSC-Regular;font-size:12px;letter-spacing:normal;line-height:16px;max-width:192px;-webkit-user-select:none;-moz-user-select:none;user-select:none}.menu-item-tooltip_tooltip_preview_vendor_name__8htIZ{max-width:145px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;word-break:break-all}.menu-item-tooltip_tooltip_preview_name_underline__fXuo4:hover{border-bottom:.5px solid #999}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9hZGRvbi1tZW51L21lbnUtaXRlbS10b29sdGlwL21lbnUtaXRlbS10b29sdGlwLmxlc3MiLCJtZW51LWl0ZW0tdG9vbHRpcC5sZXNzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLDBDQVFFLDJCQUFBLENBREEsd0JBQUEsQ0FEQSxxQkFBQSxDQUhBLGdDQUFBLENBQ0EsaUJBQUEsQ0FGQSxZQUFBLENBR0EsYUFBQSxDQUpBLFdDUUYsQ0RDRSxnREFHRSxrQkFBQSxDQU1BLHFCQUFBLENBUkEsWUFBQSxDQUdBLFNBQUEsQ0FGQSxrQkFBQSxDQU1BLDhCQUFBLENBSEEsY0FBQSxDQUVBLGVBQUEsQ0FEQSxnQkFBQSxDQUlBLHdCQUFBLENBQUEscUJBQUEsQ0FBQSxnQkNDSixDRENJLG9EQUNFLE1DQ04sQ0RFSSxvREFDRSxhQ0FOLENESUUsbURBRUUsa0JBQUEsQ0FHQSxVQUFBLENBSkEsWUFBQSxDQUVBLGNBQUEsQ0FDQSxhQUFBLENBRUEsa0JDRkosQ0RJSSxxREFHRSxrQkFBQSxDQUVBLGFBQUEsQ0FKQSxZQUFBLENBQ0Esa0JBQUEsQ0FFQSxvQkNETixDRE1FLCtDQUtFLHFCQUFBLENBSEEsOEJBQUEsQ0FEQSxjQUFBLENBRUEscUJBQUEsQ0FDQSxnQkFBQSxDQUdBLGVBQUEsQ0FEQSx3QkFBQSxDQUFBLHFCQUFBLENBQUEsZ0JDSEosQ0RPRSxzREFDRSxlQUFBLENBR0EsZUFBQSxDQURBLHNCQUFBLENBREEsa0JBQUEsQ0FHQSxvQkNMSixDRFFFLCtEQUNFLDZCQ05KIiwiZmlsZSI6Im1lbnUtaXRlbS10b29sdGlwLmxlc3MifQ== */";
var styles = {"tooltip_preview":"menu-item-tooltip_tooltip_preview__F5--R","tooltip_preview_title":"menu-item-tooltip_tooltip_preview_title__AxIp1","tooltip_preview_supplier":"menu-item-tooltip_tooltip_preview_supplier__ikkKw","tooltip_preview_text":"menu-item-tooltip_tooltip_preview_text__4Kprs","tooltip_preview_vendor_name":"menu-item-tooltip_tooltip_preview_vendor_name__8htIZ","tooltip_preview_name_underline":"menu-item-tooltip_tooltip_preview_name_underline__fXuo4"};
styleInject(css_248z);

var defaultTooltipStyle = {
    placement: 'right',
    style: {
        display: 'block',
    },
    overlayStyle: {
        backgroundColor: 'hsla(0,0%,100%,.92)',
        padding: '20px 16px 24px',
        backdropFilter: 'blur(16px)',
        boxShadow: '0 2px 12px 2px rgb(68 73 77 / 16%)',
        borderRadius: '4px',
        border: 'solid 1px rgba(0, 0, 0, 0.12)',
    },
    alignment: 'start',
    hoverDelay: 200,
    safeWidth: 230,
};

var chargingTagMap = new Map([
    ['limitedFree', img$3],
    ['inAppPurchase', img$2],
]);
function MenuItemTooltip(props) {
    var title = props.title, text = props.text, vendorName = props.vendorName, vendorSite = props.vendorSite, chargingType = props.chargingType;
    return (React.createElement("div", null,
        React.createElement("div", { className: "".concat(styles.tooltip_preview_title) },
            React.createElement("div", null, title),
            chargingType && React.createElement("img", { src: chargingTagMap.get(chargingType) })),
        vendorName && (React.createElement("div", { className: "".concat(styles.tooltip_preview_supplier) },
            React.createElement("a", { className: vendorSite ? "".concat(styles.tooltip_preview_name_underline) : '', onClick: function () { return vendorSite && openNewBlankWindow(vendorSite); }, style: { cursor: vendorSite ? 'pointer' : 'default' } },
                $t('来自：'),
                React.createElement("span", { className: "".concat(styles.tooltip_preview_vendor_name) }, vendorName)),
            vendorSite ? React.createElement("img", { src: nextIcon }) : '')),
        React.createElement("div", { className: "".concat(styles.tooltip_preview), style: { backgroundImage: "url(".concat(props.preview, ")") } }),
        React.createElement("div", { className: "".concat(styles.tooltip_preview_text) }, text)));
}
function getMenuItemTooltip(tooltipProps, newStyle) {
    // 如果传入自定义样式，覆盖默认样式
    var tooltipStyle = newStyle ? __assign(__assign({}, defaultTooltipStyle), newStyle) : defaultTooltipStyle;
    return __assign(__assign({}, tooltipStyle), { content: React.createElement(MenuItemTooltip, __assign({}, tooltipProps)) });
}

var img = "data:image/svg+xml,%3csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M8 4.75C8 4.33579 8.33579 4 8.75 4C9.16421 4 9.5 4.33579 9.5 4.75V7.2H14.4615V4.75C14.4615 4.33579 14.7973 4 15.2115 4C15.6258 4 15.9615 4.33579 15.9615 4.75V7.2H18C18.5523 7.2 19 7.64772 19 8.2V15C19 16.7673 17.5673 18.2 15.8 18.2H8.2C6.43269 18.2 5 16.7673 5 15V8.2C5 7.64772 5.44772 7.2 6 7.2H8V4.75ZM15.8 16.9H8.2C7.20063 16.9 6.38147 16.1284 6.30572 15.1485L6.3 15V8.501H17.7V15C17.7 15.9994 16.9284 16.8185 15.9485 16.8943L15.8 16.9Z' fill='%23454D5A'/%3e%3cpath d='M9.65 18.9C9.29101 18.9 9 19.191 9 19.55C9 19.909 9.29101 20.2 9.65 20.2H14.35C14.709 20.2 15 19.909 15 19.55C15 19.191 14.709 18.9 14.35 18.9H9.65Z' fill='%23454D5A'/%3e%3c/svg%3e";

var AddonMenu = /** @class */ (function () {
    function AddonMenu(docMenuConfig) {
        this.docMenuConfig = docMenuConfig;
        var _a = docMenuConfig.officialAddonSchema, officialAddonSchema = _a === void 0 ? [] : _a;
        this.officialAddonSchemaMap = new Map(officialAddonSchema.map(function (_a) {
            var addonId = _a.addonId, schemaKey = _a.schemaKey;
            return [addonId, schemaKey];
        }));
        this.renderAddonList();
    }
    AddonMenu.getInstance = function () {
        if (!this.instance) {
            throw new Error('AddonMenu is not initialized, please call AddonMenu.init() first');
        }
        return this.instance;
    };
    AddonMenu.init = function (docMenuConfig) {
        this.instance = new AddonMenu(docMenuConfig);
    };
    /**
     * 刷新非官方插件列表
     */
    AddonMenu.prototype.updateUnofficialAddonList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var addons;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, AddonManager$1.getInstance().fetchAddonList({ shouldFetchMenu: false })];
                    case 1:
                        addons = _a.sent();
                        // 更新非官方插件 menu schema
                        this.updateUnofficialAddonMenuSchema(addons);
                        // 更新非官方插件菜单
                        this.updateAddonMenu(addons.filter(function (_a) {
                            var addonId = _a.addonId;
                            return !_this.officialAddonSchemaMap.has(addonId);
                        }));
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 渲染插件菜单
     */
    AddonMenu.prototype.renderAddonList = function () {
        return __awaiter(this, void 0, void 0, function () {
            var addons;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, AddonManager$1.getInstance().fetchAddonList({ shouldFetchMenu: false })];
                    case 1:
                        addons = _a.sent();
                        // 更新非官方插件 menu schema
                        this.updateUnofficialAddonMenuSchema(addons);
                        // 更新插件菜单
                        this.updateAddonMenu(addons);
                        // 渲染二级菜单插件的二级菜单
                        this.initAddonSecondLevelMenu(addons);
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 初始化插件二级菜单
     */
    AddonMenu.prototype.initAddonSecondLevelMenu = function (addons) {
        var _this = this;
        SecondLevelMenuAddons.forEach(function (addonId) { return __awaiter(_this, void 0, void 0, function () {
            var addonInfo, menuConfig, menuConfigurationType;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        addonInfo = addons.find(function (item) { return item.addonId === addonId; });
                        if (!addonInfo) {
                            // 服务端返回的插件列表中无此插件
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, AddonManager$1.getInstance().fetchAddonMenu(addonId)];
                    case 1:
                        menuConfig = _a.sent();
                        menuConfigurationType = getMenuConfigurationType(menuConfig);
                        if (menuConfigurationType !== MenuConfigurationType.MENUS) {
                            return [2 /*return*/];
                        }
                        // 更新子菜单 schema
                        this.updateSubMenuSchema(addonId, menuConfig);
                        // 更新并注册子菜单
                        this.updateSubMenu(addonInfo, menuConfig);
                        return [2 /*return*/];
                }
            });
        }); });
    };
    /**
     * 更新插件二级菜单 schema
     */
    AddonMenu.prototype.updateSubMenuSchema = function (addonId, menuItems) {
        var subMenuSchema = menuItems.map(function (item, index) {
            if (item.type === MenuType.DIVIDE) {
                return WorkbenchBuiltInSchema.DIVIDER;
            }
            return "".concat(AddonSubMenuSchemaPrefix + addonId, "_").concat(index);
        });
        var newSchema = this.menuService.updateKeySchema(
        // 可能是官方插件或者第三方插件
        this.getAddonMenuKey(addonId), subMenuSchema);
        this.menuService.setSchema(newSchema);
    };
    /**
     * 更新并注册插件二级菜单
     */
    AddonMenu.prototype.updateSubMenu = function (addonInfo, menuItems) {
        var addonId = addonInfo.addonId, staticHost = addonInfo.staticHost, staticPath = addonInfo.staticPath;
        var subMenuConfigs = menuItems
            .map(function (item, index) {
            if (item.type === MenuType.DIVIDE) {
                return null;
            }
            var iconPath = item.hideIcon ? '' : "https://".concat(staticHost, "/").concat(staticPath, "/").concat(item.icon);
            var menuConfig = {
                name: "".concat(AddonSubMenuSchemaPrefix + addonId, "_").concat(index),
                content: $t(item.title || ''),
                icon: React.createElement("img", { src: iconPath, onError: function (event) { return hideImage(event, iconPath); } }),
            };
            return menuConfig;
        })
            .filter(function (item) { return item; });
        this.registerMenu(subMenuConfigs);
    };
    /**
     * 获取插件列表中已存在的菜单项
     */
    AddonMenu.prototype.getExistingMenus = function (parentSchemaKey) {
        var parentSchema = this.menuService.getSchema().find(function (schema) {
            if (typeof schema === 'string') {
                return schema === parentSchemaKey;
            }
            return schema.key === parentSchemaKey;
        });
        if (!parentSchema || typeof parentSchema === 'string') {
            return [];
        }
        return parentSchema.items;
    };
    AddonMenu.prototype.trimExistingMenus = function (existingMenus) {
        var result = __spreadArray([], __read(existingMenus), false);
        var lastMenus = existingMenus.slice(existingMenus.length - AddonMallsSchema.length, existingMenus.length);
        if (lastMenus.join('|') === AddonMallsSchema.join('|')) {
            // 列表中有商城，去掉商城
            result.splice(result.length - AddonMallsSchema.length, AddonMallsSchema.length);
        }
        // 如果有第三方插件，去掉第三方插件
        var index = result.findIndex(function (item) { return item === ThirdPartyAddonsPanelTitleSchema; });
        if (index > -1) {
            result.splice(index, result.length - index + 1);
        }
        return result;
    };
    /**
     * 更新非官方插件菜单 schema
     */
    AddonMenu.prototype.updateUnofficialAddonMenuSchema = function (addons) {
        var unofficialAddonSchema = this.docMenuConfig.unofficialAddonSchema;
        var unofficialAddonMenuKey = unofficialAddonSchema || this.getUnofficialAddonMenuKeyByToolbarKey();
        if (unofficialAddonMenuKey) {
            this.updateUnofficialAddonMenuSchemaWithMenuKey(addons, unofficialAddonMenuKey);
        }
    };
    AddonMenu.prototype.getUnofficialAddonMenuKeyByToolbarKey = function () {
        var unofficialAddonMenuConfig = {
            key: SDKUnofficialAddonMenuKey,
            items: [],
        };
        var menuSchema = this.menuService.getSchema();
        menuSchema.push(unofficialAddonMenuConfig);
        this.menuService.setSchema(menuSchema);
        return SDKUnofficialAddonMenuKey;
    };
    AddonMenu.prototype.updateUnofficialAddonMenuSchemaWithMenuKey = function (addons, unofficialAddonMenuKey) {
        var _this = this;
        // 获取非官方插件列表品类已有的 schema，目前仅支持在插件选项在最外层
        var defaultMenus = this.getExistingMenus(unofficialAddonMenuKey);
        // 修剪已有的 schema
        defaultMenus = this.trimExistingMenus(defaultMenus);
        // 获取各个非官方插件的 schema
        var addonMenus = addons
            .filter(function (_a) {
            var addonId = _a.addonId;
            return !_this.officialAddonSchemaMap.has(addonId);
        })
            .map(function (_a) {
            var addonId = _a.addonId;
            return _this.getAddonMenuKey(addonId);
        });
        if (addonMenus.length) {
            // 如果有第三方插件，增加第三方插件标题
            addonMenus.unshift(ThirdPartyAddonsPanelTitleSchema);
            // 如果有第三方插件并且第三方插件列表前有内容，增加分割线
            if (defaultMenus.length) {
                addonMenus.unshift(WorkbenchBuiltInSchema.DIVIDER);
            }
        }
        // 拼装成新的完整 schema
        var newSchema = this.menuService.updateKeySchema(unofficialAddonMenuKey, __spreadArray(__spreadArray(__spreadArray([], __read(defaultMenus), false), __read(addonMenus), false), __read((this.docMenuConfig.showAddonMall ? AddonMallsSchema : [])), false));
        this.menuService.setSchema(newSchema);
    };
    /**
     * 更新并注册插件菜单
     */
    AddonMenu.prototype.updateAddonMenu = function (addonMetaList) {
        var _this = this;
        var menuConfigs = addonMetaList.map(function (addonMeta) { return _this.getMenuConfig(addonMeta); });
        if (this.docMenuConfig.showAddonMall) {
            menuConfigs.push.apply(menuConfigs, __spreadArray([], __read(getAddonMallMenuConfigs()), false));
        }
        this.registerMenu(__spreadArray(__spreadArray([], __read(menuConfigs), false), [getThirdPartyAddonsPanelTitleConfig()], false));
    };
    /**
     * 获取插件菜单
     */
    AddonMenu.prototype.getMenuConfig = function (addonMeta) {
        var addonId = addonMeta.addonId, addonName = addonMeta.name, icons = addonMeta.icons;
        var isOfficial = this.officialAddonSchemaMap.has(addonId);
        var menuConfig = {
            name: this.getAddonMenuKey(addonId),
            content: $t(addonName),
            icon: React.createElement("img", { src: icons.small, onError: function (event) { return hideImage(event, icons.small); } }),
            tooltip: this.getTooltip(addonMeta),
            respectOffline: isOfficial,
            style: isOfficial ? undefined : MenuItemStyle,
        };
        return menuConfig;
    };
    /**
     * 获取插件菜单 tooltip
     */
    AddonMenu.prototype.getTooltip = function (addonMeta) {
        var addonId = addonMeta.addonId, addonName = addonMeta.name, icons = addonMeta.icons, shortDesc = addonMeta.shortDesc, vendorName = addonMeta.vendorName, vendorSite = addonMeta.vendorSite, chargingType = addonMeta.chargingType;
        var tooltipProps = {
            title: addonName,
            text: shortDesc,
            preview: icons.intro,
            vendorName: vendorName,
            vendorSite: vendorSite,
            chargingType: chargingType,
        };
        var isOfficial = this.officialAddonSchemaMap.has(addonId);
        if (isOfficial) {
            // 官方插件不需要 tooltips
            return undefined;
        }
        // 桌面端小程序中置灰第三方插件入口 http://tapd.woa.com/TIM_web/prong/stories/view/1010143861874939633
        if (ua.isMiniProgram && ua.isPC) {
            return $t('请到电脑客户端或浏览器中使用');
        }
        // 先忽略 placement 的类型，workbench 内支持数组用法，但是 ts 类型暂未补齐
        return getMenuItemTooltip(tooltipProps, { placement: ['right', 'left'] });
    };
    /**
     * 获取插件菜单的 schemaKey
     */
    AddonMenu.prototype.getAddonMenuKey = function (addonId) {
        // 官方插件从配置中读取
        var menuKey = this.officialAddonSchemaMap.get(addonId);
        if (!menuKey) {
            // 非官方插件拼接
            menuKey = "".concat(AddonMenuSchemaPrefix).concat(addonId);
        }
        return menuKey;
    };
    /**
     * 注册菜单
     */
    AddonMenu.prototype.registerMenu = function (menus) {
        if (
        // 没有需要更新的插件
        !menus.some(function (_a) {
            var name = _a.name;
            return name.startsWith(AddonMenuSchemaPrefix) || name.startsWith(AddonSubMenuSchemaPrefix);
        })) {
            return;
        }
        var config = {
            menuItems: menus,
        };
        var unofficialAddonSchema = this.docMenuConfig.unofficialAddonSchema;
        if (!unofficialAddonSchema) {
            // 没有传入菜单 key , sdk 内部新建菜单挂载
            config.menuItems.push({
                name: SDKUnofficialAddonMenuKey,
                content: '',
            });
            config.toolbarItems = [
                {
                    name: SDKUnofficialAddonToolbarKey,
                    type: 'custom',
                    content: React.createElement("img", { src: img }),
                },
            ];
        }
        Controller(config)(MenuController);
        this.controllerService.buildController(MenuController);
    };
    __decorate([
        Inject(),
        __metadata("design:type", ControllerService)
    ], AddonMenu.prototype, "controllerService", void 0);
    __decorate([
        Inject(),
        __metadata("design:type", MenuService)
    ], AddonMenu.prototype, "menuService", void 0);
    return AddonMenu;
}());

var inSmartSheet = function () {
    var _a, _b, _c, _d, _e, _f;
    return ((_c = (_b = (_a = window.SpreadsheetApp) === null || _a === void 0 ? void 0 : _a.workbook) === null || _b === void 0 ? void 0 : _b.activeSheet) === null || _c === void 0 ? void 0 : _c.getSheetType()) === 3
        || ((_f = (_e = (_d = window.SpreadsheetApp) === null || _d === void 0 ? void 0 : _d.spreadsheet) === null || _e === void 0 ? void 0 : _e.activeSheet) === null || _f === void 0 ? void 0 : _f.getSheetType()) === 'smartsheet';
};

var ADDON_TYPE;
(function (ADDON_TYPE) {
    ADDON_TYPE["DOC"] = "doc";
    ADDON_TYPE["SHEET"] = "sheet";
    ADDON_TYPE["SLIDE"] = "slide";
    ADDON_TYPE["FORM"] = "form";
    ADDON_TYPE["PDF"] = "pdf";
    ADDON_TYPE["DRIVE"] = "drive";
    ADDON_TYPE["SUITE"] = "suite";
})(ADDON_TYPE || (ADDON_TYPE = {}));
var AUTH_ACTION;
(function (AUTH_ACTION) {
    AUTH_ACTION["OPEN"] = "open";
    AUTH_ACTION["CREATE"] = "create";
})(AUTH_ACTION || (AUTH_ACTION = {}));

var DocAddonBridge = /** @class */ (function () {
    function DocAddonBridge() {
        return DocAddonBridge;
    }
    /**
     * 初始化配置
     * @param {DocData} { doc, service, addonHook } 实例配置项
     * metaInfo:当前的文档信息
     * service:文档的基础能力
     * addonHook: 插件的生命周期hook,需要传一个对象或class实例进来用户监听插件的生命周期
     */
    DocAddonBridge.setup = function (docData) {
        // 初始化docManager单例并把doc的数据托管给它
        DocManager.initDocData(docData);
        // 注册消息监听
        MessageService.register();
        // 先临时区分，等整体的 BC 制品方案出来后，再收
        if (isEnterpriseWecomEnv()) {
            AddonContentMessageService.register();
        }
        CustomizedMessageService.register();
        // Docs 命名空间注入
        DocNamespaceManager.initDocGlobalNamespace();
        // 挂载 JSbridge 调用的 invoke 方法
        JSBridgeInvokeService.mountJSBridgeInvoke();
        // TODO @lrwlfyang 无 workbench 版本后续支持
        {
            // 初始化菜单
            docData.menuConfig && AddonMenu.init(docData.menuConfig);
        }
        this.initialized = true;
        this.setupCallbacks.forEach(function (callback) { return callback(); });
        this.openAddonWhenFileOpen();
    };
    DocAddonBridge.openAddonWhenFileOpen = function (openAddonId, openAddonMarketId) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var openedFlag, canEdit, urlSearch, addonId, marketId, showAddonDisableDialog, _c, _d, accesses, _e, types, editable, accessible;
            var _this = this;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        openedFlag = Symbol('hasOpenedAddonWhenFileOpen');
                        if (window[openedFlag]) {
                            return [2 /*return*/];
                        }
                        window[openedFlag] = true;
                        canEdit = function () { return __awaiter(_this, void 0, void 0, function () {
                            var extensionService, _a, canEdit;
                            var _b, _c, _d, _e;
                            return __generator(this, function (_f) {
                                switch (_f.label) {
                                    case 0: return [4 /*yield*/, getExtensionService()];
                                    case 1:
                                        extensionService = _f.sent();
                                        _a = (((_e = (_d = (_c = (_b = extensionService === null || extensionService === void 0 ? void 0 : extensionService.dependentServiceCombinder) === null || _b === void 0 ? void 0 : _b.authDomain) === null || _c === void 0 ? void 0 : _c.authAggregate) === null || _d === void 0 ? void 0 : _d.authInfoEntity) === null || _e === void 0 ? void 0 : _e.selfDocPrivilege) || {}).canEdit, canEdit = _a === void 0 ? false : _a;
                                        return [2 /*return*/, canEdit];
                                }
                            });
                        }); };
                        urlSearch = new URLSearchParams(location.search);
                        addonId = openAddonId || urlSearch.get('openAddonId');
                        marketId = openAddonMarketId || urlSearch.get('openAddonMarketId') || '';
                        if (!addonId) return [3 /*break*/, 5];
                        // 删除 url 中的参数，防止用户复制链接分享出错
                        window.history.replaceState(window.history.state, '', deleteQuery(location.href, 'openAddonId'));
                        showAddonDisableDialog = function () { return __awaiter(_this, void 0, void 0, function () {
                            var showAddonDisableDialog;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, import('./index-01849728.js')];
                                    case 1:
                                        showAddonDisableDialog = (_a.sent()).showAddonDisableDialog;
                                        showAddonDisableDialog(addonId);
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        // smartSheet 中不支持插件，需弹出不能使用弹窗
                        if (inSmartSheet()) {
                            showAddonDisableDialog();
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, AddonManager$1.getInstance().getAddon(addonId)];
                    case 1:
                        _c = _f.sent(), _d = _c.accesses, accesses = _d === void 0 ? [] : _d, _e = _c.types, types = _e === void 0 ? [] : _e;
                        if (!(((_b = (_a = DocManager.getDocData()) === null || _a === void 0 ? void 0 : _a.metaInfo) === null || _b === void 0 ? void 0 : _b.fileType) === FileType.SUITE)) return [3 /*break*/, 2];
                        if (types.includes(ADDON_TYPE.SUITE)) {
                            openAddon({
                                addonId: addonId,
                                marketId: marketId,
                            });
                            return [2 /*return*/];
                        }
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, canEdit()];
                    case 3:
                        editable = _f.sent();
                        accessible = [accesses.includes(AddonAccessStrategy.VIEWABLE), editable].some(function (item) { return item; });
                        if (accessible) {
                            openAddon({
                                addonId: addonId,
                                marketId: marketId,
                            });
                            return [2 /*return*/];
                        }
                        _f.label = 4;
                    case 4:
                        showAddonDisableDialog();
                        _f.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    DocAddonBridge.executeAfterSetup = function (callback) {
        if (this.initialized) {
            return callback();
        }
        this.setupCallbacks.push(callback);
    };
    /**
     * 打开插件商城
     */
    DocAddonBridge.openAddonMall = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, AddonMallManager.getInstance().openAddonMall(options)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 关闭插件商城
     */
    DocAddonBridge.closeAddonMall = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, AddonMallManager.getInstance().closeAddonMall()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 更新文档基础信息
     * @param metaInfo 文档基础信息
     */
    DocAddonBridge.updateMetaInfo = function (metaInfo) {
        DocManager.updateMetaInfo(metaInfo);
    };
    /**
     *  获取docHook(懒加载处理)
     *
     * @return {*}  {DocHook}
     */
    DocAddonBridge.getDocHook = function () {
        if (!this.docHook) {
            this.docHook = new DocHook();
        }
        return this.docHook;
    };
    /**
     * 获取插件列表
     * @param requestData 获取插件列表的请求参数，shouldFetchMenu 为 true，默认拉取插件列表; channel: 插件渠道类型, 默认为 PC
     * @return {*}  {Promise<AddonListResponse>} 插件列表
     */
    DocAddonBridge.fetchAddonList = function (requestData) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, AddonManager$1.getInstance().fetchAddonList(requestData)];
            });
        });
    };
    /**
     * 更新插件列表菜单
     */
    DocAddonBridge.updateUnofficialAddonMenuList = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        // TODO @lrwlfyang 无 workbench 版本后续支持
                        return [4 /*yield*/, AddonMenu.getInstance().updateUnofficialAddonList()];
                    case 1:
                        // TODO @lrwlfyang 无 workbench 版本后续支持
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 获取插件子菜单
     * @param addonId 插件id
     * @return {*}  {MenuConfiguration} 插件子菜单
     */
    DocAddonBridge.fetchAddonMenu = function (addonId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, AddonManager$1.getInstance().fetchAddonMenu(addonId)];
            });
        });
    };
    /**
     * 根据id获取插件
     *
     * @param addonId 插件id
     * @param {GetAddonConfig} needInstalled 插件是否需要已安装
     * @param {GetAddonConfig} shouldGetLatest 是否清除缓存，需要获取最新的插件
     * @return 插件
     */
    DocAddonBridge.getAddon = function (addonId, config) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, AddonManager$1.getInstance().getAddon(addonId, config)];
            });
        });
    };
    /**
     * 获取当前 AddonMap
     * 若未调用获取插件列表接口，AddonMap 为空
     */
    DocAddonBridge.getAddonMap = function () {
        return AddonManager$1.getInstance().getAddonMap();
    };
    DocAddonBridge.getSceneAddonList = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, AddonManager$1.getInstance().getSceneAddonList(data)];
            });
        });
    };
    /**
     * 获取 web 插件 iframe 显示的代理 url
     * @param url 插件的 url
     * @param addonId 插件 id
     * @returns 代理地址
     */
    DocAddonBridge.getWebAddonProxyURL = function (url, addonId) {
        return AddonManager$1.getInstance().getWebAddonProxyURL(url, addonId);
    };
    /**
     * 获取插件对象的配置
     * @returns 插件对象的配置
     * @param addonId: 插件 Id
     * @param anchorId：插件实例唯一标识
     */
    DocAddonBridge.fetchContentContainerConfiguration = function (addonId, anchorId) {
        return __awaiter(this, void 0, void 0, function () {
            var defaultContentContainerConfiguration, addon, _a, data;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        defaultContentContainerConfiguration = { toolbar: [], resize: ResizeMode.NONE };
                        return [4 /*yield*/, AddonManager$1.getInstance().getAddon(addonId)];
                    case 1:
                        addon = _b.sent();
                        return [4 /*yield*/, addon.serviceHook.onConfigureBlock(anchorId)];
                    case 2:
                        _a = (_b.sent()).data, data = _a === void 0 ? defaultContentContainerConfiguration : _a;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    /**
     * 执行子菜单事件
     *
     * @param {string} addonId 当前插件实例对应的的插件ID
     * @param {string} action menu 对应的action
     * @return {*}  {Promise<CallbackRes>} 执行结果回调
     */
    DocAddonBridge.executeMenuAction = function (addonId, action) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, executeActionWithAuth(addonId, action)];
            });
        });
    };
    /**
     * 执行toolbar按钮事件
     *
     * @param {string} addonId 当前插件实例对应的的插件ID
     * @param {string} action toolbar button 对应的action
     * @return {*}  {Promise<CallbackRes>} 执行结果回调
     */
    DocAddonBridge.executeToolbarButtonAction = function (addonId, action) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, executeActionWithAuth(addonId, action)];
            });
        });
    };
    /**
     * 调用插件能力(云函数)
     * @param addonId 插件ID
     * @param funcName 云函数
     * @param funcArgs 云函数的参数
     * @returns 执行回调结果
     */
    DocAddonBridge.invokeAddonWithFunc = function (addonId, funcName, funcArgs) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.invokeAddonWithOptions(addonId, funcName, funcArgs, InvokeScene.DOC)];
            });
        });
    };
    DocAddonBridge.invokeAddonWithOptions = function (addonId, funcName, funcArgs, scene) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, serviceInvoke(addonId, { scene: scene, funcName: funcName, funcArgs: funcArgs })];
            });
        });
    };
    /**
     * 判断 doc element 的类型
     * @param docElement
     * @returns 类型
     */
    DocAddonBridge.getDocElementType = function (docElement) {
        return getDocElementType(docElement);
    };
    /**
     * 判断 menu configuration 的类型
     * @param menuConfiguration
     * @returns 类型
     */
    DocAddonBridge.getMenuConfigurationType = function (menuConfiguration) {
        return getMenuConfigurationType(menuConfiguration);
    };
    /**
     * 获取第三内容插件的链接类型信息
     * @param type 类型
     * @returns 链接类型信息
     */
    DocAddonBridge.getLinkTypeInfo = function (type) {
        return getLinkTypeInfo(type);
    };
    /**
     * 获取内容插件的打印模式
     * @param addonId 插件id
     * @param extraData 插件扩展字段
     * @returns 打印模式
     */
    DocAddonBridge.getPrintMode = function (addonId, extraData) {
        return getPrintMode(addonId, extraData);
    };
    /**
     * 获取第三方内容插件的链接类型
     * @param addonId 插件id
     * @param extraData 插件扩展字段
     * @returns 链接类型
     */
    DocAddonBridge.getLinkType = function (addonId, extraData) {
        return getLinkType(addonId, extraData);
    };
    /**
     * 通过ocr识别结果拉取公式插件
     * @param res：识别结果
     * @returns 结果回调
     */
    DocAddonBridge.invokeFormulaAddonWithLaTexOCR = function (res) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, invokeFormulaAddonWithLaTexOCR(res)];
            });
        });
    };
    /**
     * 将context解析为插件
     * @param context: 需要识别的内容
     * @returns 若可以识别，返回插件化后的结果，否则返回null
     */
    DocAddonBridge.parseAsAddon = function (context) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, AddonManager$1.getInstance().parseAsAddon(context)];
            });
        });
    };
    /**
     * 根据插件信息获取iconPath
     * @param url: 插件链接, addonId: 插件id
     * @returns 若可以识别，返回插件化后的结果，否则返回null
     */
    DocAddonBridge.getIconOfAddonLink = function (url, addonId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, AddonManager$1.getInstance().getIconOfAddonLink(url, addonId)];
            });
        });
    };
    /**
     * 获取官方插件菜单栏黑白icon
     * @param addonId: 插件id
     * @returns
     */
    DocAddonBridge.getOfficialAddonIcon = function (addonId) {
        return AddonManager$1.getInstance().getOfficialAddonIcon(addonId);
    };
    /**
     * 获取官方插件类型
     * @param addonId: 插件 id
     * @returns
     */
    DocAddonBridge.getOfficialAddonType = function (addonId) {
        return getOfficialAddonType(addonId);
    };
    /**
     * 向插件发送事件
     * @param anchorId 插件容器在文档侧的锚点 id，是该容器的唯一标识
     * @param target 事件的发送目标
     * @param eventName 事件名称
     * @param data 额外数据
     */
    DocAddonBridge.dispatchEventToAddon = function (anchorId, target, eventName, data) {
        if (data === void 0) { data = {}; }
        switch (target) {
            case AddonEventTarget.HINA: {
                // 将 anchorId 和 eventName 组合在一起，让对应的子应用监听到事件
                var event_1 = new CustomEvent("".concat(anchorId, "-").concat(eventName), { detail: { data: data } });
                window.dispatchEvent(event_1);
                break;
            }
        }
    };
    /**
     * 获取 addon handler, 提供给 hina 容器使用
     * @returns
     */
    DocAddonBridge.getAddonHandler = function () {
        return {
            openAddon: function (_a) {
                var addonId = _a.addonId, action = _a.action, env = _a.env;
                var envAddonId = getEnvAddonId(addonId, env);
                return executeActionWithAuth(envAddonId, action);
            },
        };
    };
    /**
     * 获取 iframe 在小程序中的渲染白名单
     *
     * @return 白名单
     */
    DocAddonBridge.getMiniAppIframeWhiteList = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, AddonManager$1.getInstance().getMiniAppIframeWhiteList()];
            });
        });
    };
    /**
     * 协同编辑下，生成唯一 clientId
     *
     * @return clientId
     */
    DocAddonBridge.getAddonClientId = function () {
        return AddonManager$1.getInstance().getAddonClientId();
    };
    /**
     * 通过专题 ID 获取插件信息
     */
    DocAddonBridge.getMallAddonByTopicId = function (topicId) {
        return AddonManager$1.getInstance().getMallAddonByTopicId(topicId);
    };
    /**
     * 以全屏的形式打开插件，会忽略插件自己定义的 Action，强制全屏打开
     * @param addonId addonId
     */
    DocAddonBridge.openAddonFullScreen = function (addonId) {
        return __awaiter(this, void 0, void 0, function () {
            var action;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, addonAuthorized(addonId)];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, DocAddonBridge.fetchAddonMenu(addonId)];
                    case 2:
                        action = (_a.sent());
                        executeActionWithAuth(addonId, {
                            name: 'openDialog',
                            options: __assign(__assign({}, action.options), { fullscreen: true }),
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    DocAddonBridge.isDevMode = function () {
        return AddonDevManager.getSingletonInstance().isDevMode();
    };
    // 是否初始化完成
    DocAddonBridge.initialized = false;
    // setup 完成后执行的 callback 列表
    DocAddonBridge.setupCallbacks = [];
    /**
     * 打开插件，未安装时会打开商城详情页
     *  addonId 插件 id
     *  marketId 商城 id，传了才能打开商城详情页
     *  @return Promise<void>
     */
    DocAddonBridge.openAddon = openAddon;
    return DocAddonBridge;
}());

function getDriveAddonList() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, request.get(DRIVE_CGI.GET_DRIVE_LIST)];
                case 1: return [2 /*return*/, (_a.sent()).data.addons];
            }
        });
    });
}

/**
 * 管理插件授权
 */
var DriveAuthManager = /** @class */ (function () {
    function DriveAuthManager() {
        var _this = this;
        // 管理所有回调
        this.callbackMap = new Map();
        this.isHandlerRemoved = true;
        /**
         * 免授权的插件不需要授权回调，直接跳转到第三方插件
         * @param authOption 授权字段
         * @param callbacks 回调函数集
         * @param needAuthorize 是否需要授权
         * @param openOptions 同 window.open 的参数
         */
        this.handleDriveAuth = function (_a, openOptions) {
            var _b;
            var authOption = _a.authOption, callbacks = _a.callbacks, needAuthorize = _a.needAuthorize;
            var target = (_b = openOptions === null || openOptions === void 0 ? void 0 : openOptions.target) !== null && _b !== void 0 ? _b : '_blank';
            var feature = openOptions === null || openOptions === void 0 ? void 0 : openOptions.feature;
            var callbackId = generateIdWithTimestamp(AUTH_RANDOM_LEN);
            var authParams = __assign(__assign({}, authOption), { state: encodeURIComponent(JSON.stringify(authOption.state)) });
            if (needAuthorize) {
                // 需要授权的 state 中需要增加 callbackId, 授权成功后执行对应的回调
                var newState = __assign(__assign({}, authOption.state), { callbackId: callbackId });
                authParams.state = encodeURIComponent(JSON.stringify(newState));
            }
            var authURL = concatAuthURI(authParams);
            tencentDocOpenUrlForAll({ url: "".concat(location.origin).concat(authURL), windowName: target, windowFeatures: feature });
            if (needAuthorize) {
                _this.callbackMap.set(callbackId, callbacks);
                if (_this.isHandlerRemoved) {
                    _this.isHandlerRemoved = false;
                    window.addEventListener('message', _this.handleAuthResult);
                }
            }
        };
        // 处理授权结果
        this.handleAuthResult = function (event) {
            var isMessageValid = function (event) { var _a, _b; return event.origin === DEFAULT_OAUTH_ORIGIN && ((_a = event.data) === null || _a === void 0 ? void 0 : _a.data) && ((_b = event.data) === null || _b === void 0 ? void 0 : _b.code) !== undefined; };
            if (!isMessageValid(event)) {
                return;
            }
            var _a = event.data, code = _a.code, _b = _a.data, state = _b.state, msg = _b.msg;
            var stateObj = JSON.parse(decodeURIComponent(state));
            var callbackId = stateObj.callbackId;
            if (!callbackId) {
                return;
            }
            if (!_this.callbackMap.has(callbackId)) {
                return;
            }
            var _c = _this.callbackMap.get(callbackId), successCallback = _c.successCallback, failCallback = _c.failCallback;
            if (code === AddonErrorCode.SUCCESS) {
                successCallback === null || successCallback === void 0 ? void 0 : successCallback();
            }
            else {
                failCallback === null || failCallback === void 0 ? void 0 : failCallback({ code: code, msg: msg });
            }
            _this.callbackMap.delete(callbackId);
            // 处理完成后，如果callbackMap为空，则解绑listener
            _this.clearEventListener(_this.callbackMap.size === 0);
        };
        // 解绑message listener
        this.clearEventListener = function (condition) {
            if (condition === void 0) { condition = false; }
            if (condition) {
                _this.isHandlerRemoved = true;
                window.removeEventListener('message', _this.handleAuthResult);
            }
        };
    }
    return DriveAuthManager;
}());

var DriveAddonManager = /** @class */ (function () {
    function DriveAddonManager() {
        this.installedAddonMap = new Map();
        // 未安装，但查询到的addon map
        this.queryAddonCache = new Map();
        this.driveAuthManager = new DriveAuthManager();
    }
    /**
     * 获取用户已安装的插件，多次调用只会发起一个请求，
     * @param force 清除缓存，重新拉取一次列表
     * @return addonId -> DriveAddon 的键值对
     */
    DriveAddonManager.prototype.loadInstalledAddons = function (force) {
        if (force === void 0) { force = false; }
        return __awaiter(this, void 0, void 0, function () {
            var driveList;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (force) {
                            this.clearCache();
                        }
                        return [4 /*yield*/, this.cacheLoadPromise()];
                    case 1:
                        driveList = _a.sent();
                        driveList.forEach(function (item) {
                            _this.installedAddonMap.set(item.addonId, item);
                        });
                        return [2 /*return*/, driveList];
                }
            });
        });
    };
    /**
     * 打开Drive插件所创建的文件
     * @param addonInfo 插件id or Item
     * @param responseType 授权方式，对应OAuth
     * @param callbacks
     */
    DriveAddonManager.prototype.openAddonFile = function (addonInfo, responseType, callbacks) {
        if (responseType === void 0) { responseType = 'code'; }
        this.handleAuth(addonInfo, AUTH_ACTION.OPEN, callbacks, responseType);
    };
    /**
     * 新建Drive插件类型文件
     * @param addonInfo 插件id or Item
     * @param responseType 授权方式，对应OAuth
     * @param callbacks
     */
    DriveAddonManager.prototype.createAddonFile = function (addonInfo, responseType, callbacks) {
        if (responseType === void 0) { responseType = 'code'; }
        this.handleAuth(addonInfo, AUTH_ACTION.CREATE, callbacks, responseType);
    };
    /**
     * 只通过 addonId 创建 drive 插件文件
     * @param addonId 插件 ID
     * @param folderId 文件夹 ID,默认值 /
     */
    DriveAddonManager.prototype.createAddonFileByAddonId = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var addonId, _a, folderId, driveAddons, curAddon;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        addonId = options.addonId, _a = options.folderId, folderId = _a === void 0 ? '/' : _a;
                        return [4 /*yield*/, this.loadInstalledAddons(true)];
                    case 1:
                        driveAddons = _b.sent();
                        curAddon = driveAddons.find(function (addon) { return addon.addonId === addonId; });
                        if (!curAddon) {
                            throw new Error('找不到已安装 drive 插件信息');
                        }
                        this.createAddonFile(__assign(__assign({}, curAddon), { folderId: folderId }));
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * 返回已安装的插件列表的插件信息，插件不存在则返回undefined
     * @param addonId 插件id
     */
    DriveAddonManager.prototype.getInstalledAddon = function (addonId) {
        return this.installedAddonMap.get(addonId);
    };
    /**
     * 返回插件，查询逻辑：已安装列表 -> 请求缓存 -> 发起接口查询，查询多个插件也只会出现至多1次查询
     * @param addonIds
     */
    DriveAddonManager.prototype.loadAddons = function (addonIds) {
        return __awaiter(this, void 0, void 0, function () {
            var uninstalledAddonIds, collectedAddons, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        uninstalledAddonIds = [];
                        collectedAddons = [];
                        addonIds.forEach(function (addonId) {
                            var _a;
                            var addon = (_a = _this.installedAddonMap.get(addonId)) !== null && _a !== void 0 ? _a : _this.queryAddonCache.get(addonId);
                            if (addon) {
                                collectedAddons.push(addon);
                            }
                            else {
                                uninstalledAddonIds.push(addonId);
                            }
                        });
                        if (uninstalledAddonIds.length === 0) {
                            return [2 /*return*/, collectedAddons];
                        }
                        _a = [[]];
                        return [4 /*yield*/, this.getUninstalledAddon(uninstalledAddonIds)];
                    case 1: return [2 /*return*/, __spreadArray.apply(void 0, [__spreadArray.apply(void 0, _a.concat([__read.apply(void 0, [(_b.sent())]), false])), __read(collectedAddons), false])];
                }
            });
        });
    };
    /**
     * 查询未安装的插件，如果缓存中没有则发起axios请求并返回drive插件信息，
     * @param addonIds
     * @throws 如果传入的插件id的插件类型不是Drive插件，抛出异常
     */
    DriveAddonManager.prototype.getUninstalledAddon = function (addonIds) {
        return __awaiter(this, void 0, void 0, function () {
            var addons;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getAddons(addonIds)];
                    case 1:
                        addons = (_a.sent()).addons;
                        return [2 /*return*/, addons.map(function (item) {
                                var driveInfo = item.driveInfo, basicInfo = item.basicInfo, rest = __rest(item, ["driveInfo", "basicInfo"]);
                                if (basicInfo.types.some(function (type) { return type === ADDON_TYPE.DRIVE; })) {
                                    // 类型为drive情况下，必然有driveInfo字段
                                    var addonInfo = __assign(__assign(__assign({}, basicInfo), driveInfo), rest);
                                    // 设置缓存
                                    if (rest.installed) {
                                        _this.installedAddonMap.set(basicInfo.addonId, addonInfo);
                                    }
                                    else {
                                        _this.queryAddonCache.set(basicInfo.addonId, addonInfo);
                                    }
                                    return addonInfo;
                                }
                                throw new Error('错误的 Drive 插件Id');
                            })];
                }
            });
        });
    };
    DriveAddonManager.prototype.handleAuth = function (addonInfo, action, callbacks, responseType) {
        var _a, _b;
        var _this = this;
        if (responseType === void 0) { responseType = 'code'; }
        var addonId = addonInfo.addonId, createPath = addonInfo.createPath, openPath = addonInfo.openPath, needAuthorize = addonInfo.needAuthorize;
        var redirectURI = action === AUTH_ACTION.CREATE ? createPath : openPath;
        var authCGI = needAuthorize ? DRIVE_CGI.AUTHORIZE : DRIVE_CGI.DIRECT_AUTHORIZE;
        var withDefaultCallbacks = __assign(__assign({}, callbacks), { successCallback: function () {
                var _a;
                _this.loadInstalledAddons.call(_this, true);
                (_a = callbacks === null || callbacks === void 0 ? void 0 : callbacks.successCallback) === null || _a === void 0 ? void 0 : _a.call(callbacks);
            } });
        var actionParamKey = (_a = {},
            _a[AUTH_ACTION.CREATE] = 'folderId',
            _a[AUTH_ACTION.OPEN] = 'fileId',
            _a)[action];
        var state = (_b = {
                action: action
            },
            _b[actionParamKey] = addonInfo[actionParamKey],
            _b);
        this.driveAuthManager.handleDriveAuth({
            authOption: {
                cgi: authCGI,
                addonId: addonId,
                responseType: responseType,
                redirectURI: redirectURI,
                state: state,
            },
            callbacks: withDefaultCallbacks,
            needAuthorize: needAuthorize,
        });
    };
    DriveAddonManager.prototype.cacheLoadPromise = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (!this.loadPromise) {
                    this.loadPromise = getDriveAddonList();
                }
                return [2 /*return*/, this.loadPromise];
            });
        });
    };
    DriveAddonManager.prototype.clearCache = function () {
        this.loadPromise = null;
        this.installedAddonMap.clear();
        this.queryAddonCache.clear();
    };
    return DriveAddonManager;
}());

var MallManager = /** @class */ (function () {
    function MallManager() {
    }
    /**
     * 安装插件
     * @param addonId 安装的插件ID
     */
    MallManager.prototype.installAddon = function (addonId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve, reject) {
                        var successCb = resolve;
                        var failCb = function () {
                            reject('操作失败，请稍后重试');
                        };
                        AddonAuthManager.getInstance().handleAddonAuth(addonId, successCb, failCb);
                    })];
            });
        });
    };
    /**
     * 卸载插件，需要异步请求
     * @param addonId 插件ID
     */
    MallManager.prototype.deleteAddon = function (addonId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, uninstallAddon(addonId)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        _a.sent();
                        throw new Error('操作失败，请稍后重试');
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    return MallManager;
}());

export { $t as $, ADDON_TYPE as A, DocAddonBridge as D, FORMULA_ADDON_ID as F, Languages as L, MenuConfigurationType as M, OfficialAddonType as O, PrintMode as P, REPORT_VALID_LIST as R, SIGN_ADDON_ID as S, getHelpLineNormal as a, AddonManager$1 as b, DocHook as c, DocElementType as d, AddonScenes as e, AddonListChannel as f, getLanguageByI18n as g, AddonWindowType as h, LinkType as i, AUTH_ACTION as j, LINK_ADDON_ID as k, AddonEventTarget as l, DriveAddonManager as m, MallManager as n, AddonMallPageType as o, SDKUnofficialAddonToolbarKey as p, styleInject as s };
//# sourceMappingURL=index-eab1fc93.js.map
